/* eslint-disable */
const i18n = {
  "zh-CN": {
    "marketing.new_pricing.full_plan": "\u5B8C\u6574\u8BA1\u5212\u6BD4\u8F83",
    "one.meetingFeature": "会议功能",
    "one.phoneFeature": "电话功能",
    "phoneAdminFeatures": "Phone Admin Features",
    "common.basic": "\u514D\u8D39",
    "one.lite": "基础加强版",
    "common.pro": "\u4E13\u4E1A",
    "common.business": "\u5546\u4E1A",
    "one.bizPlus": "商业加强版",
    "common.enterprise": "\u4F01\u4E1A",
    "meetings.fullPlanItem1": "\u53C2\u4F1A\u8005\u5BB9\u91CF",
    "meetings.fullPlanItem1Tip": "\u53C2\u4F1A\u8005\u662F\u7531\u6301\u4F1A\u8BAE\u8BB8\u53EF\u8BC1\u7684\u4EBA\u5B89\u6392\u7684\u4F1A\u8BAE\u7684\u53D7\u9080\u4EBA\u3002\u53C2\u4F1A\u8005\u53EF\u4EE5\u4ECE\u624B\u673A\u3001\u53F0\u5F0F\u673A\u3001\u79FB\u52A8\u8BBE\u5907\u548C\u5E73\u677F\u7535\u8111\u514D\u8D39\u52A0\u5165\u4F1A\u8BAE\u3002\u53C2\u4F1A\u8005\u4E0D\u9700\u8981\u6709 Zoom \u8D26\u6237\u5373\u53EF\u52A0\u5165\u4F1A\u8BAE\u3002\u6BCF\u4E2A\u8BA1\u5212\u7684\u53C2\u4F1A\u8005\u4EBA\u6570\u90FD\u6709\u9650\u5236\uFF0C\u4F46\u662F\u7528\u6237\u53EF\u4EE5\u901A\u8FC7\u8D2D\u4E70\u9644\u52A0\u7EC4\u4EF6\u6765\u63D0\u9AD8\u4ED8\u8D39\u8BA1\u5212\u7684\u4EBA\u6570\u4E0A\u9650\u3002",
    "meetings.fullPlanItem1_ent": "500<br><span class=\"cell-desc\">*1,000（适用于企业加强版）</span>",
    "meetings.fullPlanItem2": "\u8BB8\u53EF\u8BC1\u6570",
    "meetings.fullPlanItem2Tip": "\u60A8\u53EF\u4EE5\u5728\u8D26\u6237\u4E2D\u6DFB\u52A0\u4EFB\u610F\u6570\u91CF\u7684\u57FA\u7840\u7528\u6237\uFF0C\u4F46\u6BCF\u4E2A\u8BA1\u5212\u5BF9\u53EF\u5206\u914D\u4F1A\u8BAE\u8BB8\u53EF\u8BC1\u7684\u7528\u6237\u6570\u91CF\u90FD\u6709\u7279\u5B9A\u9650\u5236\u3002",
    "meetings.fullPlanItem6": "\u6280\u672F\u652F\u6301",
    "meetings.fullPlanItem6Tip": "Premier support packages available to help minimize risk and reduce downtime.",
    "meetings.fullPlanItem6_basic": "\u51ED\u7968\u5165\u573A",
    "meetings.fullPlanItem6_pro": "\u7968\u8BC1\u4E0E\u5B9E\u65F6\u804A\u5929",
    "meetings.fullPlanItem6_biz": "\u7968\u8BC1\u3001\u5B9E\u65F6\u804A\u5929\u4E0E\u7535\u8BDD",
    "meetings.fullPlanItem6_ent": "\u7968\u8BC1\u3001\u5B9E\u65F6\u804A\u5929\u4E0E\u7535\u8BDD",
    "meetings.fullPlanItem3": "\u8BA1\u8D39\u5468\u671F\u548C\u6761\u6B3E",
    "meetings.fullPlanItem3_basic": "免费",
    "meetings.fullPlanItem3_pro": "\u6BCF\u6708\u6216\u6BCF\u5E74",
    "meetings.fullPlanItem3_biz": "\u6BCF\u6708\u6216\u6BCF\u5E74<span class cell-desc>*\u53EF\u4EE5\u901A\u8FC7<a tabindex=\"-1\" href=\"https://zoom.us/zh-cn/contactsales.html\">\u9500\u552E\u4EBA\u5458</a></span>\u83B7\u5F97\u591A\u5E74\u5408\u540C",
    "meetings.fullPlanItem3_ent": "\u4EC5\u5E74\u5EA6\u534F\u8BAE<span class cell-desc>*\u53EF\u4EE5\u5168\u989D\u6216\u6309\u6708\u652F\u4ED8</span>",
    "meetings.fullPlanItem4": "\u65E0\u9650\u5236\u4F1A\u8BAE",
    "meetings.fullPlanItem5": "\u4F1A\u8BAE\u6301\u7EED\u65F6\u95F4",
    "meetings.fullPlanItem5Tip": "\u6BCF\u6B21\u7FA4\u7EC4\u4F1A\u8BAE\uFF08\u4E0D\u5C11\u4E8E 3 \u540D\u53C2\u4F1A\u8005\uFF09\u5141\u8BB8\u7684\u6700\u957F\u6301\u7EED\u65F6\u95F4\u3002",
    "meetings.fullPlanItem5_basic": "40 \u5206\u949F",
    "one.basicPlusFullPlanItem1": "60 mins",
    "meetings.fullPlanItem5_pro": "30 \u5C0F\u65F6",
    "meetings.fullPlanItem5_biz": "30 \u5C0F\u65F6",
    "meetings.fullPlanItem5_ent": "30 \u5C0F\u65F6",
    "meetings.fullPlanItem7": "\u5F55\u5236",
    "meetings.fullPlanItem7Tip": "Zoom \u672C\u5730\u5F55\u5236\u53EF\u4EE5\u5C06\u4F1A\u8BAE\u8BB0\u5F55\u4FDD\u5B58\u4E3A MP4\uFF08\u89C6\u9891\uFF09\u3001M4A\uFF08\u97F3\u9891\uFF09\u548C txt\uFF08\u804A\u5929\uFF09\u683C\u5F0F\u3002<br>Zoom \u4E91\u5F55\u5236\u53EF\u4EE5\u5C06\u4F1A\u8BAE\u5B58\u50A8\u5728 Zoom \u4E91\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u6D4F\u89C8\u5668\u4E0B\u8F7D\u548C/\u6216\u4F20\u8F93\u5176\u4E2D\u7684\u6587\u4EF6\u3002",
    "meetings.fullPlanItem7_basic": "\u672C\u5730\u5F55\u5236",
    "meetings.fullPlanItem7_pro": "\u672C\u5730\u5F55\u5236\u53CA 5 GB \u4E91\u5B58\u50A8\uFF08\u6BCF\u4E2A\u8BB8\u53EF\u8BC1\uFF09",
    "meetings.fullPlanItem7_biz": "\u672C\u5730\u5F55\u5236\u53CA 10 GB \u4E91\u5B58\u50A8\uFF08\u6BCF\u4E2A\u8BB8\u53EF\u8BC1\uFF09",
    "meetings.fullPlanItem7_ent": "\u672C\u5730\u5F55\u5236\u53CA\u65E0\u9650\u4E91\u5B58\u50A8",
    "meetings.fullPlanItem9": "\u7535\u8BDD\u62E8\u5165",
    "meetings.fullPlanItem9Tip": "\u901A\u8FC7\u7535\u8BDD\u4F1A\u8BAE/\u97F3\u9891\u4F1A\u8BAE\uFF08\u4F7F\u7528\u4F20\u7EDF\u7535\u8BDD\uFF09\u52A0\u5165Zoom\u4F1A\u8BAE\u3002\u6211\u4EEC\u5C06\u6309\u7167\u7528\u6237\u7684\u901A\u8BDD\u5957\u9910\u5411\u7528\u6237\u6536\u53D6\u8D39\u7528\u3002\u8BD5\u7528\u6211\u4EEC\u7684\u97F3\u9891\u4F1A\u8BAE\u9644\u52A0\u5957\u9910\u4EE5\u83B7\u53D6\u88AB\u53EB\u4ED8\u8D39\u62E8\u5165\u53F7\u7801\u3002",
    "meetings.fullPlanItem9_pro": "\u6536\u8D39",
    "meetings.fullPlanItem9_biz": "\u6536\u8D39",
    "meetings.fullPlanItem9_ent": "\u6536\u8D39",
    "meetings.fullPlanItem_EssentialApp": "基本应用",
    "common.learnMore": "\u4E86\u89E3\u66F4\u591A",
    "meetings.fullPlanItem_EssentialAppText": "免费使用付费应用 1 年（需遵守条款）",
    "meetings.fullPlanItem11": "\u5C4F\u5E55\u5171\u4EAB",
    "meetings.fullPlanItem11Tip": "\u684C\u9762\u548C\u5E94\u7528\u5171\u4EAB\u3002\u6388\u6743\u4F1A\u8BAE\u7528\u6237\u53EF\u4EE5\u9009\u62E9\u5141\u8BB8\u591A\u540D\u53C2\u4F1A\u8005\u5728\u4ED6\u4EEC\u4E3B\u6301\u7684\u4F1A\u8BAE\u671F\u95F4\u540C\u65F6\u5171\u4EAB\u5C4F\u5E55\u3002",
    "meetings.fullPlanItem12": "\u5206\u7EC4\u4F1A\u8BAE\u5BA4",
    "meetings.fullPlanItem12Tip": "\u60A8\u53EF\u4EE5\u901A\u8FC7\u89C6\u9891\u5206\u7EC4\u4F1A\u8BAE\u5BA4\u5C06 Zoom \u4F1A\u8BAE\u5206\u6210\u6700\u591A 50 \u4E2A\u5355\u72EC\u7684\u4F1A\u8BAE\uFF0C\u5206\u522B\u8FDB\u884C\u8BA8\u8BBA\u3001\u4E13\u9898\u7814\u7A76\u7B49\u3002",
    "meetings.fullPlanItem14": "\u865A\u62DF\u80CC\u666F",
    "meetings.fullPlanItem15": "\u4E2A\u4EBA\u4F1A\u8BAE\u53F7",
    "meetings.fullPlanItem15Tip": "\u521B\u5EFA\u60A8\u81EA\u5DF1\u7684\u6C38\u4E45\u5728\u7EBF\u4F1A\u8BAE\u5BA4\u3002\u60A8\u53EF\u4EE5\u968F\u65F6\u5F00\u59CB\u4F1A\u8BAE\uFF0C\u6216\u5B89\u6392\u5C06\u6765\u6240\u9700\u7684\u4F1A\u8BAE\u3002",
    "one.messaging": "发送消息",
    "one.new": "全新",
    "meetings.fullPlanItem16Tip": "\u60A8\u53EF\u4EE5\u901A\u8FC7 Chat \u8F7B\u677E\u53D1\u9001\u7FA4\u804A\u4FE1\u606F\u3001\u6587\u4EF6\u3001\u5C4F\u5E55\u622A\u56FE\u3001\u4EE3\u7801\u7247\u6BB5\u3001\u8BED\u97F3\u6D88\u606F\u548C\u56FE\u7247\u3002 \u53EF\u89C4\u5B9A\u6587\u672C\u683C\u5F0F\uFF0C\u7528\u6237\u8FD8\u53EF\u5171\u4EAB GIF \u548C\u8868\u60C5\u3002 \u5728\u7EBF\u72B6\u6001\u663E\u793A\u804A\u5929\u53C2\u4E0E\u8005\u4F7F\u7528\u7684\u662F\u7535\u8111\u3001\u79FB\u52A8\u8BBE\u5907\uFF0C\u8FD8\u662F\u5904\u4E8E\u5FD9\u788C\u72B6\u6001\u3002",
    "meetings.fullPlanItem17": "\u4E3B\u6301\u4EBA\u63A7\u4EF6",
    "meetings.fullPlanItem18": "\u5728\u5171\u4EAB\u5C4F\u5E55\u4E0A\u8FDB\u884C\u5171\u540C\u6CE8\u91CA",
    "meetings.fullPlanItem19": "\u8FDC\u7A0B\u952E\u76D8\u548C\u9F20\u6807\u63A7\u5236",
    "meetings.fullPlanItem21": "\u591A\u65B9\u5171\u4EAB",
    "endToEndEncryptionForZoomMeetings": "Zoom Meetings 的端到端加密功能",
    "whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings": "启用 Zoom Meetings 的端到端加密 (E2EE) 功能即表示，特定会议中使用 Zoom 客户端的所有会议参会者之间的通信将使用仅限参会者设备已知的加密密钥进行加密。 这意味着，任何第三方（包括 Zoom）都无法获得会议的私钥。",
    "enterpriseGradeSecurityFeatures": "企业级安全功能",
    "256BitAesGcmEncryptionForRealTime": "适用于传输中实时内容的 256 位 AES-GCM 加密，以及高级聊天加密、密码、等候室、锁定会议、音频签名、屏幕共享水印、双重身份验证等。",
    "meetings.fullPlanItem29": "\u7B49\u5019\u5BA4",
    "meetings.fullPlanItem29Tip": "\u7B49\u5019\u5BA4\u529F\u80FD\u5141\u8BB8\u4E3B\u6301\u4EBA\u63A7\u5236\u53C2\u4F1A\u8005\u52A0\u5165\u4F1A\u8BAE\u7684\u65F6\u95F4\u3002 \u4F5C\u4E3A\u4F1A\u8BAE\u4E3B\u6301\u4EBA\uFF0C\u60A8\u53EF\u4EE5\u9010\u4E00\u51C6\u8BB8\u53C2\u4F1A\u8005\u6216\u4E00\u6B21\u6027\u51C6\u8BB8\u6240\u6709\u53C2\u4F1A\u8005\u3002 \u5728\u8BBE\u7F6E\u4E2D\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u5C06\u54EA\u4E9B\u4EBA\u7F6E\u5165\u7B49\u5019\u5BA4\u3001\u54EA\u4E9B\u4EBA\u81EA\u52A8\u83B7\u5F97\u51C6\u8BB8\u3002 \u6240\u6709\u8D26\u6237\u90FD\u6709\u7B49\u5019\u5BA4\u529F\u80FD\u3002 \u4E3B\u6301\u4EBA\u53EF\u4EE5\u5411\u7B49\u5019\u5BA4\u53D1\u9001\u6D88\u606F\u3002 \u5982\u679C\u4F7F\u7528\u7684\u662F\u4ED8\u8D39\u5957\u9910\uFF0C\u5219\u53EF\u4EE5\u81EA\u5B9A\u4E49\u7B49\u5019\u5BA4\u3002",
    "meetings.fullPlanItem41": "Zoom for Home \u8BBE\u5907\u5185\u7F6E",
    "meetings.fullPlanItem61": "\u56FA\u5B9A\u591A\u4EBA",
    "meetings.fullPlanItem61Tip": "\u4E3B\u6301\u4EBA\u6700\u591A\u53EF\u6388\u4E88 9 \u4EBA\u56FA\u5B9A\u89C6\u9891\u4EE5\u521B\u5EFA\u81EA\u5B9A\u4E49\u89C6\u56FE\u7684\u6743\u9650\u3002 \u8FD9\u6837\u65E0\u8BBA\u53D1\u8A00\u4EBA\u662F\u8C01\uFF0C\u56FA\u5B9A\u89C6\u9891\u5C06\u4FDD\u6301\u53EF\u89C1\u3002",
    "meetings.fullPlanItem62": "\u805A\u7126\u591A\u4EBA",
    "meetings.fullPlanItem62Tip": "\u4E3B\u6301\u4EBA\u6700\u591A\u53EF\u805A\u7126 9 \u540D\u89C2\u4F17\u7684\u89C6\u9891\uFF0C\u8FD9\u6837\u65E0\u8BBA\u53D1\u8A00\u4EBA\u662F\u8C01\uFF0C\u5168\u4F53\u53C2\u4F1A\u8005\u90FD\u80FD\u770B\u5230\u805A\u96C6\u4EBA\u5458\u7684\u89C6\u9891\u3002",
    "meetings.fullPlanNewItem1": "\u6EE4\u955C",
    "meetings.fullPlanNewItem1Tip": "\u4F7F\u7528\u6709\u8DA3\u7684\u5F69\u8272\u6EE4\u955C\u6216\u88C5\u9970\u6027\u52A8\u7269\u8D34\u7EB8\uFF0C\u4E3A\u6B22\u4E50\u65F6\u523B\u3001\u805A\u4F1A\u7B49\u573A\u5408\u589E\u6DFB\u4E50\u8DA3\u3002",
    "meetings.fullPlanNewItem2": "\u6295\u7968",
    "meetings.fullPlanNewItem3": "\u8054\u5E2D\u4E3B\u6301\u4EBA\u548C\u5907\u9009\u4E3B\u6301\u4EBA",
    "meetings.fullPlanNewItem3Tip": "<a href=\"https://support.zoom.us/hc/zh-cn/articles/201362603-Host-and-co-host-controls-in-a-meeting\" target=\"_blank\">\u4E86\u89E3\u66F4\u591A</a>\u5173\u4E8E\u6211\u4EEC\u7684\u4F1A\u8BAE\u8054\u5E2D\u4E3B\u6301\u4EBA\u63A7\u4EF6\u7684\u4FE1\u606F\u3002",
    "meetings.fullPlanItem24": "\u5206\u914D\u4F1A\u8BAE\u5B89\u6392\u8005",
    "meetings.fullPlanItem24Tip": "\u60A8\u53EF\u4EE5\u5206\u914D\u5176\u4ED6\u4EBA\u5458\u4E3A\u60A8\u8BBE\u7F6E\u4F1A\u8BAE\u3002\u53D7\u6258\u4EBA\u5FC5\u987B\u62E5\u6709\u4E13\u4E1A\u7248\u8BA1\u5212\u3002",
    "meetings.fullPlanItem25": "REST API",
    "meetings.fullPlanItem25Tip": "\u4F7F\u8D26\u6237\u6240\u6709\u8005\u3001\u7BA1\u7406\u5458\u548C\u60A8\u7684\u5F00\u53D1\u4EBA\u5458\u80FD\u591F\u5B89\u5168\u8BBF\u95EE Zoom REST API\u3002\u6839\u636E\u8D26\u6237\u7C7B\u578B\uFF08\u4E13\u4E1A\u7248\u3001\u5546\u4E1A\u7248\u3001\u4F01\u4E1A\u7248\u7B49\uFF09\u548C API \u8BF7\u6C42\u7C7B\u578B\uFF08\u8F7B\u578B\u3001\u4E2D\u578B\u3001\u91CD\u578B\u7B49\uFF09\uFF0C\u4E0D\u540C\u8D26\u6237\u7EA7\u522B\u9002\u7528\u4E0D\u540C\u7684 API \u901F\u7387\u9650\u5236\u3002\u90E8\u5206 API \u53EA\u5BF9\u7279\u5B9A\u8D26\u6237\u7C7B\u578B\u6709\u8BBF\u95EE\u9650\u5236\u3002\u4F7F\u7528 API \u901F\u7387\u9650\u5236\u548C API \u53C2\u8003\u6587\u6863\u4E86\u89E3\u5B8C\u6574\u4FE1\u606F\u3002",
    "meetings.fullPlanItem25_pro": "REST API \u4E13\u4E1A\u7248\u901F\u7387\u9650\u5236",
    "meetings.fullPlanItem25_biz": "REST API \u901F\u7387\u9650\u5236",
    "meetings.fullPlanItem26": "Skype for Business (Lync) \u4E92\u64CD\u4F5C\u6027",
    "meetings.fullPlanItem26Tip": "Lync 2010 \u548C 2013 \u7528\u6237\u4EE5\u53CA Skype for Business \u7528\u6237\u53EF\u4EE5\u901A\u8FC7 Lync \u8054\u7CFB\u4EBA\u5217\u8868\u53D1\u8D77 Zoom \u4F1A\u8BAE\u3002",
    "meetings.fullPlanItem27": "\u76F4\u64AD",
    "meetings.fullPlanItem27Tip": "\u5411 Facebook\u3001Youtube \u6216\u7B2C\u4E09\u65B9\u670D\u52A1\u76F4\u64AD\u3002",
    "meetings.fullPlanItem28": "\u62A5\u544A",
    "meetings.fullPlanItem28Tip": "\u4FDD\u5B58\u767D\u677F\u4F1A\u8BDD",
    "meetings.fullPlanItem30": "\u7528\u6237\u7BA1\u7406",
    "meetings.fullPlanItem30Tip": "\u6240\u6709\u8005\u548C\u7BA1\u7406\u5458\u53EF\u4EE5\u6DFB\u52A0\u3001\u5220\u9664\u548C\u5206\u914D\u89D2\u8272\u4E0E\u9644\u4EF6\u529F\u80FD\u3002",
    "one.autoCaptions": "自动字幕",
    "one.englishOnly": "仅限英语",
    "meetings.fullPlanItem31": "\u7BA1\u7406\u5458\u95E8\u6237",
    "meetings.fullPlanItem31Tip": "\u901A\u8FC7Zoom\u7BA1\u7406\u5458\u95E8\u6237\u4F7F\u7528\u4E00\u4E2A\u8D26\u6237\u7BA1\u7406\u516C\u53F8\u7684\u6240\u6709\u7528\u6237\uFF0C\u4EE5\u7B80\u5316\u8BA1\u8D39\u65B9\u5F0F\u3001\u5B9E\u73B0\u9AD8\u7EA7\u7528\u6237\u7BA1\u7406\u8BBE\u7F6E\u5E76\u5BF9\u4F7F\u7528\u60C5\u51B5\u8FDB\u884C\u5168\u9762\u5206\u6790\u3002",
    "meetings.fullPlanItem32": "LTI \u96C6\u6210",
    "meetings.fullPlanItem32Tip": "\u901A\u8FC7\u5B66\u4E60\u7BA1\u7406\u7CFB\u7EDF\uFF08\u642D\u914D Moodle\u3001Canvas\u3001Desire2Learn \u548C Blackboard \u4F7F\u7528\uFF09\uFF0C\u8F7B\u677E\u5C06\u4F1A\u8BAE\u6DFB\u52A0\u81F3\u4EFB\u4F55\u8BFE\u7A0B\u6D3B\u52A8\u5E76\u9080\u8BF7\u9002\u5408\u7684\u5B66\u751F\u3002",
    "meetings.fullPlanItem33": "\u4E91\u5F55\u5236\u6284\u672C",
    "meetings.fullPlanItem33Tip": "\u4E91\u5F55\u5236\u6284\u672C\u662F\u60A8\u5F55\u5236\u5230\u4E91\u7AEF\u7684\u4F1A\u8BAE\u6216\u7F51\u7EDC\u7814\u8BA8\u4F1A\u97F3\u9891\u7684\u8F6C\u5F55\u6587\u5B57\u3002 \u8BF7\u6CE8\u610F\uFF0C\u76EE\u524D\u4EC5\u82F1\u8BED\u8BED\u8A00\u652F\u6301\u6B64\u670D\u52A1\u3002 <a href=\"https://support.zoom.us/hc/zh-cn/articles/115004794983-Using-audio-transcription-for-cloud-recordings-\" target=\"_blank\">\u70B9\u51FB\u6B64\u5904</a>\u4E86\u89E3\u8BE6\u60C5\u3002",
    "meetings.fullPlanItem34": "\u54C1\u724C\u5BA3\u4F20",
    "meetings.fullPlanItem34Tip": "\u5C06\u516C\u53F8\u54C1\u724C\u4FE1\u606F\u6DFB\u52A0\u5230\u81EA\u5B9A\u4E49\u9875\u9762\uFF0C\u7528\u6237\u4ECE\u8BE5\u9875\u9762\u52A0\u5165\u4F1A\u8BAE\u3002\u521B\u5EFA\u9080\u8BF7\u89C2\u4F17\u6240\u9700\u7684\u54C1\u724C\u7535\u5B50\u90AE\u4EF6\u6A21\u677F\u3002",
    "meetings.fullPlanItem35": "\u6258\u7BA1\u57DF",
    "meetings.fullPlanItem35Tip": "\u4F7F\u7528\u60A8\u7684\u516C\u53F8/\u5927\u5B66\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u57DF\u5C06\u7528\u6237\u81EA\u52A8\u6DFB\u52A0\u5230\u60A8\u7684\u8D26\u6237\u3002",
    "meetings.fullPlanItem37": "\u8BED\u8A00\u7FFB\u8BD1",
    "meetings.fullPlanItem37Tip": "\u4F1A\u8BAE\u4E3B\u6301\u4EBA\u53EF\u4EE5\u5728\u4F1A\u8BAE\u548C\u7F51\u7EDC\u7814\u8BA8\u4F1A\u4E2D\u6307\u5B9A\u8BD1\u5458\u3002\u5F53\u4F1A\u8BAE\u6216\u7F51\u7EDC\u7814\u8BA8\u4F1A\u5F00\u59CB\u65F6\uFF0C\u4F1A\u8BAE\u4E3B\u6301\u4EBA\u53EF\u4EE5\u5F00\u542F\u7FFB\u8BD1\u529F\u80FD\uFF0C\u8FD9\u5C06\u4E3A\u8BD1\u5458\u63D0\u4F9B\u4E13\u95E8\u7684\u8BED\u8A00\u9891\u9053\u3002\u53C2\u4F1A\u8005\u53EF\u4EE5\u6839\u636E\u9700\u8981\uFF0C\u9009\u62E9\u81EA\u5DF1\u6240\u9700\u7684\u8BED\u8A00\u9891\u9053\u3002\u53C2\u4F1A\u8005\u4E0D\u4F46\u53EF\u4EE5\u542C\u5230\u81EA\u5DF1\u6240\u9700\u7684\u8BED\u8A00\u7FFB\u8BD1\uFF0C\u8FD8\u53EF\u4EE5\u9009\u62E9\u8C03\u4F4E\u539F\u59CB\u97F3\u9891\u7684\u58F0\u97F3\u3002",
    "meetings.fullPlanItem39": "\u9AD8\u7BA1\u5546\u4E1A\u8BC4\u8BBA",
    "meetings.fullPlanItem39Tip": "\u8BE6\u7EC6\u7684\u8D8B\u52BF\u91C7\u7528\u5206\u6790\u3001\u6295\u8D44\u56DE\u62A5\u7387 (ROI) \u8DDF\u8E2A\u4EE5\u53CA\u4EA7\u54C1\u8DEF\u7EBF\u56FE\u8BA8\u8BBA\u3002",
    "meetings.fullPlanItem40": "\u6346\u7ED1\u6298\u6263",
    "meetings.fullPlanNewItem4": "\u5305\u542B Webinar 500",
    "one.includeWbn1000": "*企业加强版包括 Webinar 1000",
    "meetings.fullPlanItem51": "Zoom \u767D\u677F",
    "meetings.unlimited": "\u65E0\u9650",
    "one.translatedCations": "已翻译字幕",
    "one.entPlus": "Enterprise Plus",
    "mail": "邮件",
    "zoomMailAndCalendarInTheZoomApp": "Zoom App 中的 Zoom Mail 和 Calendar",
    "mailService": "邮件服务",
    "emailServiceWithFullTimeEndToEnd": "电子邮件服务具有全时端到端加密功能，可增强隐私保护",
    "customMailDomain": "自定义邮件域",
    "customMailDomainWithMailService": "具有邮件服务的自定义邮件域",
    "calendarClient": "日历客户端",
    "scheduleAndJoinMeetings": "通过 Zoom App 安排和加入会议",
    "calendarService": "日历服务",
    "meetingSchedulingAndAppointment": "会议安排和预约",
    "zoomCustomerManagedKey": "Zoom Customer Managed Key",
    "bringYourOwnEncryptionKeysToProtectZoomDataAtRest": "Bring your own encryption keys to protect Zoom data at rest",
    "phone.fullPlanItem1": "无限国内通话",
    "phone.fullPlanItem2": "计时国际通话",
    "phone.fullPlanItem3": "\u65E0\u9650\u547C\u51FA",
    "phone.fullPlanItem4": "\u4E1A\u754C\u9886\u5148\u7684\u9AD8\u6E05\u901A\u8BDD\u8D28\u91CF",
    "phone.fullPlanItem4Tip": "\u5177\u5907\u4E3B\u52A8\u964D\u566A\u3001\u56DE\u58F0\u6D88\u9664\u53CA\u6309\u952E\u6291\u5236\u529F\u80FD",
    "phone.fullPlanItem5": "\u539F\u751F Windows\u3001MacOS \u548C Linux \u684C\u9762\u5E94\u7528",
    "phone.fullPlanItem6": "\u539F\u751F iOS \u548C Android \u79FB\u52A8\u5E94\u7528",
    "phone.fullPlanItem7": "\u8F6C\u79FB\u73B0\u6709\u53F7\u7801\u6216\u8D2D\u4E70\u65B0\u53F7\u7801 (DID)",
    "phone.fullPlanItem8": "\u88AB\u53EB\u4ED8\u8D39\u53F7\u7801",
    "phone.fullPlanItem9": "\u7535\u8BDD\u5206\u673A\u53F7\u7801",
    "phone.fullPlanItem10": "\u5E26\u8F6C\u5F55\u529F\u80FD\u7684\u8BED\u97F3\u4FE1\u7BB1",
    "phone.fullPlanItem10Tip": "\u901A\u8FC7\u79FB\u52A8/\u684C\u9762\u5E94\u7528\u548C\u7535\u5B50\u90AE\u4EF6\u8BBF\u95EE\u8BED\u97F3\u4FE1\u7BB1\u8F6C\u5F55",
    "phone.fullPlanItem11": "\u65E0\u9650\u81EA\u52A8\u52A9\u7406/ IVR",
    "phone.fullPlanItem12": "\u6309\u59D3\u540D\u76EE\u5F55\u62E8\u53F7",
    "phone.fullPlanItem13": "\u81EA\u52A8\u547C\u53EB\u5206\u914D (ACD) \u7FA4\u7EC4\uFF0C\u5177\u6709\u547C\u53EB\u961F\u5217\u529F\u80FD",
    "phone.fullPlanItem14": "\u5207\u5165/\u76D1\u89C6/\u79C1\u804A/\u63A5\u7BA1",
    "phone.fullPlanItem15": "\u8282\u5047\u65E5\u548C\u5DE5\u4F5C\u65E5\u8DEF\u7531\u9009\u62E9",
    "phone.fullPlanItem16": "3 \u8DEF\u4E13\u7528\u7535\u8BDD\u4F1A\u8BAE",
    "phone.fullPlanItem17": "\u901A\u8BDD\u5F55\u97F3",
    "phone.fullPlanItem17Tip": "\u53EF\u4EE5\u81EA\u52A8\u548C\u624B\u52A8\u5F55\u97F3\u3002",
    "phone.fullPlanItem18": "\u53EF\u914D\u7F6E\u7684\u533F\u540D\u53CA\u6307\u5B9A\u547C\u53EB\u9650\u5236",
    "phone.fullPlanItem19": "\u7D27\u6025\u547C\u53EB",
    "phone.fullPlanItem19Tip": "\u62E8\u6253\u5F53\u5730\u7D27\u6025\u670D\u52A1\u7535\u8BDD",
    "phone.fullPlanItem20": "Nomadic E911 \u5BFB\u5740\uFF08\u7F8E\u56FD\u548C\u52A0\u62FF\u5927\uFF09\u2014\u2014",
    "phone.fullPlanItem20Tip": "\u52A8\u6001\u68C0\u6D4B\u7528\u6237\u4F4D\u7F6E\uFF0C\u5E76\u5C06\u76F8\u5E94\u7684\u7D27\u6025\u5730\u5740\u62A5\u544A\u7ED9\u672C\u5730\u7D27\u6025\u670D\u52A1\u90E8\u95E8\uFF08\u4EC5\u9650\u7F8E\u56FD\u548C\u52A0\u62FF\u5927\uFF09\u548C\u5185\u90E8\u5B89\u5168\u56E2\u961F",
    "phone.fullPlanItem21": "\u7D27\u6025\u54CD\u5E94\u4E2D\u5FC3",
    "phone.fullPlanItem21Tip": "\u60A8\u7684\u5185\u90E8\u5B89\u5168\u56E2\u961F\u80FD\u591F\u6536\u5230\u7D27\u6025\u547C\u53EB\u8B66\u62A5\uFF0C\u5E76\u8BB0\u5F55/\u76D1\u89C6/\u5207\u5165\u7D27\u6025\u547C\u53EB\u4EE5\u5E2E\u52A9\u534F\u8C03\u54CD\u5E94\u3002",
    "phone.fullPlanItem22": "\u5171\u4EAB\u7EBF\u8DEF\u663E\u793A/\u6388\u6743",
    "phone.fullPlanItem23": "\u8BBE\u5907\u95F4\u547C\u53EB\u5207\u6362",
    "phone.fullPlanItem24": "\u547C\u53EB\u5BC4\u5B58",
    "phone.fullPlanItem25": "\u804A\u5929\uFF08\u5728\u7EBF\u72B6\u6001\u3001\u4E00\u5BF9\u4E00\u548C\u56E2\u961F\u6D88\u606F\u6536\u53D1\uFF09",
    "phone.fullPlanItem25Tip": "\u4E0E\u4EFB\u610F Zoom \u7528\u6237\u804A\u5929",
    "endToEndEncryptionForZoomPhone": "Zoom Phone 的端到端加密功能",
    "whenEnabledForZoomPhoneEndToEndEncryptionE2ee": "启用 Zoom Phone 的端到端加密 (E2EE) 功能后，将使用仅限呼叫方和接听方设备已知的加密密钥对通话进行加密。 此外，用户还可以选择向彼此提供唯一安全代码验证 E2EE 状态。",
    "256BitAesGcmEncryptionForRealTimeContent": "适用于实时内容和媒体的 256 位 AES-GCM 加密，在 SIP 注册期间使用的 TLS 加密，以及主叫方 ID 屏蔽、专用网络对等互联、工具欺诈检测和呼叫阻止列表。",
    "phone.fullPlanItem43": "\u96F6\u63A5\u89E6\u7535\u8BDD\u914D\u7F6E",
    "phone.fullPlanItem44": "\u5728\u5355\u4E2A\u8D26\u6237\u4E2D\u914D\u7F6E\u591A\u4E2A\u8BA1\u5212\u7C7B\u578B",
    "phone.fullPlanItem46": "\u5B9E\u65F6\u62A5\u544A\u548C\u8D28\u91CF\u4EEA\u8868\u677F",
    "phone.fullPlanItem47": "\u652F\u6301\u865A\u62DF\u684C\u9762 (VDI) \u73AF\u5883",
    "phone.fullPlanItem47Tip": "<a href=\"https://support.zoom.us/hc/zh-cn/articles/360031096531-Getting-Started-with-VDI\">\u4E86\u89E3\u66F4\u591A</a> VDI \u8BE6\u60C5",
    "phone.fullPlanItem48": "\u5168\u5929 24 \u5C0F\u65F6\u5168\u7403\u5BA2\u6237\u670D\u52A1",
    "phone.fullPlanItem49": "\u81EA\u5E26\u8FD0\u8425\u5546\u652F\u6301",
    "phone.fullPlanItem49Tip": "\u652F\u6301\u4E0E\u73B0\u6709 PSTN \u670D\u52A1\u63D0\u4F9B\u5546\u76F4\u63A5\u548C\u57FA\u4E8E\u73B0\u573A\u7684\u5BF9\u63A5",
    "phone.fullPlanItem50": "\u4E0E\u4F20\u7EDFPBX\u6DF7\u5408\u96C6\u6210",
    "phone.fullPlanSms": "\u77ED\u4FE1\u548C\u5F69\u4FE1",
    "phone.fullPlanSmsTip": "\u4EC5\u9002\u7528\u4E8E\u8D2D\u4E70\u901A\u8BDD\u8BA1\u5212\u7684\u7F8E\u56FD\u548C\u52A0\u62FF\u5927\u53F7\u7801\u3002 \u9002\u7528\u4E8E\u76F4\u62E8\u53F7\u7801\uFF08\u975E\u516C\u53F8\u53F7\u7801\uFF09\u3002",
    "notIncluded": "Not Included",
    "included": "Included",
    "helpTooltipIcon": "Help Tooltip icon",
    "phone.fullPlanItem20Pdf": "\u4E0B\u8F7D\u6570\u636E\u8868",
    "marketing.new_pricing.phone.metered_plan.new.item1": "内线通话，拨入和拨出呼叫。 所有呼出通话分钟数都将按时间进行计费。 请查看计量费率。",
    "marketing.new_pricing.phone.metered_plan.item1": "\u7F8E\u56FD\u548C\u52A0\u62FF\u5927\u53F7\u7801",
    "marketing.new_pricing.phone.item.sms": "\u56FD\u5185\u77ED\u4FE1\u548C\u5F69\u4FE1",
    "marketing.new_pricing.phone.item.sms.tip": "\u4EC5\u9002\u7528\u4E8E\u8D2D\u4E70\u901A\u8BDD\u8BA1\u5212\u7684\u7F8E\u56FD\u548C\u52A0\u62FF\u5927\u53F7\u7801\u3002 \u9002\u7528\u4E8E\u76F4\u62E8\u53F7\u7801\uFF08\u975E\u516C\u53F8\u53F7\u7801\uFF09\u3002",
    "marketing.new_pricing.phone.metered_plan.item3": "\u4ECE\u591A\u79CD\u8BBE\u5907\u548C/\u6216\u5E94\u7528\u63A5\u6253\u7535\u8BDD",
    "marketing.new_pricing.common.one_management_portal": "一个管理门户",
    "marketing.new_pricing.common.one_management_portal_tooltip": "在 Zoom 集中式管理员门户中配置和管理用户，以及监控通话质量和使用情况数据。",
    "marketing.new_pricing.phone.unlimited_plan.item2": "\u7F8E\u56FD\u548C\u52A0\u62FF\u5927\u65E0\u9650\u901A\u8BDD",
    "marketing.new_pricing.phone.domestic_plan.item5": "\u53EF\u9009\u9644\u52A0\u7EC4\u4EF6\uFF1A\u65E0\u9650\u547C\u53EB 19 \u4E2A\u56FD\u5BB6/\u5730\u533A",
    "marketing.new_pricing.phone.domestic_plan.item5.tip": "\u8BE5\u9644\u52A0\u7EC4\u4EF6\u8BA1\u5212\u53EF\u4E0E\u4EFB\u4F55\u65E0\u9650\u901A\u8BDD\u8BA1\u5212\u4E00\u540C\u8D2D\u4E70\uFF0C\u63D0\u4F9B\u5230\u4EE5\u4E0B\u56FD\u5BB6/\u5730\u533A\u7684\u65E0\u9650\u56FD\u9645\u901A\u8BDD\uFF1A\u7F8E\u56FD\u3001\u52A0\u62FF\u5927\u3001\u82F1\u56FD\u3001\u7231\u5C14\u5170\u3001\u6FB3\u5927\u5229\u4E9A\u3001\u65B0\u897F\u5170\u3001\u5965\u5730\u5229\u3001\u4E39\u9EA6\u3001\u6CD5\u56FD\u3001\u5FB7\u56FD\u3001\u610F\u5927\u5229\u3001\u8461\u8404\u7259\u3001\u897F\u73ED\u7259\u3001\u745E\u5178\u3001\u6BD4\u5229\u65F6\u3001\u8377\u5170\u3001\u745E\u58EB\u548C\u6CE2\u591A\u9ECE\u5404\u3002",
    "phone.fullPlanItem27": "\u5373\u63D2\u5373\u7528 VoIP \u7535\u8BDD",
    "phone.fullPlanItem27Tip": "\u652F\u6301\u5E26\u6709\u9644\u63A5\u76D2\u7684\u53F0\u5F0F\u7535\u8BDD\u3001\u4F1A\u8BAE\u7535\u8BDD\u548C\u65E0\u7EBF\u8BBE\u5907",
    "phone.fullPlanItem28": "\u6A21\u62DF\u8BBE\u5907\u652F\u6301\uFF08ATA\u3001\u5BFB\u547C\u7B49\uFF09",
    "phone.fullPlanItem28Tip": "ATA \u53EF\u652F\u6301\u6700\u591A 288 \u4E2A\u7AEF\u53E3",
    "phone.fullPlanItem29": "\u5171\u4EAB\u7535\u8BDD",
    "phone.fullPlanItem31": "\u5C06\u901A\u8BDD\u5347\u7EA7\u4E3A Zoom Meeting",
    "phone.fullPlanItem32": "\u5C06\u901A\u8BDD\u8F6C\u79FB\u5230 Zoom Meeting \u6216 Zoom Room",
    "phone.fullPlanItem34": "Salesforce",
    "phone.fullPlanItem34Tip": "\u539F\u751F Salesforce Lightning \u5E94\u7528\uFF0C\u5E26\u6709\u62E8\u53F7\u76D8\u3001\u70B9\u51FB\u62E8\u53F7\u3001\u6D3B\u52A8\u8BB0\u5F55\u548C\u5C4F\u5E55\u5F39\u51FA\u529F\u80FD",
    "phone.fullPlanItem35": "Slack",
    "phone.fullPlanItem35Tip": "\u672C\u673A\u96C6\u6210 Slack /\u6307\u4EE4\u548C\u901A\u8BDD\u6309\u94AE",
    "phone.fullPlanItem36": "\u8054\u7EDC\u4E2D\u5FC3",
    "phone.fullPlanItem36Tip": "Five9\u3001Twilio\u3001Genesys\u3001NICE inContact\u3001Talkdesk",
    "phone.fullPlanItem37": "Microsoft",
    "phone.fullPlanItem37Tip": "\u65E5\u5386\u548C\u5728\u7EBF\u72B6\u6001\u4E0E Outlook \u96C6\u6210",
    "phone.fullPlanItem38": "Google",
    "phone.fullPlanItem38Tip": "\u70B9\u51FB\u901A\u8BDD\u3001\u65E5\u5386\u548C\u5728\u7EBF\u72B6\u6001\u4E0E Google \u65E5\u5386\u548C Gmail \u96C6\u6210",
    "phone.fullPlanItem40": "\u901A\u8FC7 SAML 2.0 \u5355\u70B9\u767B\u5F55",
    "phone.fullPlanItem40Tip": "Supports Microsoft Active Directory, Google, Ping, Okta, Centrify. Requires Business, Education, or Enterprise account.",
    "phone.fullPlanItem41": "256 \u4F4D\u8EAB\u4EFD\u9A8C\u8BC1/\u5A92\u4F53\u52A0\u5BC6\u652F\u6301",
    "phone.fullPlanItem42": "\u4F01\u4E1A API \u548C\u5B89\u5168\u6027",
    "phone.fullPlanItem45": "FEDRamp \u4E2D\u5EA6\u5408\u89C4\u6027",
    "phone.fullPlanItem46Tip": "Requires a Business, Education, or Enterprise account to access the Dashboard",
    "phone.fullPlanMeterd": "\u8BA1\u65F6",
    "billing.common.select": "特选",
    "phone.fullPlanUnlimited": "无限区域通话",
    "phone.fullPlanItem26": "\u8BBE\u5907\u652F\u6301",
    "phone.fullPlanItem30": "Zoom会议",
    "phone.fullPlanItem33": "\u96C6\u6210\u670D\u52A1",
    "phone.fullPlanItem39": "\u96C6\u4E2D\u7BA1\u7406",
    "marketing.new_pricing.basic_plus.comparison.meeting_duration": "40 mins with 4 extensions up to {0} mins per billing cycle",
    "marketing.new_pricing.basic_plus.comparison.recording": "Local & {0} cloud",
    "zoomOneRequired": "需要使用 Zoom One",
    "zoomOneAddOnRequired": "This is a Zoom One Add-On and requires a paid Zoom One license in order to purchase.",
    "sessionTypeOptions": "会议类型选项",
    "events.webinarTitle": "网络研讨会",
    "webinarOrMeeting": "网络研讨会或会议",
    "multiDayMultiTrackConcurrentSessions": "多日、多系列以及同时召开的会议",
    "teamCollaboration": "团队协作",
    "licensesOf_500CapacityAndAboveComeWith_5HubHostsAnd_3CoEditorsAndThe_100CapacityLicensesComeWith_2HubHostsAnd_1CoEditorEachOfThese_5HostsCanCollaborateOnEachOthersEventsIncludingHostingSessionsEditingAndUpdatingEventContentCreatingAndPushingEventsLiveAndAssigningRolesWithinAnEventAdditionalHostsAndCoEditorsCanBePurchasedFor_75PerHostOrCoEditorPerMonthForZoomEventsAnd_65PerHostOrCoEditorPerMonthForZoomSessions": "容量为 500 人及以上的许可证配有 5 名中心主持人和 3 名共同编辑者，容量为 100 人的许可证配有 2 名中心主持人和 1 名共同编辑者。 这 5 名主持人可以在彼此的活动中开展协作，包括举办会议、编辑和更新活动内容、创建和推送活动直播以及在活动内分配角色。 可以另行购买主持人和共同编辑者名额，Zoom Events 的价格为每个主持人或共同编辑者每月 75 美元，Zoom Sessions 的价格为每个主持人或共同编辑者每月 65 美元。",
    "eventOrSessionBranding": "活动或会议品牌化设置",
    "inZoomEventsAndZoomSessionsEventHostsCanCreateAUniqueColorPaletteAndApplyBrandingAcrossTheEntireEventIncludingAttendeeEmailsInZoomWebinarsEventHostsCanApplyNameTagsUploadABacksplashAndIncludeUniformVirtualBackgroundsForEachSpeaker": "在 Zoom Events 和 Zoom Sessions 中，活动主持人可以创建一个独特的调色板，并在整个活动中应用品牌化设置（包括观众电子邮件）。 在 Zoom Webinars 中，活动主持人可以应用名称标签，上传壁纸并为每个演讲者提供统一的虚拟背景。",
    "productionTools": "生产工具",
    "useBackstageSimuliveAndLaunchInSessionResourcesAndCtasThroughoutYourEventToKeepYourTeamOrganizedAndYourAttendeesEngaged": "在整个活动中使用“后台”和“预录后直播”功能，并启动会议中资源和 CTA，可确保团队有序开展工作并吸引观众积极参与。",
    "expoAndSponsors": "展览会和赞助商",
    "highlightYourSponsorsAndKeepYourAttendeesEngagedWithTheVirtualExpoHall": "突出展示您的赞助商，通过虚拟展览会大厅吸引观众积极参与。",
    "events.eventsProductFeature3": "\u6D3B\u52A8\u4E2D\u5FC3",
    "eventHubsThatAllowYouToOrganizeYourEventsAndPostEventRecordings": "用于组织活动和发布活动录制文件的活动中心",
    "eventAnalyticsAndReporting": "活动分析和报告",
    "eventAnalyticsToTrackRevenueEngagementAndAttendanceForAllOfYourEvents": "用于跟踪所有活动的收入、参与度和出席情况的活动分析",
    "interactiveInSessionFeatures": "交互式会议中功能",
    "inSessionQAndAChatPollingAndQuizzes": "会议中问答、聊天、问卷和测验",
    "durationPerSession": "每场会议的持续时间",
    "100InteractiveVideoPanelists_49ViewableOnScreenAtOneTime": "100 多名交互式视频嘉宾（49 人可同时显示在屏幕上）",
    "eventRegistration": "活动注册",
    "eventManagementPlatformEventInformationSpeakerListRegistration": "活动管理平台（活动信息、演讲者名单、注册）",
    "sessionBranding": "会议品牌化设置",
    "setMatching": "Set matching virtual backgrounds, speaker name tags, and a branded backsplash.",
    "eventBranding": "活动品牌化设置",
    "customizeRegistration": "Customize the registration page, lobby page and much more with your own branded colors, fonts and logos.",
    "speakerBioInformation": "演讲者简介信息",
    "sessionVideoPreviews": "会议视频预览",
    "streamingSessionsInEventLobby": "活动大厅中的直播会议",
    "giveYourAttendeesAWayToPreviewConcurrentSessionsThatAreTakingPlaceByScrollingThroughTheLiveSessionsWithinTheEventLobby": "Give your attendees a way to preview concurrent sessions that are taking place, by scrolling through the live sessions within the Event Lobby.",
    "eventSponsors": "活动赞助商",
    "expoFloor": "展览会大厅",
    "expoFloorForAttendeesToInteractWithSponsorsEngageInLiveConversationsAndExploreExpoBooths": "Expo Floor for attendees to interact with sponsors, engage in live conversations and explore Expo Booths.",
    "associatedWithAnEventHubPerLicense": "与活动中心关联（每个许可证）",
    "customizablePreAndPostEventEmailReminders": "可自定义的活动前和活动后电子邮件提醒",
    "customizableRegistration": "自定义注册",
    "ticketing": "票务",
    "paidFree": "付费/免费",
    "practiceSession": "会议准备模式",
    "productionStudio": "生产工作室",
    "avoidAdditionalProductionAndAgencyCostsByDesigningYourOwnInSessionLayoutsCreateMultipleWebinarScenesWithCustomLayoutsAndDetermineTheirSequenceCustomizeVideoBordersChangeAspectRatiosAndAddSceneWallpapers": "通过设计自己的会议布局，避免额外的生产和代理成本。 使用自定义布局创建多个网络研讨会场景，然后确定它们的顺序。 自定义视频边框、更改长宽比、添加场景壁纸",
    "1080pVideoResolution": "1080p 视频分辨率",
    "backstage": "后台",
    "aBehindTheScenesEventManagementSpaceForTheProductionCrewAndPanelistsToCollaborateBeforeDuringAndAfterASessionThisFeatureCanBeUsedInWebinarsHostedFromTheWebPortalForAnyoneWithAnAnnualZoomSessionOrZoomEventsLicense": "幕后活动管理空间可供制作团队和嘉宾在会议前、会议中和会议后进行协作。此功能适用于在 Web 门户中举办的网络研讨会，可供持有年度 Zoom Sessions 或 Zoom Events 许可证的任何用户使用。",
    "simulive": "预录后直播",
    "provideEngagingContentAtAnyTimeOfTheDayInAnyTimeZoneSimuliveWillBringTheLiveExperienceToAllAttendeesWithPreRecordedContentThatStartsAndEndsAutomaticallyThisFeatureCanBeUsedInWebinarsHostedFromTheWebPortalForAnyoneWithAnAnnualZoomSessionOrZoomEventsLicense": "随时随地提供引人入胜的内容。 预录后直播通过自动开始和结束的预录内容为所有观众带来实时直播体验。 此功能适用于在 Web 门户中举办的网络研讨会，可供持有年度 Zoom Sessions 或 Zoom Events 许可证的任何用户使用。",
    "sessionResources": "会议资源",
    "allowAttendeesToViewAndDownloadDocumentsDuringTheSessionThroughCustomizableCallsToActionWithinAWebinarSessionThisFeatureCanBeUsedInWebinarsHostedFromTheWebPortalForAnyoneWithAnAnnualZoomSessionOrZoomEventsLicense": "允许观众在网络研讨会期间通过可自定义的行动号召查看和下载文档。 此功能适用于在 Web 门户中举办的网络研讨会，可供持有年度 Zoom Sessions 或 Zoom Events 许可证的任何用户使用。",
    "lobbyChat": "大厅聊天",
    "livePollingAndResults": "实时问卷和调查结果",
    "qAndA": "问答",
    "sessionSurveys": "会议调查",
    "eventSurveys": "活动调查",
    "liveTranscription": "实时转录",
    "languageInterpreterSupport": "语言传译员支持",
    "cloudRecordingsAndTextTranscripts": "云录制和文字转录",
    "performanceAndAudienceEngagementReports": "性能和观众参与度报告",
    "detailedAnalyticsDashboardsAndReporting": "详细分析仪表板和报告",
    "billingManagementAccountLevelAndHubLevel": "计费管理账户级别和中心级别",
    "paymentProviderStripe": "付款提供商 - Stripe",
    "paymentProviderPaypal": "付款提供商 - PayPal",
    "taxation": "税务",
    "taxComplianceControlForEu": "欧盟税务合规控制",
    "recordingCloudLocal": "录制 - 云/本地",
    "onDemandRecordingAvailable": "可按需录制",
    "postEvent": "活动后",
    "postEventSurvey": "活动后调查",
    "marketoIntegration": "Marketo 集成",
    "pardotIntegration": "Pardot 集成",
    "eloquaIntegration": "Eloqua 集成",
    "attendeeNetworking": "观众交流",
    "inWebinarChatOnly": "仅限网络研讨会中聊天",
    "inSessionChatOnly": "仅限会议中聊天",
    "networkingFeaturesIncludingAttendeeProfileCreation_1_1ChatAndMore": "交流功能，包括创建观众个人资料、一对一聊天等",
    "professionalServicesAvailable": "可提供专业服务",
    "3hoursPPA": "3 hours of professional services included in Zoom Sessions and Zoom Events licenses for capacities over 10,000 attendees. 1 hour is included for 1000, 3000, and 5000. Not included in Pay Per Attendee plans.",
    "asAnAddOn": "作为附加组件",
    "localizationToAllZoomLanguages": "所有 Zoom 语言本地化",
    "eventAttributes": "活动属性",
    "hubCollaboration": "中心/协作",
    "eventSetup": "活动设置",
    "audienceEngagement": "观众参与度",
    "analytics": "分析",
    "paymentsBilling": "付款/计费",
    "postEventFeatures": "活动后功能",
    "events.fullPlanItem14": "集成",
    "additionalFeatures": "其他功能",
    "marketing.new_pricing.clips": "Clips",
    "marketing.new_pricing.clips_tips": "Effortlessly create, edit, and share short videos. Stored clips are easily discoverable, boosting engagement.",
    "marketing.new_pricing.notes": "Notes",
    "marketing.new_pricing.notes_tips": "Notes offers a robust personal and collaborative document editor with extensive formatting options, accessible both in and out of meetings.",
    "marketing.new_pricing.included_x": "{0} included",
    "createAndShareNewOrExistingWhiteboardsInMeetingsAndWebinar": "在会议和网络研讨会中创建和共享新白板或现有白板",
    "shareWhiteboardsInPresentationOrCollaborationMode": "在演示或协作模式下共享白板",
    "zoomWebMeetingIntegration": "Zoom 网络会议集成",
    "guestAndTemporaryAccessInMeetingWebinar": "会议/网络研讨会的访客和临时访问权限",
    "hostOwnsAllContentCreatedInMeetingAndWebinar": "主持人拥有在会议和网络研讨会中创建的所有内容",
    "shareClaimAndJoinWhiteboardsInZoomRoom": "在 Zoom Room 中共享、申请和加入白板",
    "meetingAndWebinarSpecificWhiteboardSettings": "特定于会议和网络研讨会的白板设置",
    "shareWhiteboardsWithZoomTeamChatsAndChannels": "通过 Zoom Team Chat 和频道共享白板",
    "unlmitedConcurrentlyEditableWhiteboards": "无限制且可同时编辑的白板",
    "standardFeaturesAndAdvancedDocumentControl": "标准功能和高级文档控制",
    "canBeAddedToZoomOneBasicOrProPlans": "可以添加到 Zoom One 基础版或专业版套餐",
    "advancedWhiteboardFeatures": "高级白板功能，包括自定义和组织模板，以及第三方集成",
    "marketing.new_pricing.ai_companion": "AI Companion",
    "companionModalTitle": "Zoom AI Companion",
    "companionModalDesc": "借助 Zoom 平台上集成的 AI 助手，改变您的日常工作",
    "companionModalContent": "使用可搜索的转录文字、后续步骤截取、主题章节等功能，更快地查看录制文件;获取实时摘要或会后总结，并通过团队聊天或电子邮件轻松与他人共享;如果参加现场会议迟到，可向 AI Companion 询问讨论的主题;对聊天内容和电子邮件的说话语气、篇幅和其他改写偏好进行个性化设置",
    "enjoyCompanionTipForNN": "Enjoy Zoom AI Companion when you purchase a Zoom One plan!",
    "enjoyCompanionTipForPaid": "Zoom AI Companion 现已向所有付费客户开放.",
    "enjoyCompanionTip": "Zoom AI Companion 现已向所有付费客户开放!",
    "marketing.enjoy_companion.more_feature_come": "还有更多不可思议的功能，敬请期待！",
    "marketing.enjoy_companion.top_features": "热门功能",
    "marketing.enjoy_companion.legal_terms": "Zoom AI Companion 包含在 Zoom 用户账户的付费服务中，无需支付额外费用。 可能不包括部分垂直行业和地区。",
    "subscriptionPlansGreaterThan_50UsdMonth": "订阅套餐费用超过 50 美元/月",
    "subscriptionPlansGreaterThan_200UsdMonth": "订阅套餐费用超过 200 美元/月",
    "simplifiedVideoConferencingAndMessagingAcrossAnyDevice": "简化跨任何设备的视频会议和信息发送",
    "allPlansClipsCoreFeatureDescription1": "轻松录制、编辑和共享短视频",
    "allPlansClipsCoreFeatureDescription2": "无限制的视频和高级功能",
    "allPlansClipsCoreFeatureToolTip": "轻松创建、编辑和共享短视频。 存储后的剪辑显而易见，从而提高了参与度。",
    "allPlansNotesCoreFeatureDescription1": "轻松录制、编辑和共享短视频",
    "allPlansNotesCoreFeatureDescription2": "无限制的视频和高级功能",
    "allPlansNotesCoreFeatureToolTip": "Notes 提供了功能强大的个人和协作文档编辑器，可编辑多种格式的文档并且可在会议内外使用。",
    "easilyCommunicateIn_1_1MessagesSmallGroupsOrWithLargeTeams": "轻松地在一对一消息、小型或大型群组中进行交流",
    "quicklyFindContactsInstantMessagesGroupChatsAndFilesKeepingKnowledgeAndInformationAtYourFingertips": "快速查找联系人、即时消息、群组聊天和文件，随时掌握各类知识和信息。",
    "boostProductivityByLeveragingYourFavoriteAppsRightWithinTeamChat": "通过在 Zoom Team Chat 中使用您最常用的应用程序来提高工作效率",
    "enhanceCollaborationWithSeamlessFileSharing": "加强协作，实现无缝文件共享",
    "neverLoseTrackOfMeetingConversationsCommunicateBeforeDuringAndAfterAMeetingInADedicatedGroupChatInZoomTeamChatForAllMeetingParticipants": "再也不会丢失会议谈话内容。 在会议前、会议中和会议后，所有会议参与者都可以在 Zoom Team Chat 的专用群组聊天中进行沟通。",
    "backChannelsToTheZoomCloudOrAThirdPartyStorageProvider": "将频道备份到 Zoom 云或第三方存储提供商",
    "customizeYourOwnAvatarToBringSomeFunIntoMeetingsAndPresentYourselfDynamicallyWithoutNeedingToBeOnVideo": "定制自己的虚拟形象，为会议增添一些乐趣，并在不需要开启视频的情况下以动态方式展示自己",
    "showEngagementAndQuicklyCommunicateWithOtherParticipantsInANonVerbalWay": "表现出互动性，并以非口头方式与其他参与者快速沟通",
    "injectSomeFunIntoYourMeetingsWithAVarietyOfFiltersOverlayedOntoYourVideo": "通过在视频上叠加各种滤镜，为您的会议增添一些乐趣",
    "createSingleChoiceOrMultipleChoicePollingQuestionsForYourMeetings": "为您的会议创建单选或多选问卷问题。",
    "availableToAllPhoneStandaloneCustomersSupportPlansWillVaryWhenPairedWithMeetingsPlans": "Available to all phone standalone customers. Support plans will vary when paired with meetings plans.",
    "troubleshootTechnicalIssuesAndAccessSupportResourcesBySearchingOurKnowledgeBaseArticles": "通过搜索我们的知识库文章解决技术问题并访问支持资源。",
    "aPlaceToFindSolutionsAskQuestionsAndCollaborateWithOtherZoomUsers": "查找解决方案、提出问题和与其他 Zoom 用户协作的地方。",
    "getAnswersToQuestionsAndTroubleshootTechnicalIssuesByInteractingWithOurChatbot": "通过与我们的聊天机器人互动获得问题的答案，并解决技术问题。",
    "aiCompanion": "AI Companion",
    "common.phoneTab": "Zoom Phone",
    "automatedMeetingsCaptions": "Automated Meetings Captions",
    "translatedCaptions-0": "已翻译字幕",
    "workspaceReservation": "工作区预订",
    "accessAcrossAnyDevice": "通过任何设备访问",
    "directChannelOrGroupChat": "私聊、频道或群聊",
    "messageAndFileHistory": "消息和文件历史记录",
    "findPeopeChannelsAndFilesInSearch": "在搜索中查找人员、频道和文件",
    "applicationIntegrations": "应用程序集成",
    "secureFileSharing": "安全的文件共享功能",
    "persistentMeetingChat": "持续会议聊天",
    "cloudStorage": "云存储",
    "avatars": "虚拟形象",
    "inMeetingReactions": "会议内表情符号",
    "virtualBackgrounds": "虚拟背景",
    "videoFilters": "视频滤镜",
    "inMeetingPollsAndQuizzes": "会议内问卷和测验",
    "liveStreamingAcrossPlatforms": "平台直播",
    "appearanceTouchUp": "美颜",
    "originalSoundForMusicians": "音乐人原声",
    "knowledgeBase": "知识库",
    "zoomCommunity": "Zoom 社区",
    "chatbot": "聊天机器人",
    "submitWebTickets": "提交 Web 工单",
    "liveChatSupport": "实时聊天支持",
    "livePhoneSupport": "实时电话支持",
    "meetWithAgentOnVideo": "通过视频与坐席会面",
    "billing.zone_basic_plus.comments.checkout_desc": "Any unused extended meetings do not roll over. Your 4 extended meetings refresh at the beginning of each monthly billing cycle.",
    "billing.zone_basic_plus.comments.extend_your_meetings": "Extend your meetings",
    "billing.zone_basic_plus.comments.extend_your_meetings_desc": "Four {0} minute meetings per month for seamless collaboration",
    "billing.zone_basic_plus.comments.more_great_feature": "More great features",
    "billing.zone_basic_plus.comments.more_great_feature_desc": "Everything from the Basic Free plan, plus {0} GB of Cloud Storage",
    "billing.zone_basic_plus.title": "Zoom One Basic Plus",
    "billing.zone_basic_plus.bill_info": "{number} user  •  {price}{billingCycle}",
    "billing.common.employees": "员工",
    "billing.planform.meeting_license_tips.need_unassign_user": "To proceed with the downgrade, unassign {0} user(s) by {1}. Otherwise, downgrade will not be processed.",
    "billing.planform.meeting_license_decrease_tips.need_decrease_addon": "To decrease the number of users for Zoom One {plan}, you need to adjust the add-on {product} license quantity to be equal to or less than Zoom One {plan}. <a href=\"/billing\">Return to Plan Management</a>",
    "billing.planform.meeting_cycle_tips.can_not_select_monthly": "If you\u2019d like to have a Zoom One {plan} monthly subscription, you need to update your {product} plan to a monthly subscription first.  <a href=\"/billing\">Return to Plan Management</a>",
    "billing.planform.meeting_license_disable_downsell": "You are not able to make this change to your account mid-contract. To contact our team, please use this <a href=\"/billing/contactus?type=downsell&mrs={0}&current_term={1}&renewal_term={2}&subscription_end_date={3}&current_term_period_type={4}&renewal_term_period_type={5}&plan_code={6}&is_one_month={7}\" target=\"_blank\">form</a>.",
    "billing.planform.meeting_license_custom_pricing": "Your account has custom pricing. To decrease the license count, please <a href=\"/billing/contactus\" target=\"_blank\">contact us</a>.",
    "billing.vat_number": "\u589E\u503C\u7A0E\u53F7\u7801",
    "billing.not_vat_registered": "\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0",
    "billing.not_vat_tips": "\u5982\u679C\u4F60\u662F\u4E00\u5BB6\u5DF2\u6CE8\u518C\u7684\u6B27\u76DF\u4F01\u4E1A\uFF0C\u5219\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801",
    "billing.vat_checkbox_desc": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u5C06\u6839\u636E\u6B27\u76DF\u6CD5\u5F8B\u4EE5\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
    "billing.amMsg": "\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u767B\u8BB0\u53F7\u7801",
    "billing.amMsgDesc": "\u901A\u8FC7\u9009\u4E2D\u6B64\u6846\uFF0C\u672C\u4EBA\u786E\u8BA4\u672C\u4EBA/\u6211\u4EEC\u5DF2\u5728\u4E9A\u7F8E\u5C3C\u4E9A\u6CE8\u518C\u589E\u503C\u7A0E\u3002 \u6211\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u58F0\u660E\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u5DF2\u5728\u4E9A\u7F8E\u5C3C\u4E9A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA\u63A5\u53D7\u5E76\u7406\u89E3Zoom\u4E0D\u4F1A\u6536\u53D6\u4E9A\u7F8E\u5C3C\u4E9A\u589E\u503C\u7A0E\uFF0C\u5E76\u4E14\u672C\u4EBA/\u6211\u4EEC\u53EF\u80FD\u9700\u8981\u81EA\u884C\u8BC4\u4F30\u5E94\u4ED8\u7684\u589E\u503C\u7A0E\u3002",
    "billing.vat_registration_placeholder": "\u589E\u503C\u7A0E\u767B\u8BB0\u53F7\u7801",
    "billing.registered_for_vat": "\u5DF2\u6CE8\u518C\u589E\u503C\u7A0E",
    "billing.gst_number": "GST\u53F7\u7801",
    "billing.not_gst_registered": "\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0",
    "billing.not_gst_tips": "\u5BF9\u4E8E\u5DF2\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\u7684\u4F01\u4E1A\uFF0C\u8BF7\u8F93\u5165GST\u53F7\u7801",
    "billing.not_gst_tips_for_au": "如果您的企业已注册澳大利亚商品和服务税 (GST)，请输入澳大利亚商业编号 (ABN)。 提供 ABN 即表示，您声明您已注册澳大利亚商品和服务税，并为您在澳大利亚经营的企业购买 Zoom 服务（而非供私人或家庭使用）。",
    "billing.gst_checkbox_desc": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3Zoom\u5C06\u6839\u636E\u5F53\u5730\u6CD5\u5F8B\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6309\u9002\u7528\u7A0E\u7387\u5F81\u6536\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u3002",
    "billing.vat_header_val_BS": "\u5982\u679C\u4F60\u5DF2\u5728\u5DF4\u54C8\u9A6C\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u4F60\u7684TIN\uFF0C\u5B83\u5C06\u663E\u793A\u5728\u4E3A\u4F60\u5F00\u5177\u7684\u53D1\u7968\u4E0A\u3002",
    "billing.vat_header_val_BH": "\u5982\u679C\u60A8\u5DF2\u5728\u5DF4\u6797\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u60A8\u7684\u589E\u503C\u7A0E\u53F7\u3002",
    "billing.vat_id_number_placeholder": "\u589E\u503C\u7A0E\u53F7",
    "billing.vat_checkout_popup_message_IS_BH": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u6D88\u8D39\u8005\u3001\u4F01\u4E1A\u6216\u653F\u5E9C\u673A\u6784\u5E76\u672A\u529E\u7406\u7A0E\u8D39\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u7A0E\u52A1\u72B6\u6001\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u6D88\u8D39\u8005\u3001\u4F01\u4E1A\u6216\u653F\u5E9C\u673A\u6784\u5E76\u672A\u6CE8\u518C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\uFF08\u5982\u679C\u9002\u7528\uFF09\u3002",
    "billing.vat_header_val_BD": "\u5982\u679C\u60A8\u5DF2\u767B\u8BB0\u7F34\u7EB3\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165BIN",
    "billing.vat_checkout_popup_message_BD": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u5E76\u672A\u767B\u8BB0\u7F34\u7EB3\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u6458\u8981\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
    "billing.vat_header_val_BB": "\u5982\u679C\u4F60\u5DF2\u5728\u5DF4\u5DF4\u591A\u65AF\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u4F60\u7684\u589E\u503C\u7A0E\u53F7\u7801\uFF0C\u5B83\u5C06\u663E\u793A\u5728\u4E3A\u4F60\u5F00\u5177\u7684\u53D1\u7968\u4E0A\u3002",
    "billing.byMsg": "\u8BF7\u8F93\u5165\u60A8\u7684\u7A0E\u52A1\u6807\u8BC6\u53F7(PIN)",
    "billing.inMsg": "\u5BF9\u4E8E\u5DF2\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\u7684\u4F01\u4E1A\uFF0C\u8BF7\u8F93\u5165\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u53F7\u7801\u3002\u5982\u679C\u65E0\u6CD5\u63D0\u4F9B\u6709\u6548\u7684GSTIN\uFF0C\u5C06\u5BFC\u81F4\u65E0\u6CD5\u5F00\u7ACB\u7535\u5B50\u53D1\u7968\u3002\u5C06\u81EA\u52A8\u9A8C\u8BC1SEZ\u72B6\u6001\u3002<br /><br />ZVC India\u5FC5\u987B\u5411\u5370\u5EA6\u5883\u5185\u6CE8\u518C\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7684\u5BA2\u6237\u5F00\u5177\u7535\u5B50\u53D1\u7968\u3002\u4E3A\u6B64\uFF0C\u52A1\u5FC5\u786E\u4FDD\u4F60\u7684\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u767B\u8BB0\u53F7\u7801\u6240\u5206\u914D\u5230\u7684\u5DDE\u4E0E\u4F60\u7684\u8D26\u5355\u90AE\u5BC4\u5730\u5740\u53CA\u8BA2\u8D27\u65B9\u5730\u5740\u6240\u5C5E\u7684\u5DDE\u4FDD\u6301\u4E00\u81F4\u3002",
    "billing.tin_number": "TIN \u7F16\u53F7",
    "billing.tax_checkbox_by": "\u514D\u7A0E",
    "billing.vat_header_val_KHM": "\u5982\u679C\u60A8\u5DF2\u5728\u67EC\u57D4\u5BE8\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7\u3002",
    "billing.vat_checkout_popup_message_KHM": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
    "billing.vat_header_val_CM": "If you are a business customer, enter your NIU and it will be displayed on invoices issued to you",
    "billing.tax_promote_cl": "\u8BF7\u8F93\u5165\u7A0E\u53F7(RUT)\u5E76\u5FFD\u7565\u5C0F\u6570\u548C\u8FDE\u5B57\u7B26\u3002",
    "billing.rut_number": "RUT\u53F7\u7801",
    "billing.tax_checkbox_desc_cl": "\u9009\u4E2D\u6B64\u590D\u9009\u6846\u8868\u793A\u6211\u627F\u8BA4\u9700\u8981\u7F34\u7EB3\u667A\u5229\u7684\u589E\u503C\u7A0E\uFF0C\u56E0\u6B64Zoom\u65E0\u9700\u518D\u5411\u6211\u6536\u53D6\u589E\u503C\u7A0E\u3002",
    "billing.vat_header_val_GH": "\u5982\u679C\u60A8\u5DF2\u5728\u52A0\u7EB3\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7\u3002",
    "billing.vat_header_val_IS": "\u5982\u679C\u60A8\u5DF2\u5728\u51B0\u5C9B\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u60A8\u7684\u589E\u503C\u7A0E\u53F7\u3002",
    "billing.tax_promote_vat_cat1": "\u5982\u679C\u4F60\u662F\u589E\u503C\u7A0E\u6CE8\u518C\u5BA2\u6237\uFF0C\u8BF7\u586B\u5199\u5C06\u4E8EZoom\u53D1\u9001\u7ED9\u4F60\u7684\u53D1\u7968\u4E0A\u663E\u793A\u7684\u589E\u503C\u7A0E\u53F7\u7801",
    "billing.tax_number_on_invoice_tips": "\u5982\u679C\u4F60\u5E0C\u671B\u5728Zoom\u7ED9\u4F60\u5F00\u7684\u53D1\u7968\u4E0A\u663E\u793A\u4F60\u7684\u7A0E\u53F7\uFF0C\u8BF7\u5728\u6B64\u5904\u8F93\u5165\u8BE6\u60C5\u3002",
    "billing.vat_header_val_KAZ": "\u5982\u679C\u4F60\u5DF2\u5728\u54C8\u8428\u514B\u65AF\u5766\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
    "billing.keMsg": "\u8BF7\u8F93\u5165\u60A8\u7684\u4E2A\u4EBA\u6807\u8BC6\u53F7(PIN)\uFF0C\u5B83\u5C06\u663E\u793A\u5728\u53D1\u7ED9\u60A8\u7684\u53D1\u7968\u4E0A\u3002",
    "billing.tax_promote_default": "\u5982\u679C\u4F60\u662F\u5DF2\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\u7684\u4F01\u4E1A\uFF0C\u5219\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801",
    "billing.vat_cat2_checkbox_desc": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u5C06\u6839\u636E\u5F53\u5730\u6CD5\u5F8B\u4EE5\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
    "billing.tax_promote_my": "\u5982\u679C\u4F60\u662F\u7A0E\u52A1\u6CE8\u518C\u5BA2\u6237\uFF0C\u8BF7\u586B\u5199\u5C06\u4E8EZoom\u53D1\u9001\u7ED9\u4F60\u7684\u53D1\u7968\u4E0A\u663E\u793A\u7684\u7A0E\u53F7",
    "billing.tax_number_promote.default": "\u5982\u679C\u60A8\u662F\u5546\u4E1A\u7248\u5BA2\u6237\uFF0C\u8BF7\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7",
    "billing.mdMsgDesc": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u4E0D\u662F\u5546\u4E1A\u5BA2\u6237\uFF08\u5373\u9002\u7528\u4E8E\u6469\u5C14\u591A\u74E6\u7A0E\u6536\u76EE\u7684\u7684\u6CD5\u5F8B\u5B9E\u4F53\uFF09\u3002 \u672C\u4EBA\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u7A0E\u52A1\u72B6\u6001\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u4E0D\u662F\u5546\u4E1A\u5BA2\u6237\uFF08\u5373\u9002\u7528\u4E8E\u6469\u5C14\u591A\u74E6\u7A0E\u6536\u76EE\u7684\u7684\u6CD5\u5F8B\u5B9E\u4F53\uFF09\uFF0C\u5373\u8868\u793A\u672C\u4EBA\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\uFF08\u5982\u9002\u7528\uFF09\u3002",
    "billing.ngMsg": "\u5982\u679C\u60A8\u662F\u4F01\u4E1A\u5BA2\u6237\uFF0C\u8BF7\u63D0\u4F9B\u60A8\u7684\u7A0E\u52A1\u6807\u8BC6\u53F7(TIN)\uFF0C\u8FD9\u5C06\u663E\u793A\u5728Zoom\u4E3A\u60A8\u5F00\u5177\u7684\u53D1\u7968\u4E0A\u3002",
    "billing.tax_promote_no": "\u8BF7\u4E8E\u201CMVA\u201D\u524D\u8F93\u51659\u4F4D\u589E\u503C\u7A0E\u53F7",
    "billing.mva_number": "MVA\u53F7\u7801",
    "billing.vat_checkout_popup_message_RU": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u4FC4\u7F57\u65AF\u589E\u503C\u7A0E\u3002",
    "billing.vat_header_val_RS": "\u5982\u679C\u4F60\u5DF2\u5728\u585E\u5C14\u7EF4\u4E9A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u4F60\u7684\u589E\u503C\u7A0E\u53F7\u7801\uFF0C\u5B83\u5C06\u663E\u793A\u5728\u4E3A\u4F60\u5F00\u5177\u7684\u53D1\u7968\u4E0A\u3002",
    "billing.vat_checkout_popup_message_TW": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u53F0\u6E7E\u589E\u503C\u7A0E\u3002",
    "billing.vat_header_val_TZ": "\u5982\u679C\u60A8\u5DF2\u767B\u8BB0\u7F34\u7EB3\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u767B\u8BB0\u53F7\u7801(VRN)",
    "billing.tax_promote_tr": "\u5982\u679C\u4F60\u5DF2\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801",
    "billing.ugMsg": "\u5982\u679C\u60A8\u5DF2\u767B\u8BB0\u7F34\u7EB3\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165TIN",
    "billing.vat_header_val_UKR": "\u5982\u679C\u4F60\u5DF2\u5728\u4E4C\u514B\u5170\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
    "billing.vat_header_val_VNM": "\u5982\u679C\u60A8\u662F\u5546\u4E1A\u7248\u5BA2\u6237\uFF0C\u8BF7\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7\u3002\u8F93\u5165\u7A0E\u52A1\u6807\u8BC6\u53F7\u5373\u8868\u793A\u5BA2\u6237\u58F0\u660E\u5176\u4E3A\u4F01\u4E1A\u5BA2\u6237\uFF0C\u56E0\u6B64\u6709\u8D23\u4EFB\u5411\u8D8A\u5357\u7A0E\u52A1\u673A\u6784\u7533\u62A5\u4EFB\u4F55\u5E94\u4ED8\u7A0E\u6B3E\u3002",
    "billing.vat_checkout_popup_message_VNM": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u7A0E\u8D39\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u7A0E\u52A1\u72B6\u6001\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u672C\u4EBA/\u6211\u4EEC\u5E76\u672A\u767B\u8BB0\u7EB3\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u6458\u8981\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\uFF08\u5982\u679C\u9002\u7528\uFF09\u3002",
    "billing.vat_header_val_GE": "\u5982\u679C\u4F60\u5728\u683C\u9C81\u5409\u4E9A\u6CE8\u518C\u4E86\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
    "billing.vat_checkout_popup_message": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u65E6\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u8FD8\u5C06\u6839\u636E\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6{0}\u7684\u589E\u503C\u7A0E\u3002",
    "billing.vat_checkout_popup_message_KAZ": "\u54C8\u8428\u514B\u65AF\u5766",
    "billing.vat_checkout_popup_message_GE": "\u683C\u9C81\u5409\u4E9A",
    "billing.vat_checkout_popup_message_UKR": "\u4E4C\u514B\u5170",
    "billing.gst_checkbox_desc_template": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u5C06\u6839\u636E{0}\u4EE5\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u5546\u54C1\u53CA\u670D\u52A1\u7A0E\u3002",
    "billing.tax_checkbox_desc_non_inr_in": "\u5370\u5EA6\u6CD5\u5F8B",
    "billing.tax_promote_co": "\u5982\u679C\u4F60\u662F\u589E\u503C\u7A0E\u4EE3\u7406\uFF0C\u5E76\u4E14\u4F60\u8BA4\u4E3AZoom\u63D0\u4F9B\u7684\u670D\u52A1\u5E94\u514D\u9664\u589E\u503C\u7A0E\uFF0C\u8BF7\u5728\u201C\u7A0E\u53F7\u201D\u5B57\u6BB5\u9009\u62E9\u503C\u201C\u589E\u503C\u7A0E\u4EE3\u7406\u201D\u6216\u201CAgente de IVA\u201D\u3002\u5982\u679C\u9009\u62E9\u6B64\u503C\uFF0C\u5219\u4F60\u5728\u54E5\u4F26\u6BD4\u4E9A\u589E\u503C\u7A0E\u7533\u62A5\u671F\u95F4\u6709\u4E49\u52A1\u8FDB\u884C\u7533\u62A5\u3002",
    "billing.byCheckboxMsg": "\u9009\u4E2D\u6B64\u590D\u9009\u6846\u5373\u8868\u793A\uFF0C\u6211\u627F\u8BA4\u6211\u662F\u4EE3\u8868\u5546\u4E1A\u5BA2\u6237\uFF08\u5373\u767D\u4FC4\u7F57\u65AF\u7EB3\u7A0E\u6CD5\u4EBA\u5B9E\u4F53\uFF09\u884C\u4E8B\uFF0C\u6211\u4E0D\u662F\u767D\u4FC4\u7F57\u65AF\u7EB3\u7A0E\u4E2A\u4EBA\u6216\u4E2A\u4EBA\u4F01\u4E1A\u5BB6\u3002 \u6211\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002 Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u58F0\u660E\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E3A\u8BC1\u660E\u6211\u662F\u4EE3\u8868\u767D\u4FC4\u7F57\u65AF\u7EB3\u7A0E\u5546\u4E1A\u5BA2\u6237\u800C\u975E\u4E2A\u4EBA\u6216\u4E2A\u4EBA\u4F01\u4E1A\u5BB6\u884C\u4E8B\uFF0C\u6211\u63A5\u53D7\u5E76\u7406\u89E3Zoom\u4E0D\u4F1A\u6536\u53D6\u767D\u4FC4\u7F57\u65AF\u589E\u503C\u7A0E\uFF0C\u5E76\u4E14\u6211\u6240\u4EE3\u8868\u7684\u5546\u4E1A\u5BA2\u6237\u53EF\u80FD\u9700\u8981\u81EA\u4E3B\u8BC4\u4F30\u9700\u8981\u7F34\u7EB3\u7684\u589E\u503C\u7A0E\u3002",
    "billing.uzCheckboxMsg": "By checking this box, I acknowledge that I am acting on behalf of a business customer (i.e. a legal entity for Uzbekistan tax purposes) and I am not an individual or individual entrepreneur for Uzbekistan tax purposes. I take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate statement. Furthermore, in certifying that I am acting on behalf of a business customer and not an individual or individual entrepreneur for Uzbekistan tax purposes, I accept and understand that Zoom will not charge Uzbekistan VAT and the business customer I am acting on behalf of may be required to self-assess for VAT due.",
    "billing.vat_header_val_OM": "\u5982\u679C\u4F60\u5728\u963F\u66FC\u6CE8\u518C\u4E86\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
    "billing.vat_checkout_popup_message_OM": "\u963F\u66FC",
    "billing.tax_promote.include_your_vat_number": "\u5982\u679C\u60A8\u662F\u5DF2\u6CE8\u518C\u589E\u503C\u7A0E\u7684\u5BA2\u6237\uFF0C\u8BF7\u586B\u5199\u589E\u503C\u7A0E\u53F7\u7801",
    "billing.vat_header_val_TW": "\u5982\u679C\u60A8\u5DF2\u5728\u53F0\u6E7E\u6CE8\u518C\u589E\u503C\u7A0E\uFF0C\u8BF7\u8F93\u5165\u589E\u503C\u7A0E\u53F7\u7801\u3002",
    "billing.tax_checkbox_desc_template": "\u4E00\u7ECF\u52FE\u9009\u8BE5\u590D\u9009\u6846\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5E76\u4E14\u5BF9\u672C\u58F0\u660E\u7684\u51C6\u786E\u6027\u548C\u5B8C\u6574\u6027\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002Zoom\u4E0D\u627F\u62C5\u4EFB\u4F55\u56E0\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\u4FE1\u606F\u62AB\u9732\u4E0D\u5B8C\u6574\u6216\u4E0D\u51C6\u786E\u6240\u4EA7\u751F\u7684\u8D23\u4EFB\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u8BC1\u660E\u4E0A\u8FF0\u4F01\u4E1A\u5E76\u672A\u529E\u7406\u589E\u503C\u7A0E\u7F34\u7EB3\u767B\u8BB0\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u4EEC\u63A5\u53D7\u5E76\u7406\u89E3\uFF0C\u9664\u8BA2\u5355\u603B\u89C8\u4E2D\u5217\u51FA\u7684\u4EF7\u683C\u5916\uFF0CZoom\u5C06\u6839\u636E{0}\u4EE5\u9002\u7528\u7684\u7A0E\u7387\u5BF9\u6240\u6709\u5E94\u7A0E\u670D\u52A1\u6536\u53D6\u589E\u503C\u7A0E\u3002",
    "billing.tax_checkbox_desc_no": "\u632A\u5A01\u6CD5\u5F8B",
    "billing.tax_checkbox_desc_tr": "\u571F\u8033\u5176\u6CD5\u5F8B",
    "billing.tax_input_placeholder": "\u7A0E\u52A1\u6807\u8BC6\u53F7",
    "billing.pin_number": "PIN\u53F7\u7801",
    "billing.tax_checkbox_md": "\u975E\u4F01\u4E1A\u5BA2\u6237",
    "billing.xx_and_above": "{0} 岁及以上",
    "billing.under_xx": "{0} 岁以下",
    "billing.sign_up_error_msg_1": "请更新或取消您的更改以注册",
    "billing.dont_have_account": "没有账户？",
    "billing.sign_in_df_account": "登录其他账户",
    "billing.common.form_xx_month": "{0} /月起",
    "billing.common.from_xx_month_after_trial": "{duration} 天试用期过后 {price}/月起",
    "billing.common.save_count": "节省 {0} 的费用",
    "billing.error.empty_valid": "{0}为必填项",
    "billing.error.inr_non_india_error": "要使用印度卢比完成购买行为，您的联系人地址必须位于印度。 如果您想选择其他国家/地区，请",
    "billing.error.inr_non_india_error_switch_to_usd": "切换为美元",
    "billing.address.address_line2": "地址行 2",
    "billing.address.phone": "\u7535\u8BDD\u53F7\u7801",
    "billing.see_more": "查看更多",
    "billing.enhance_experience": "增强 Zoom 体验",
    "billing.create_account.sign_up": "注册",
    "billing.create_account.sign_up_desc": "您将成为此账户的所有者，并获得管理员功能的完全访问权限。",
    "billing.create_account.sign_up_desc_for_zp": "您将成为此账户的所有者，并获得管理员功能的完全访问权限。 Zoom Phone 仅供商业使用。",
    "billing.create_account.have_account": "已有账户？",
    "billing.create_account.sign_in": "登录",
    "billing.create_account.age": "年龄",
    "billing.create_account.password": "密码",
    "billing.password.mustMatchAll": "密码必须符合所有要求",
    "billing.create_account.continue_to_address": "继续填写地址",
    "billing.create_account.full_name": "全名",
    "billing.create_account.sdk_registered": "要购买视频SDK，您必须将单独的新Zoom账户地址用于应用开发。",
    "billing.create_account.sdk_registered_new": "The email address you’ve entered is associated with an existing account. Please create a new account with a different email address to purchase Video SDK.",
    "billing.address.business_info": "公司信息",
    "billing.pay_method.save_pay_method": "保存付款方式",
    "billing.pay_method.verify_pay_method": "验证付款方式",
    "billing.common.n_a": "不适用",
    "billing.order_summary": "订单摘要",
    "billing.order_summary_current": "当前套餐",
    "billing.order_summary_updated": "已更新订单摘要",
    "billing.order_summary.item_ss": "项目",
    "billing.order_summary.annual_subscription": "年度订阅",
    "billing.order_summary.monthly_subscription": "月度订阅",
    "billing.order_summary.quarterly_subscription": "季度订阅",
    "billing.order_summary.two_years_subscription": "两年订阅",
    "billing.order_summary.three_years_subscription": "三年订阅",
    "billing.order_summary.subtotal": "小计",
    "billing.order_summary.total": "总计",
    "billing.order_summary.todays_total": "今日总金额",
    "billing.order_summary.todays_total_tip_upgrade": "\u4eca\u65e5\u7684\u8d39\u7528\u5c06\u6309\u6bd4\u4f8b\u6536\u53d6\uff0c\u5e76\u5728\u4f60\u5b8c\u6210\u8ba2\u5355\u540e\u8ba1\u7b97\u3002\u4f60\u5c06\u6536\u5230\u5305\u542b\u6700\u7ec8\u91d1\u989d\u7684\u53d1\u7968\u3002",
    "billing.order_summary.total_billed_monthly": "按月计费总金额",
    "billing.order_summary.total_billed_monthly_new": "每月新增总费用",
    "billing.order_summary.total_billed_monthly_current": "当前每月总计",
    "billing.order_summary.total_billed_quarterly_current": "当前季度总计",
    "billing.order_summary.total_billed_two_years_current": "目前两年总计",
    "billing.order_summary.total_billed_three_years_current": "目前三年总计",
    "billing.order_summary.total_billed_annually": "按年计费总金额",
    "billing.order_summary.total_billed_quarterly": "季度收费总计",
    "billing.order_summary.total_billed_quarterly_new": "新的季度总计",
    "billing.order_summary.total_billed_two_years": "两年收费总计",
    "billing.order_summary.total_billed_two_years_new": "新的两年合计",
    "billing.order_summary.total_billed_three_years": "三年收费总计",
    "billing.order_summary.total_billed_three_years_new": "新的三年合计",
    "billing.order_summary.total_billed_annually_new": "新的年付套餐总费用",
    "billing.order_summary.total_billed_annually_current": "当前年度总计",
    "billing.order_summary.total_billed_trial_tip": "您将于 {date} 自动注册 {plan} {billingCycle} 订阅，系统将按比例向您收取剩余计费周期的费用。如果您在 {date} 之前取消免费试用，您的总 {billingCycle} 账单将自动调整为不包括 {plan}。",
    "billing.order_summary.next_charge_date": "下次收费日期",
    "billing.order_summary.extra_charges": "加上适用的税款、费用和超额费用",
    "billing.order_summary.plus_applicable_taxes": "加上适用税费",
    "billing.order_summary.prorated_title": "\u4ECA\u65E5\u5E94\u4ED8\u91D1\u989D\u662F\u591A\u5C11\uFF1F",
    "billing.order_summary.prorated_desc": "目前将按比例向您收取费用，在下一个订阅期将会全额收取费用（非自动续订套餐除外）。",
    "billing.order_summary.prorated_cycle_change_desc": "您将收到现有套餐中未用时段的余额。 该余额将在您将被收取费用的新套餐中折抵，并从今天开始。",
    "billing.order_summary.prorated_upsell_desc": "目前将按比例向您收取费用，在下一个订阅期将会全额收取费用（非自动续订套餐除外）。",
    "billing.order_summary.prorated_downsell_desc": "-",
    "billing.order_summary.taxes_desc": "根据您提供的账单信息，您购买的产品可能需要缴纳地方税。 最终费用可能与此处显示的金额不同，并将显示在您的发票上。",
    "billing.order_summary.taxes_desc2": "根据您提供的账单信息，您的购买可能需要缴纳地方税。 最终费用可能与此处显示的金额不同，并将显示在您的发票上。",
    "billing.order_summary.prorated_charge_today": "今天按比例收费",
    "billing.order_summary.inr_discount_title": "您已获得 {discount}% 的折扣优惠",
    "billing.order_summary.inr_discount_tooltip": "Zoom Workplace 专业版年度订阅可享 {discount}% 的折扣优惠。此优惠不可与其他优惠券同时使用。",
    "billing.address.street_address": "街道地址",
    "billing.essential_apps.dialog_desc": "使用各种应用发展和管理您的业务，这些应用可记录会议笔记，让团队参与互动活动，并提供见解以改善客户对话。 您的套餐中随附有免费使用付费应用 1 年。",
    "billing.essential_app.legal_copy": "此优惠仅适用于自 2023 年 1 月 4 日起及以后通过 Zoom 在线频道 zoom.us/buy 购买 Zoom One 专业版、商业版或商业加强版订阅而拥有当前许可证的用户。 其订阅与医疗保健、教育或政府账户关联的用户不能享受此优惠。  除 Coda 外，每个应用的访问有效期为自个人用户激活该应用起的 1 年时间。 同一 Zoom 账户中所有用户的 Coda 访问有效期为自同一 Zoom 账户中任何用户首次激活 Coda 起的 1 年时间，而与同一 Zoom 账户中后续用户的初始激活日期无关。对于所有应用，如果重新分配或取消用户的合格许可证或订阅，则将终止该用户的访问权限，无论 1 年访问期限是否还有剩余时间。每个应用都需要遵守激活后所适用的使用条款和隐私政策。随附的应用仅支持英文。并非所有应用都能在移动设备上运行。优惠不可兑换也不可退还现金。优惠仅适用于 <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a> 中被列为基本应用的这些应用。 已订阅任何应用的用户不能享受与那些特定应用有关的这项优惠。Zoom 保留随时修改或取消此优惠的权利，无需事先通知和承担任何责任。",
    "billing.buyItNow.signup.zoom_phone_tos": "Zoom Phone由电信提供商Zoom Voice Communications提供。有关Zoom Phone电信提供商的信息，请参阅<a href=\"https://zoom.us/zh-cn/terms\" target=\"_blank\">服务条款</a>。",
    "billing.planform.pbx.auto_remove_unlimited_addons_info": "\u4F60\u5DF2\u79FB\u9664\u56FD\u9645\u4E0D\u9650\u65F6\u901A\u8BDD\u5957\u9910\u7684\u6240\u6709\u7B26\u5408\u6761\u4EF6\u7684\u5957\u9910\uFF0C\u7EE7\u7EED\u64CD\u4F5C\u524D\u8FD9\u4E9B\u5957\u9910\u5C06\u4ECE\u8BA2\u5355\u4E2D\u79FB\u9664\u3002",
    "billing.planform.pbx.auto_remove_unlimited_addons_title": "\u56FD\u9645\u4E0D\u9650\u65F6\u901A\u8BDD\u5957\u9910\u5C06\u88AB\u79FB\u9664",
    "billing.zoom_one_pro.desc": "将会议、团队聊天、白板、电话等功能集于一体的统一解决方案",
    "billing.terms.marketing_word": "I would like to receive marketing communication from Zoom. I understand that I can unsubscribe at anytime.",
    "billing.error.edu_invalid_emial_msg": "您的电子邮件地址不能用于注册教育账户。请使用教育域的电子邮件地址或<a href=\"/contactsales\" target=\"_blank\">联系销售人员</a>进行人工验证。",
    "billing": {
      "invoice": {
        "warning": "要完成您的购买，您需要随同新购买一起支付未结发票。",
        "cart": {
          "label": "未结发票",
          "unit": "{0} 张发票",
          "with_credit_balance_desc": "今天的总额包括您以往订阅的未结发票，其中包括已计入发票总额的未使用天数的 {0} 额度。"
        }
      },
      "bill_monthly": "按月计费",
      "bill_annually": "按年计费",
      "bill_quarterly": "按季度计费",
      "bill_two_years": "每两年计费一次",
      "bill_three_years": "每三年计费一次",
      "limited_features": "功能受限",
      "docs": {
        "docs": "Docs",
        "features_item1": "AI Companion 可生成内容并提供翻译",
        "features_item2": "与团队共享的文档数量不受限制",
        "features_item3": "可访问的版本历史记录不受限制",
        "comparison_table_tips": "使用 AI 文档有序保存构思内容和信息，以便适应不同团队和项目需求。"
      },
      "tasks": {
        "tasks": "Tasks",
        "features_item1": "利用 AI Companion 的强大功能从您的聊天、电子邮件、文档、白板和会议摘要中识别和创建任务",
        "features_item2": "轻松进行排序、过滤、分组和搜索，以快速访问和收集任务的背景信息",
        "tooltip": "通过在 Zoom Workplace 中根据对话和会议摘要提供任务建议的 AI 优先解决方案，随时了解并按时完成行动项目。",
        "comparison_table_tips": "通过在 Zoom Workplace 中根据对话和会议摘要提供任务建议的 AI 优先解决方案，随时了解并按时完成行动项目。"
      },
      "zoom_docs": {
        "title": "Zoom Docs",
        "plan_details": {
          "desc2": "在一个文档中轻松编写文本、图片等内容",
          "desc3": "可在会议期间以及非会议期间通过任何设备开展协作",
          "desc4": "轻松访问和恢复文档历史记录"
        },
        "current_account_includes_zoom_docs": "您账户中的每个授权用户都可以访问 Zoom Docs。如果您购买更多名额，您可以将其分配给账户中的任何基础版用户。"
      },
      "modal": {
        "tips": "需要验证免税？",
        "proceed_to_checkout": "前往结账",
        "payment_not_support_modal_tips": "{0} 仅支持在新浏览器窗口中使用，您需要在其中重新输入您的账户信息。",
        "continue_with_paypal": "继续使用 PayPal",
        "apple_pay_modal_tips": "{0} 仅支持在运行 Safari 浏览器的符合条件的 Apple 设备上使用，您需要在其中重新输入您的账户信息。 $zh-TW: {0} 僅支援執行 Safari 瀏覽器的合格 Apple 裝置，您需要重新輸入帳戶資訊。",
        "continue_with_apple": "继续使用 Apple Pay",
        "continue_with_google": "继续使用 Google Pay",
        "your_account": "您的账户"
      },
      "comparison": {
        "required_in_most_plans": "对于大多数套餐为必选项",
        "include_in_most_plans": "包含在大多数套餐中",
        "30_hours": "30 小时",
        "hubSpot_integration": "HubSpot 集成",
        "salesforce_integration": "Salesforce 集成",
        "included_in_zoom_webinars_attendees": "包含在 Zoom Webinars 订阅、一个月套餐以及适合 20,000 至 100,000 名观众的单次使用套餐中。",
        "in_webinar_chat_only": "仅限网络研讨会中聊天",
        "compare_all_features": "比较所有功能",
        "footer_desc": {
          "feature": "对于没有付费 Zoom One 套餐的客户，购买单次 Zoom Webinars 套餐后，即可获得三个月的 Zoom One 专业版访问权限。",
          "event_attributes": "对于单次 Zoom Webinars 套餐，超过三小时的网络研讨会可能需要额外的付费咨询服务。如需了解更多信息，请<a href=\"https://explore.zoom.us/en/event-services/\">联系活动服务</a>",
          "audience_engagement": "适合 250,000 名以上观众的单次套餐的功能可用性因咨询服务支持而异。",
          "integration": "不包含在适合 250,000 名以上观众的单次 Zoom Webinars 套餐中。",
          "additional_features": "单次 Zoom Webinars 套餐包含五小时。"
        }
      },
      "message": {
        "billing_cycle_update_alert": "The billing cycle for the {0} plan has been updated to {1}, which is required for purchasing the {2} {3} subscription.",
        "undo_change": "Undo change"
      },
      "zcm": {
        "title": "由 Theta Lake 提供技术支持的 Zoom Compliance Manager",
        "description": "使用专用的归档、电子取证和数据治理解决方案精简合规性。",
        "select_license_tip": "一个许可证适用于您账户中的一个用户。",
        "max_license": "上限为 {0} 个许可证。",
        "license_count_tool_tip": "Zoom Compliance Manager 许可证数量必须等于或小于 {0} 用户数量。您可以在“套餐管理”中编辑您的 {0} 许可证数量。",
        "plan_details": {
          "desc1": "简化会议、网络研讨会、团队聊天等的通信和协作归档",
          "desc2": "使用电子取证的搜索功能轻松查找重要的通信记录",
          "desc3": "直接在 Zoom Web 门户中简化归档、电子取证和合法持有要求",
          "desc4": "每个许可证可访问 10 GB 的存储空间（可根据需要购买更多存储空间）"
        }
      },
      "zcm_storage": {
        "title": "Zoom Compliance Manager 由 Theta Lake 提供技术支持 - 附加存储空间",
        "description": "您的账户包含 {0}（每个许可证）的存储空间。添加更多存储空间以在账户中的所有授权用户之间共享。"
      },
      "vat_SN_message": "如果您已登记增值税，请输入税号，它将显示在向您开具的发票上。",
      "vat_SN_placeholder": "税号",
      "uin_placeholder": "Unique Identification Number",
      "empty_tin": "Tax number is required",
      "invalid_tin": "This tax number is not valid",
      "state_mismatch": "Your State/province under the Address field and the GST number are not aligned. Please verify and update the correct details in the State/province in the Address field and/or the GST number",
      "empty_uin": "Unique Identification Number is required",
      "invalid_uin": "or invalid Unique Identification Number. Please check and validate that both your TRN and UIN are valid.",
      "zone_pro_plus": {
        "title": "Zoom Workplace 专业加强版",
        "select_local_number_title": "选择用户数量",
        "select_local_number_desc": "每位用户都将获得一个本地号码，可无限制拨打区域电话。最小数量为 1 个用户。",
        "explore_other_plans_cta": "了解其他套餐",
        "pbx_base_title": "如何处理地区费用和国际费用？",
        "brief_title": "专业加强版",
        "max_user_tips": "最大数量为 {0} 个用户。",
        "pro_plus_phone_features": "Chat only"
      },
      "zoom_enterprise_named_host": {
        "title": "Zoom 企业版指定主持人"
      },
      "zoom_one_pro": {
        "set_up_success_msg": "What's next? Set up your new plan to get your organization and team members up and running."
      },
      "zoom_one_biz": {
        "set_up_success_msg": "What's next? Set up your new business plan to get your organization and team members up and running.",
        "continue_with_lm": "是否要继续举办参会者人数超过 100 人的会议？ 使用<a href=\"#\">大型会议</a>增加会议容量",
        "unlock_license_limit": "现在您可以将用户数量设置为 10 以下。",
        "license_limit_with_lm": "Large Meeting 购买要求 Zoom Workplace Pro 许可证的数量等于或大于当前分配给您账户中的用户的 Zoom Workplace Business 许可证数量。"
      },
      "zoom_clips_plus": {
        "title": "Zoom Clips Plus",
        "easily_record_desc": "轻松录制、编辑和共享短视频",
        "unlimited_videos_desc": "无限制的视频和高级功能",
        "current_account_includes_zoom_clips": "账户中的每个 Zoom One 授权用户都可以访问 Zoom Clips。 如果您购买更多名额，您可以将其分配给账户中的任何基本用户。"
      },
      "trial": {
        "title": "\{0\} 免费试用",
        "duration_desc_cart": "\{0\} 天免费试用",
        "start_date": "\{0\} 开始",
        "unit_suffix": "试用结束后 \{0\}",
        "trial_charge_terms_desc": "您的 {0} 天免费试用将于 {1} 结束。 除非您在 {1} 前取消，否则将收取您 {2}，以及 {3} 周期性订阅的适用税费。 付费订阅会自动续订，直到您取消为止。 在续订前一天，您可以导航到 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a> 取消自动续订。",
        "trial_manually_title": "您即将完成",
        "trial_manually_title2": "分配您的免费试用",
        "trial_manually_assign": "请选择“用户管理”，以验证免费试用是否已自动分配给您账户上的正确用户。",
        "trial_manually_assign2": "您的免费试用已开始。 要开始使用，请将许可证分配给您自己或您账户中的一个用户。",
        "trial_manually_assign_btn": "分配给用户",
        "trial_auto_assign_title": "您现在可以开始 \{0\} 免费试用了",
        "trial_auto_assign_subtitle": "下一步操作是什么？ 设置您的 \{0\} 以充分利用您的免费试用体验。",
        "start_free_trial_btn": "设置 \{0\}",
        "buy_trial_success": "您的免费试用已开始。 设置您的 \{0\} 以充分利用您的免费试用体验。",
        "upgrade_paid_success": "您的免费试用已升级为付费套餐",
        "upgrade_paid_success_desc": "此订阅从 {0} 开始。 我们已向您收费 {1}。 本订阅将于 {2} 自动续订。",
        "ineligible_hint": "您的账户 {0} 不符合 {1} 的条件。 如果要使用 {2}，请购买套餐。",
        "ineligible_hint_nn": "很抱歉，您不符合免费试用 {0} 的条件。",
        "trial_days_free": "{0}-day free",
        "paid_plan_required_when_add_plans": "\{0\} requires a paid {1}, Your {2} will automatically convert to a paid subscription when you place the order.",
        "paid_plan_required_when_add_plans_confirm_title": "Confirm order to start paid subscription",
        "paid_plan_required_when_add_plans_confirm_content": "After placing the order, your {0} will be canceled, and you will be automatically enrolled into a paid subscription.",
        "saas": {
          "trial_success_desc": "在 Zoom Events 平台上发布具有视频点播、多样化视频布局等功能的免费活动。"
        },
        "webinar": {
          "back_to_webinar": "返回到 webinars"
        },
        "try_for_n_days": "试用 {0} 天",
        "or_buy_now": "或立即购买",
        "free_trial": "免费试用"
      },
      "landing": {
        "zone": {
          "solution": {
            "title": "一体化解决方案的优势",
            "audio": "体验一流的视频和音频质量以及 Zoom 标志性的易用性",
            "upvote": "利用全面的通信和协作工具，加强员工和客户关系",
            "computer_desk": "使用单个应用简化工作流程、提高工作效率并减少应用疲劳",
            "v1": {
              "audio": "智能协作工具让项目不断推进，而简化的功能让您可以从聊天中发起呼叫或会议，或在白板上进行协作。",
              "upvote": "滤镜、表情、问卷、举手以及音乐或视频共享功能，为虚拟会议增添乐趣，使会议更具吸引力。",
              "computer_desk": "一个易于使用的通信平台，您可以从移动设备或台式机获得无缝、自动化的用户体验。"
            }
          },
          "question": {
            "title": "常见问题解答",
            "tools_introduce": {
              "title": "什么是协作工具？",
              "desc": "协作工具提供各种方法让团队能够通过视频、聊天、电话和白板共享信息。"
            },
            "tools_advantages": {
              "title": "使用在线协作工具有哪些优势？",
              "desc": "分散各处的团队成员能够通过在线协作工具更轻松地进行头脑风暴、共享信息并完成工作。"
            },
            "tools_work": {
              "title": "协作工具如何工作？",
              "desc": "协作工具提供不同方式与内部和外部各方进行交互和通信，让您可以轻松共享文件、想法、更新等。"
            },
            "tools_type": {
              "title": "有哪些不同类型的协作工具？",
              "desc": "协作工具提供电话用于拨打电话；提供视频用于开展在线会议；提供聊天用于一对一私聊、团队消息收发和文件共享，以及提供拖放式白板供人员进行头脑风暴。"
            },
            "tools_effective": {
              "title": "在线协作是否有效？",
              "desc": "可以！ 在线协作非常有效，因为无论团队位于何处或在哪个时区，相互之间都可以轻松交谈和协作。"
            },
            "tools_use": {
              "title": "我应该在哪里使用协作工具？",
              "desc": "可在家中、办公室、会议室、汽车、飞机等任何地方使用协作工具！"
            }
          },
          "feature": {
            "elevate": {
              "title": "使用 Zoom One 提升您的工作流程",
              "subtitle": "体验更顺畅的通信和无缝集成，改变您的创建、协作和创新方式。"
            },
            "ai_title": "智能 AI 助手",
            "ai_desc": "通过 Zoom AI Companion 的摘要、撰写等智能功能，提高工作效率和团队效率。",
            "zwb_title": "数字白板",
            "zwb_desc": "利用我们持久的虚拟协作空间进行头脑风暴、规划和学习。 Zoom Whiteboard 可让团队随时随地利用便笺、绘图工具、注释等轻松进行构思。",
            "mail_title": "邮件和日历",
            "mail_desc": "我们的电子邮件和日历解决方案支持 Microsoft 365、Google 或 Zoom Mail 和 Calendar 服务，可将您的重要通信整合到一起。",
            "clips_title": "视频片段",
            "clips_desc": "使用 Zoom Clips 简化日常通信。 录制、编辑和共享高质量的短视频消息，节省来回聊天的时间，缩短会议时间。",
            "meeting_title": "虚拟会议",
            "meeting_desc": "通过可靠的高清音频和视频互动将团队凝聚在一起。 Zoom Meetings 专为现代团队打造，具有屏幕共享、聊天和翻译等协作和包容功能。",
            "chat_title": "团队聊天",
            "chat_desc": "通过我们与 Zoom 产品和第三方应用紧密集成的持久性团队协作解决方案 Zoom Team Chat，在聊天和渠道之间保持信息畅通和有序。",
            "phone_title": "电话系统",
            "phone_desc": "使用我们适用于各种规模企业的可靠、功能丰富的云电话系统，在任何设备上拨打和接听电话。 Zoom Phone 易于部署，专为现代协作时代而打造。",
            "scheduler_title": "计划程序",
            "scheduler_desc": "使用 Zoom Scheduler 在会议召开的地方安排会议。 您可以取消不必要的日程安排应用，从而节省时间和金钱。",
            "workspace_title": "工作区预订",
            "workspace_desc": "用现代化的工作解决方案提升您的办公体验。 借助 Zoom 工作区预约功能，您可以让混合式会议更具包容性，并支持灵活的工作区。",
            "notes_title": "笔记",
            "notes_desc": "Zoom Notes 是一款专用的内置笔记应用程序，可让您快速捕捉想法、行动项目等，从而更有效地开展协作。",
            "cmr_title": "云录制",
            "cmr_desc": "使用 Zoom 云直接存储、流式传输和下载您的视频录制文件。",
            "scheduler_desc_v1": "轻松共享用于办公时间、访谈等的会议时段。"
          }
        }
      },
      "video_sdk_uc": {
        "title": "Zoom SDK Universal Credit",
        "subtitle": "Maximize building with bundled products and the flexibility of prepaid credits for all SDK service plans.",
        "credit_rates_cta": "Credit rates",
        "select_plan_title": "Select your plan",
        "feature_title": "Includes SDK, plus:",
        "credits_unit": "/month/{0} credits",
        "feature_bundle": {
          "title": "All-in-one bundled solution",
          "desc": "Access all SDK service plans with a single subscription"
        },
        "feature_flexible": {
          "title": "Flexible credit usage for any SDK service",
          "desc": "Apply credits to any SDK services, including Translations, QSS, CRC, and more"
        },
        "feature_recommend": {
          "title": "Get greater savings with a {0} credits plan",
          "desc": "Receive more credits each month while spending less"
        },
        "feature_for_future": {
          "title": "Apply credits to future SDK products",
          "desc": "Never miss the opportunity to use upcoming SDK services"
        },
        "feature_cobrowsing": {
          "title": "Cobrowse SDK",
          "desc": "Secure, real-time screen sharing with sensitive data masking"
        },
        "credit_rate_dialog": {
          "title": "Zoom SDK Universal Credit Value",
          "subtitle": "Usage from each product included will be converted into credits. For example, {amount} {currency} or {credit} credits for a Video SDK Session is worth {time} mins.",
          "desc": "*The SDK service usage is determined by monthly meeting session minutes. For example, five users in a ten minute meeting will count as 50 minutes. Partial minutes are rounded up.",
          "note1": "对于视频 SDK 会话的使用，其衡量依据应该是客户和/或客户应用程序用户发起的会话在一个月内的会话分钟总数（“会话分钟数”）。例如，如果有五（5）个最终用户通过客户应用程序参加 10 分钟的会话，那么使用的会话分钟总数将为五十（50）分钟。使用的非整数分钟数将四舍五入。",
          "note2": "一分钟转录会消耗一分钟标准转录时间。一分钟翻译会消耗两分钟标准转录时间。",
          "note3": "云录制分钟数包括合成录制和/或单独录制。",
          "note3_1": "合成录制将网格中的所有参会者视频都包含在一个视频帧中。此录制选项按每个会话持续时间一分钟的录制时间计量。",
          "note3_2": "单独录制允许将选定的个别参会者录制到每个参会者的单独视频中。此录制选项按每个录制的单独视频流分钟数一分钟的录制时间计量。"
        },
        "table_column_label": {
          "service_plan": "Service Plan",
          "rate": "Rate",
          "see_rate_cta": "See rate"
        },
        "switch_desc": "Want to switch to the Pay As You Go plan for the flexibility to pay exclusively for the SDK service?",
        "switch_cta": "Switch now"
      },
      "zoom_united": {
        "pro": "Zoom\u878d\u5408\u5957\u9910\u4e13\u4e1a\u7248",
        "biz": "Zoom\u878d\u5408\u5957\u9910\u5546\u4e1a\u7248"
      },
      "toll_free": "\u4E3B\u53EB\u514D\u8D39\u7535\u8BDD",
      "premium_call_in_numbers": "\u6536\u8D39\u7535\u8BDD\uFF08\u57FA\u4E8E\u8D39\u7528\uFF09",
      "call_out": "\u62E8\u51FA",
      "search_countries": "\u6309\u56FD\u5BB6/\u5730\u533A\u641C\u7D22",
      "countries_regions": "\u56FD\u5BB6/\u5730\u533A",
      "tel": {
        "landline": "\u56FA\u5B9A\u7535\u8BDD",
        "mobile": "\u79FB\u52A8\u7535\u8BDD"
      },
      "addAnother": {
        "large": "+ 添加其他大型会议套餐",
        "webinar": "+ 添加其他网络研讨会套餐",
        "events": "+ 添加其他活动套餐",
        "sessions": "+ 添加其他会话套餐"
      },
      "zr": {
        "desc": "通过专为混合团队设计的高清视频会议，与其他人实时互动，享受无缝会议室体验。",
        "feature": {
          "wb": "包括 Zoom Whiteboard 加强版",
          "meeting_zr": "一键加入会议室",
          "wireless": "一键无线近距离共享",
          "share": "无线多方共享"
        },
        "remove_assigned_license": "您目前有 {0} 个已分配的会议室。 更新套餐后，请从“Zoom Rooms 管理”删除 {1} 个已分配的会议室（截止时间为 {2}），以完成降级。",
        "remember_remove_rooms": "在 {1} 之前，请记得在“Zoom Rooms 管理”中删除 {0} 个会议室。 <br/><br/>一旦成功删除会议室，系统将进行降级处理。",
        "unassign_rooms": "取消分配会议室",
        "max_license_alert": "如果您想购买 {0} 个或更多会议室，请<a href=\"/contactsales\" target=\"_blank\" class=\"opc-zr-max-license-alert\">联系销售人员</a>。",
        "license_unit": "会议室"
      },
      "rc": {
        "desc": "支持无缝集成，使任何使用 Microsoft、Google 或任何基于标准的 SIP/H.323 视频会议端点的人员都可加入 Zoom Meetings。",
        "remove_assigned_license": "您目前有 {0} 个已分配的端口。 更新套餐后，请从“Zoom Rooms 管理”删除 {1} 个已分配的端口（截止时间为 {2}），以完成降级。",
        "max_license_alert": "上限为 {0} 个端口。",
        "license_unit": "端口",
        "license_tooltips": "每个端口订阅每次允许 1 个设备连接您账户中的所有会议。"
      },
      "zobizplus": {
        "add_another": "+ 添加其他区域",
        "unlimited_desc": "每位用户都将获得一个本地号码，可无限制拨打区域电话。",
        "unlimited_license_desc": "您至少需要有 10 名用户才能完成购买。",
        "atlease_desc": "您至少需要有 {0} 名用户才能完成购买",
        "promo_biz_desc": "要满足 10 名用户的最低要求，您可以在购买时添加此套餐。",
        "promo_biz_title": "需要非 Zoom Phone 用户？",
        "UC": "无限通话",
        "required_license_warning": "您的 Zoom One 用户总数必须至少为 {0} 名。",
        "required_license_alert": "若要删除此套餐的用户，请返回到“套餐管理”并调整 Zoom One 用户，以便在合并两个套餐时可以满足 {0} 名用户的最低要求。 <a href=\"/billing\">返回到“套餐管理”</a>",
        "pending_change": "您已申请对此套餐进行更改。 如果您想编辑此套餐，请<a href=\"/billing\">返回到“套餐管理”</a>并删除您的申请。",
        "auto_add_message": "{0} 用户人数现已更新为满足 {1} 名用户的最低要求。",
        "set_up_new_biz_plus_success_msg": "下一步操作是什么？ 设置新的商业加强版和电话套餐以便您的组织和团队成员可以正常使用。",
        "subscription_cycle_same_as_other_plan": "The subscription cycle for {0} needs to be the same as {1}."
      },
      "got_it": "\u77E5\u9053\u4E86",
      "cancel_title_sorry_to_see_you_go": "\u5F88\u9057\u61BE\u770B\u5230\u60A8\u79BB\u5F00\uFF01",
      "clips": "Zoom Clips",
      "clips_plus": "Clips Plus",
      "notes": "备注",
      "ai_companion": "AI Companion",
      "events": {
        "compare_feature_title": "它们有何区别？",
        "onlyForAttendeesDesc": "仅适用于 {0} 名观众",
        "requireTitle": "*所有套餐均需要 Zoom One 许可证",
        "capacityInfo": {
          "title": "{0} 中的观众人数",
          "ppa": {
            "desc": "选择按观众付费套餐后，购买的观众名额将决定自购买之日起的 12 个月内，总共有多少观众可以参加您举办的所有活动。 <br/><br/>如果超出购买的观众名额，将按每位观众 {0} 向您收取费用。"
          },
          "saas": {
            "desc": "选择订阅套餐后，购买的 {0} 许可证数规定了可以参加 {0} 中的每场会议或每场网络研讨会的观众人数上限。"
          },
          "xx_license_amount": "{0} 许可证数量",
          "max_allowed_in_webinar": "活动中的每场网络研讨会允许参加的观众人数上限",
          "max_allowed_in_meeting": "活动中的每场会议允许参加的观众人数上限"
        },
        "eventSaas": {
          "desc": "成功举办更多混合式活动或虚拟活动。 通过社交功能、展会大厅等功能，提高观众参与度。"
        },
        "eventSaasCore": {
          "desc": "借助 Zoom Sessions 举办更具吸引力的活动。 获得高级品牌推广和活动后分析等付费活动功能。"
        },
        "saas": {
          "title": "订阅",
          "tooltips": "<strong>订阅</strong>支持您以所选人数举办不限次数的活动。",
          "capacityTips": "与已购 {0} 许可证相关联的观众人数规定了每场活动允许的观众人数上限。",
          "freeTrialDescriptions": {
            "duration": "\{0\} 天免费使用 Zoom Sessions",
            "capacity": "主持一场最多可容纳 \{0\} 名观众的活动（无付费门票）",
            "publish": "发布一个视频点播（仅限 Zoom Events 中心）",
            "cancel": "随时取消",
            "requirement": "免费试用期间需要具有有效的网络研讨会许可证"
          }
        },
        "ppa": {
          "title": "按观众付费",
          "tooltips": "<strong>按观众付费</strong>许可证规定了自购买之日起的 12 个月内，总共有多少观众可以参加您的账户所举办的所有活动。",
          "attendeeTips": "已购观众人数规定了在购买后的 12 个月内有多少观众可以参加您举办的所有活动。"
        },
        "webinarSetUp": {
          "title": "门户网站中的网络研讨会设置"
        },
        "zoom_events_tooltip": "Since you've already added all available monthly subscriptions for {0}, you can only add annual subscriptions for {0}",
        "title_for_events": "Events",
        "title_for_sessions": "Sessions",
        "concurrentEvents": {
          "title": "同时进行的活动",
          "tooltips": "<strong>订阅</strong>套餐支持直播活动，而<strong>按观众付费</strong>套餐允许同时进行直播活动。"
        },
        "overages": {
          "title": "超额"
        },
        "eventsPlatformHubs": {
          "title": "Zoom Events 平台中心",
          "saas": "{0} 中心/许可证",
          "ppa": "{0} 个中心",
          "tooltips": "Zoom Events <strong>中心</strong>可以便捷地安排活动，允许主持人根据特定主题对相关活动进行分组。"
        },
        "eventsPlatformHosts": {
          "title": "Events 平台主持人",
          "subTitle": "{0} 名观众或更多观众",
          "saas": "{0} 名中心主持人",
          "ppa": "{0} 名中心主持人",
          "tooltips": "Zoom Events <strong>中心主持人</strong>可以创建、编辑并发布由中心所有者创建的活动。"
        },
        "attendees": "{0} 名观众",
        "plan_details": {
          "webinar_desc": "简单的设置解决方案，适用于可容纳 100 名以上互动嘉宾的大型网络研讨会。",
          "events_desc": "具有强大注册和交流功能的先进活动平台。 适用于举办虚拟活动和混合式活动。",
          "sessions_desc": "利用活动品牌化设置、多主持人协作和活动管理等功能简化交互式单场会议活动。",
          "core_features": "核心功能"
        },
        "addon": {
          "ze_hub_hosts_title": "Zoom Events 追加的中心主持人",
          "zs_hub_hosts_title": "Zoom Sessions 追加的中心主持人",
          "ze_co_editors_title": "Zoom Events 追加的合编者",
          "zs_co_editors_title": "Zoom Sessions 追加的合编者",
          "hub_hosts_desc": "同一组织内添加到某个中心的中心主持人可以创建、编辑和发布由中心所有者创建的活动。",
          "co_editors_desc": "合编者可以与主持人合作并为其提供帮助，具体方式包括参与活动，编辑活动内容或发布活动。",
          "hub_hosts_attendees_desc": "500 名观众以上的套餐包括 4 名中心主持人，100 名观众套餐包括 1 名中心主持人。",
          "hub_hosts_attendees_desc_new": "5 host seats (1 hub owner and 4 hub hosts) are included in the 500+ attendees plan, and 2 host seats (1 hub owner and 1 hub host) are included in the 100 attendees plan.",
          "co_editors_attendees_desc": "500 名观众以上的套餐包括 3 名合编者，100 名观众或 100 名观众以下的套餐包括 1 名合编者。",
          "hub_hosts": "中心主持人",
          "co_editors": "合编者",
          "maximun_alert_message": "上限为 20 个 {0}。",
          "hub_hosts_unit": "Hub 主持人",
          "co_editors_unit": "合编者",
          "monthly_hub_host": "/月/中心主持人",
          "annual_hub_host": "/年/中心主持人",
          "monthly_co_editor": "/month/co-editor",
          "annual_co_editor": "/year/co-editor",
          "monthly_host": "/month/host",
          "annual_host": "/year/host",
          "quarterly_hub_host": "/quarterly/hub host",
          "two_years_hub_host": "/two years/hub host",
          "three_years_hub_host": "/three years/hub host",
          "quarterly_host": "/quarterly/host",
          "two_years_host": "/two years/host",
          "three_years_host": "/three years/host",
          "quarterly_co_editor": "/quarterly/co-editor",
          "two_years_co_editor": "/two years/co-editor",
          "three_years_co_editor": "/three years/co-editor",
          "ze_hub_hosts_tips": "除了随附的主持人名额外，您最多可以购买 20 个可在 Zoom Event 平台使用的中心主持人名额。 您必须将自己的主持人名额分配给 Zoom Events 平台上的用户。",
          "zs_co_editors_tips": "除了许可证中随附的合编者名额外，您最多可以再购买 20 个合编者名额。 您必须将自己的合编者名额分配给 Zoom Events 平台上的用户。",
          "hosts": "主持人"
        },
        "ppa_terms_condition_imme": "当您继续应用此优惠券时，按观众付费方式购买的 Zoom Events 和按观众付费方式购买的 Zoom Sessions 中的任何剩余观众数将被立即取消而不予退款。",
        "ppa_terms_condition_pending": "如果继续使用此优惠券，按观众付费方式购买的 Zoom Events 和按观众付费方式购买的 Zoom Sessions 中的任何剩余观众数将在 {0} 之前被取消且不予退款。 在此日期之前，您仍然可以将剩余观众数用于已安排的活动和新活动。"
      },
      "company_organization_legal": "\u516C\u53F8\u6CD5\u5B9A\u540D\u79F0",
      "company_organization_learn_more": "The Legal Company Name will be the legal name displayed on invoices issued to you and where applicable, used for e-invoicing. No retrospective adjustments will be allowed to the Legal Company Name once an invoice has been issued.",
      "plan1_to_plan2": "{oldPlan} 至 {newPlan}",
      "zone_ppm": {
        "title": "Zoom One 会议延长",
        "banner_tips": "在此会议结束前完成购买",
        "config_desc": "Zoom One 会议延长将适用于当前正在进行的会议。 如果您在当前会议结束后完成此购买，此延长将存储在您的账户中，并在接下来的 30 天内可用于将来的会议。",
        "bill_info": "会议正在进行  •  最长持续时间：{extensionTime} 小时 •  {amount}",
        "one_time": "一次性",
        "comments": {
          "instant_extension": "即时延长",
          "instant_extension_desc": "会议在结账后立即延长",
          "one_time_purchase": "一次性购买",
          "one_time_purchase_desc": "无需订阅"
        }
      },
      "tollfree": {
        "telephony": "Telephony",
        "desc": "会议的扩展音频解决方案包括高质量的 VoIP、收费拨入服务、全球免费接入和专用拨入号码。",
        "audio_conferencing": {
          "title": "音频会议",
          "desc": "音频会议套餐按每个国家/地区的每次通话收费。 每月超出的使用量将收取额外费用。 <a href=\"{0}\" class=\"zm-button zm-button--link\" target=\"_blank\">查看音频会议费率<i class=\"zm-icon-window-new\"></i></a>",
          "montly_desc": "\u97f3\u9891\u5957\u9910\u7684\u8d77\u4ef7\u4e3a{0}/\u6708\uff0c\u6839\u636e\u6bcf\u4e2a\u56fd\u5bb6/\u5730\u533a\u6bcf\u901a\u7535\u8bdd\u7684\u8d39\u7387\u8ba1\u8d39\u3002\u5982\u8d85\u8fc7{0}/\u6708\u7684\u4fdd\u5e95\u901a\u8bdd\u8d39\u7528\uff0c\u5219\u9700\u8981\u6839\u636e\u6240\u5217\u8d39\u7387\u652f\u4ed8\u8d85\u989d\u8d39\u3002",
          "pay_you_go_desc": "\u6839\u636e\u4f7f\u7528\u7684\u5206\u949f\u6570\u548c\u6807\u51c6\u7684\u6bcf\u5206\u949f\u8d39\u7387\u8ba1\u7b97\u8d39\u7528\u3002"
        },
        "audio_us_ca": {
          "title": "\u7f8e\u56fd\u4e0e\u52a0\u62ff\u5927Zoom\u97f3\u9891\u5957\u9910",
          "desc": "该套餐包含每月每个主持人不限时美国/加拿大被叫付费号码和呼出功能"
        },
        "desc_for_sdk": "Enhance your video sessions with call-out functionality by calling others to join the session by phone (available in select countries)",
        "need_beyound_us_ca": "\u9700\u8981\u6dfb\u52a0\u7f8e\u56fd\u4e0e\u52a0\u62ff\u5927\u4ee5\u5916\u7684\u56fd\u5bb6/\u5730\u533a\uff1f",
        "view_rates_link": "<a href=\"{0}\" class=\"zm-button zm-button--link\" target=\"_blank\">\u67e5\u770b\u97f3\u9891\u5957\u9910\u8d39\u7387</a>",
        "audio_conferencing_plan": "音频会议套餐",
        "enable_countries_regions": "\u542f\u7528\u547c\u53eb\u56fd\u5bb6/\u5730\u533a",
        "enable_countries_regions_desc": "\u663e\u793a\u7684\u6240\u6709\u8d39\u7387\u5747\u6309\u6bcf\u5206\u949f\u6bcf\u4f4d\u53c2\u4f1a\u8005\u8ba1\u8d39\u3002",
        "add_additional_countries_regions": "+ 添加其他国家/地区",
        "add_us_ca_audio": "+ 添加美国和加拿大 Zoom 音频",
        "require_equal_number_for_audio_unlimited": "每次购买的音频会议许可证数必须与 Zoom One 商业版用户数一致",
        "require_equal_number_for_audio_unlimited_alert": {
          "meeting_only": "You must have an equal number of Zoom One users for each Audio Conferencing license purchase. If you’d like to have a different number of licenses, update your Zoom One plan in <a href=\"/billing\">Plan Management</a>",
          "meeting_and_rooms": "Your Audio Conferencing plan license number must equal the sum of your Zoom Rooms and Zoom One licenses. If you’d like to have a different number of licenses, update them in <a href=\"/billing\">Plan Management</a>"
        },
        "require_equal_number_tip": "You must have an equal number of Audio Conferencing license for each Zoom One license purchase",
        "require_equal_number_tip_for_zr": "Your US/CA Audio Plan license number should equal to the sum of your Zoom Rooms license and Zoom One license",
        "update_audio_license_tips": "The license quantity of {0} is now updated to match the license quantity of {1}.",
        "audio_addon_desc": "所有付费套餐都随附本地付费号码，但音频套餐允许您针对收费国家/地区添加呼出、全球免费和本地拨入功能",
        "choose_one_option_tpc": "\u4ECE\u514D\u8D39\u7535\u8BDD\u3001\u4ED8\u8D39\u7535\u8BDD\u548C\u547C\u53EB\u7535\u8BDD\u4E2D\u81F3\u5C11\u9009\u62E9\u4E00\u9879\u3002",
        "select_at_least_one_country": "Please select at least one country/region",
        "dedicated_dial_in_number": {
          "title": "专用拨入号码",
          "desc": "专用拨入号码允许你的参会者无需输入会议号即可加入音频会议。",
          "exceed_tip": "The number of Dedicated Dial-In Numbers you have on your account cannot exceed the number of users on your Zoom One plan. Please either increase the number of Zoom One plan hosts in <a href=\"/billing\">Plan Management</a> or decrease the number of Dedicated Dial-In Numbers in your selection to continue. Have questions? <a href='/billing/contactus' target='_blank'>Contact us</a>"
        }
      },
      "annual_cost": "年度成本",
      "monthly_cost": "月成本",
      "upfront": "前期",
      "prepaid": "已预付",
      "pay_you_go": "即付即用",
      "estimated_tax": "估算税款",
      "credit_balance": "应用的贷方余额",
      "see_more_details": "查看更多详细信息",
      "your_products": "您的产品",
      "consumption_cancel": {
        "switch_to_monthly": "Switch to Monthly",
        "switch_to_monthly_questionmark": "Switch to Monthly?",
        "switch_to_annual": "Switch to Annual",
        "switch_to_annual_questionmark": "Switch to Annual?",
        "immediate_cancel": "Once you switch your {0} subscription to {1}, any remaining attendees from both Zoom Events Pay Per Attendee and Zoom Sessions Pay Per Attendee will be canceled immediately without refunds.",
        "pending_cancel": "Once you switch your {0} subscription to {1}, any remaining attendees from both Zoom Events Pay Per Attendee and Zoom Sessions Pay Per Attendee will be canceled without refunds. You can use your remaining attendees for scheduled and new events with overages until {2}.",
        "go_back": "Go Back"
      },
      "bank_transfer": {
        "message": "<div class=\"apm-furikomi-success\">请务必在 {0} 天内按照银行转账说明通过 Furikomi 完成付款（要求填写准确金额），才能保持订阅处于有效状态。我们将与 SMBC 共享部分付款信息，以完成本次银行转账。</div>在收到付款后，我们将通过 {1} 通知您。Zoom 将发送通知电子邮件，向您提醒未来的付款。",
        "bank_information": "Bank information",
        "transfer_funds": "Transfer funds using the following bank information:",
        "bank_code": "Bank code",
        "bank_name": "Bank name",
        "branch_code": "Branch code",
        "branch_name": "Branch name",
        "account_type": "Account type",
        "account_number": "Account number",
        "account_holder": "Account holder",
        "powered_by": "Powered by",
        "stripe": "Stripe",
        "terms": "Terms",
        "privacy": "Privacy",
        "copied_to_clipboard": "Copied to clipboard."
      },
      "processing_payment": "\u6211\u4EEC\u6B63\u5728\u5904\u7406\u60A8\u7684\u4ED8\u6B3E\u3002",
      "notify_when_payment_received": "\u6536\u5230\u4ED8\u6B3E\u540E\uFF0C\u6211\u4EEC\u5C06\u4E8E{0}\u901A\u77E5\u60A8\u8BA2\u9605\u8BE6\u60C5\u3002",
      "checkout": "结账",
      "continue": "继续",
      "plan_details": "套餐详情",
      "please_note": "请注意",
      "whiteboard": "白板",
      "whiteboard_basic": "白板基础版",
      "team_chat": "团队聊天",
      "mail_calendar": "邮件和日历",
      "essential_apps": "基本应用",
      "extras": "赠品",
      "vat": {
        "pe_msg": "提供 RUC 即表示，您声明您已注册秘鲁增值税，并为您在秘鲁开展的商业活动购买 Zoom 服务（而非供私人或家庭使用）。",
        "pe_checkbox": "商业客户",
        "pe_tooltip": "勾选该复选框即表示本人/我们证明本人/我们已注册秘鲁增值税，并为本人/我们在秘鲁开展的商业活动购买 Zoom 服务（而非供私人或家庭使用）。对于因增值税注册信息披露不完整或不准确而造成的问题，Zoom 不承担任何责任。",
        "INR_tax_verified_tip": "I/we understand that Section 16 of the IGST Act 2017 provides that any supply of goods or services to Special Economic Zones (“SEZ”) shall be considered as a zero-rated supply only where such services are used for authorised operations of the SEZ. In this regard, we hereby confirm that the services being provided by ZVC India Private Limited are in relation to the authorised operations of {0}. I/we hereby declare that I/we have obtained GST registration for the SEZ unit(s), under a valid Letter of Approval (\"LoA\") issued by SEZ authorities. In case any fact or information is found to be incorrect or invalid at any given point of time or where the services are not being used for authorised operations of our unit, in addition to any other indemnities or obligations in the Agreement, I/we shall indemnify and hold ZVC India Private Limited harmless, from and against all liabilities of GST amount including interest and penalties, that may arise in addition to any other indemnities or obligations in the Agreement.",
        "msg_by": "如果您是商业客户，请输入您的纳税识别号 (TIN)",
        "checkbox_by": "非商业客户",
        "tooltip_by": "在填写复选框时，我/我们证实，我/我们不是白俄罗斯税务方面的法人实体，且我/我们对于本声明的准确性和完整性承担全部责任。 对于不完整或不准确的声明，Zoom 不承担任何责任。 此外，在证明我/我们不是白俄罗斯应纳税的商业客户时，我/我们接受并理解 Zoom 将对所有应税服务收取订单摘要中所列价格之外的适用税率的增值税。",
        "msg_co": "如果您已注册增值税，请输入您的税号 (RUT)",
        "placeholder_co": "RUT",
        "tooltip_co": "In completing the checkbox I/we certify that the above named business is not 'Responsable de IVA' nor a VAT Collector and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate VAT registration disclosure. Furthermore, in certifying that the above named Business is not 'Responsable de IVA' nor a VAT Collector, I/we accept and understand that Zoom will charge VAT on all taxable services at the applicable rate in addition to the prices listed in Order Summary.",
        "tooltip_cl": "在填写复选框时，我/我们证实，以上列名企业并未进行 VAT 注册，且我/我们对于本声明的准确性和完整性承担全部责任。 对于因 VAT 注册信息披露不完整或不准确而造成的责任，Zoom 不承担任何责任。 此外，在证明上述企业未注册增值税时，我/我们接受并理解 Zoom 将对所有应税服务收取订单摘要中所列价格之外的适用税率的增值税。",
        "tooltip_eg": "在填写复选框时，我/我们证实，以上列名企业/个人并未进行 VAT 注册，且我/我们对于本声明的准确性和完整性承担全部责任。 对于因 VAT 注册信息披露不完整或不准确而造成的责任，Zoom 不承担任何责任。 此外，在证明上述企业/个人未注册增值税时，我/我们接受并理解 Zoom 将对所有应税服务收取订单摘要中所列价格之外的适用税率的增值税。",
        "tooltip_ic": "In completing the checkbox I/we certify that the above named business is not IGIC registered and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate IGIC registration disclosure. Furthermore, in certifying that the above named Business is not IGIC registered I/we accept and understand that Zoom will charge IGIC on all taxable services at the applicable rate in addition to the prices listed in Order Summary.",
        "msg_kr": "输入经营注册号",
        "msg_th": "如果您已注册增值税，请输入您的增值税号",
        "msg_ic": "If you are IGIC registered in Canary Islands, enter NIF",
        "tax_promote_eg": "如果您已注册增值税，请输入税务登记号",
        "tax_registration_number": "税务登记号",
        "tax_requirement": {
          "desc": "I acknowledge that, for the purposes of complying with Saudi tax law, Saudi customers are required to withhold taxes, remit the relevant amounts to the competent authorities, maintain records to prove the correctness of taxes withheld as well as provide Zoom with the respective withholding tax certificate(s). I am aware that failure to comply with such requirements may trigger the application of penalties according to Saudi legislation.<br /><br />Withholding Tax Certificates can be sent to: <a href=\"mailto:{email}\">{email}</a>",
          "invalid_msg": "Please check this box if you want to proceed"
        }
      },
      "buyItNow": {
        "please_note": "Please Note:",
        "cant_continue": "Unable to continue"
      },
      "update": {
        "download_the_zoom_app": "\u4E0B\u8F7DZoom App",
        "download_mac": "MAC",
        "download_mac_m1": "<span>Macs with </span><br />Apple Silicon chips",
        "download_windows": "WINDOWS PC",
        "download_windows_64": "<span>Windows</span><br /> 64-bit",
        "download_windows_arm": "<span>Windows</span><br /> ARM"
      },
      "license_limit_msg": "已选择 {0} 个 {1} 许可证。 {2} 许可证数量不能超过 {3} 用户数量。",
      "select_billing_cycle": "选择订阅周期",
      "add_participants_plan": "另添加 {0} 个参会者套餐",
      "addon_license_limit_tips": "要增加 {0} 的许可证数量，您需要将 {1} 用户数量调整为等于或大于 {0}。 <a href=\"/billing\">返回到套餐管理</a>",
      "addon_license_limit_tips_without_contact": "要增加 {0} 的许可证数量，您需要将 {1} 用户数量调整为等于或大于 {0}。",
      "addon_toggle_more": "查看更多产品",
      "addon_toggle_less": "收起产品信息",
      "addon_auto_add_tips": "您现在正在编辑 {0} 和 {1}",
      "addon_auto_remove_tips": "您现在正在编辑 {0}。 {1} 已删除，因为您有足够的用户数。",
      "add_attendees_plan": "+ 添加 {0} 名观众套餐",
      "licences_limit_tips": "{0} 许可证数量不能超过 {1} 许可证数量。",
      "licenses_assigned_limit_tips": "许可证数量必须等于或大于当前分配给您账户中用户的许可证数量。",
      "license_sync_base": "{0} 用户数现已更新，以匹配 {1} 许可证数",
      "license_sync_addon": "{0} 许可证数现已更新，以匹配 {1} 用户数",
      "need_more_license": "需要 {0} 个或更多许可证？",
      "need_more_license_desc": "{0} 只能支持最多 {1} 位用户和 {2} 个 {3} 许可证。您需要切换到 {4} 套餐才能获得更多许可证。",
      "switch_to": "切换到 {0} 套餐",
      "billing": "计费",
      "storage": "存储空间",
      "attendees": "观众",
      "participants": "\u53C2\u4F1A\u8005",
      "licenses": "Licenses",
      "license": "许可证",
      "billing_cycle": {
        "monthly": "\u6708\u5EA6",
        "annual": "按年",
        "one_month": "单月",
        "one_month_new": "一个月",
        "pay_per_attendee": "按观众付费",
        "quarterly": "季度",
        "two_years": "两年",
        "three_years": "三年",
        "one_time": "单次",
        "subscription": "订阅",
        "subscription_or_one_month": "订阅或一个月"
      },
      "annual_save": "每个用户节省的费用",
      "zone": {
        "meetings": "会议",
        "select_license": "选择用户数量",
        "attendee_info": "每个用户可享受无限制的会议时长，会议最多可以有 {0} 名观众。",
        "attendee_info_edit": "此处列出的许可证计数反映了在进行更改后您希望在账户上拥有的许可证<b>总数</b>。",
        "desc1": "{0} 用户 •  {1}{2}",
        "desc1_monthly": "/月",
        "desc1_annual": "/年",
        "min_of_pro": "最小数量为 1 个用户。",
        "min_of_licenses": "最小数量为 {0} 个用户。",
        "max_of_licenses": "最多 {0} 个用户。",
        "max_of_license_contact_us": "The maximum amount is {0} license. If you want to purchase more, please <a class=\"zm-button zm-button--link opc-link-btn\" href=\"/contactsales\" target=\"_blank\">Contact Sales</a>.",
        "max_of_pro": "最多 9 个用户。",
        "max_of_pro_99": "最多 99 个用户。",
        "min_of_biz": "最小数量为 10 个用户。",
        "min_of_biz_new": "此套餐至少需要 {number} 个用户。",
        "min_of_biz_1": "最小数量为 1 个用户。",
        "biz_combined_bizplus": "将此套餐与 Zoom One 商业加强版结合使用时，您总共需要有 10 名用户。",
        "promo_bizplus": "Suggested for you",
        "max_license_of_biz": "最多 {0} 个用户。 如果您想购买 {1} 个或更多许可证，请<a href=\"/contactsales\" target=\"_blank\">联系销售人员</a>。",
        "max_of_biz": "最多 99 个用户。 如果您想购买 100 个或更多许可证，请<a href=\"/contactsales\" target=\"_blank\">联系销售人员</a>。",
        "max_of_plans": "上限为 {0} 个许可证。 如果您想购买 {1} 个或更多许可证，请<a href=\"/contactsales\" target=\"_blank\">联系销售人员</a>。",
        "max_of_plans_user": "最多 {0} 个用户。 如果您想购买 {1} 个或更多许可证，请<a href=\"/contactsales\" target=\"_blank\">联系销售人员</a>。",
        "explore_other_plans": "了解其他套餐",
        "explore_other_plans_edit": "转换套餐",
        "see_full_feature": "查看完整功能列表",
        "trial": {
          "desc1": "访问所有 Zoom Workplace 专业版功能",
          "desc2": "AI Companion",
          "desc3": "随时取消",
          "select_free_trial": "选择免费试用",
          "trial_charge_terms_desc": "如果您未在免费试用结束前取消，您的订阅将自动续订，并且将通过您登记的付款方式自动收取 {0}（月度订阅）或 {1}（年度订阅）的订阅费。"
        },
        "learn_more_modal": {
          "feature_tip": "通过 AI 驱动的协作平台重塑团队合作方式。",
          "intro1": "不受限制地举办长达 30 小时的会议，最多可容纳 100 名参会者",
          "intro2": "可同时访问最多 3 个具有标准功能的可编辑白板",
          "intro3": "通过 Clips 加强版录制、编辑和共享高质量的短视频消息",
          "intro4": "使用 Zoom AI Companion 更高效地完成工作"
        },
        "host_need_adjust": {
          "title": "将调整您的 Zoom One、{0} 许可证数量",
          "content": "Zoom One 专业版的最大用户数量是 {1} 个用户。 {0} 许可证数量不能超过 Zoom One 许可证数量。"
        },
        "pro_details": {
          "row1": "举办多达 100 名参会者的会议",
          "row2": "不限次数的会议，每次会议限时 30 小时",
          "row3": "5 GB 云录制文件存储空间（每个许可证）",
          "row4": "自动字幕",
          "row5": "3 个可编辑白板",
          "row6": "用于进行协作、文件共享等的聊天和频道",
          "row7": "邮件和日历客户端与服务测试版",
          "row8": "免费使用付费应用 1 年（需遵守条款）",
          "row9": "提高团队协作能力和工作效率"
        },
        "biz_details": {
          "meetings": {
            "row1": "举办多达 300 名参会者的会议",
            "row2": "不限次数的会议，每次会议限时 30 小时",
            "row3": "5 GB 云录制文件存储空间（每个许可证）",
            "row4": "自动字幕"
          },
          "whiteboard": {
            "row1": "无限制的白板"
          },
          "team_chat": {
            "row1": "用于进行协作、文件共享等的聊天和频道"
          },
          "mail_calendar": {
            "row1": "邮件和日历客户端与服务"
          },
          "essential_apps": {
            "row1": "免费使用付费应用 1 年（需遵守条款）",
            "row2": "提高团队协作能力和工作效率"
          },
          "extras": {
            "row1": "单点登录",
            "row2": "托管域",
            "row3": "公司品牌化设置"
          },
          "clips": {
            "row1": "轻松录制、编辑和共享短视频",
            "row2": "无限制的视频和高级功能"
          },
          "ai_companion": {
            "row1": "使用 AI 助手在 Zoom 平台上自动执行关键任务",
            "row1_new": "使用您的智能 AI 助手在 Zoom 平台上自动执行关键任务",
            "row2": "快速获取会议摘要、协助起草消息等"
          },
          "notes": {
            "row1": "在 Zoom 中创建和共享可编辑文档",
            "row2": "具有富文本编辑功能的个人笔记和协作笔记"
          },
          "tips": "起售价为 10 个许可证 {0}/年"
        },
        "alert_title": "每个 {0} 许可证至少需要一个 {1} 用户",
        "edu": {
          "hd": "高清视频和音频",
          "attendees": "300 名观众",
          "wb": "白板",
          "team_chat": "团队聊天",
          "MC": "Mail 和 Calendar"
        },
        "edu_details": {
          "hd": "适用于线下培训与虚拟培训",
          "meetings": "每次会议限时 30 小时",
          "attendees": "按会议",
          "cloud_storage": "0.5 GB",
          "tips": "起价为 {0} 个许可证 {1}/年"
        }
      },
      "large_meeting": {
        "title": "大型会议",
        "desc": "扩大您的影响范围，增加会议人数，最多可容纳 1,000 名参会者。",
        "config_desc": "会议和网络研讨会的观众人数最多可增加到 1000 名",
        "add_more_plan_link_capacity": "如果您想添加其他容量 {0} 套餐来补充您目前的许可证而不是更改当前套餐，请<a href=\"{1}\">点击此处</a>。",
        "promo": "需要举办参会者人数超过 {100} 人的会议？",
        "increase_with": "通过“大型会议”增加",
        "expandable_with": "通过“大型会议”可扩展"
      },
      "webinar": {
        "title": "Zoom Webinars",
        "desc": "允许多达 100 名嘉宾与多达 10,000 名观众进行互动",
        "config_desc": "选择一个或多个套餐。 每个计划最多支持 100 名互动视频嘉宾。 许可证按“仅限观看权限”的观众人数定价。 观众人数从 {0} 人到 {1} 人不等。",
        "brief_title": "网络研讨会",
        "config_desc_new": "借助 Zoom 的高质量视频广播吸引观众参加并广播消息。 最多 {0} 名观众和 {1} 名嘉宾。",
        "engage_your_audiences_desc": "借助 Zoom 的高质量视频广播吸引观众参加并广播消息。",
        "up_to_x_attendees_y_panelists": "最多 {0} 名观众和 {1} 名嘉宾。",
        "add_more_plan_link_capacity_new": "您想添加另一个 {0} 套餐吗？ <a href=\"{1}\">添加套餐</a>",
        "upcoming_prompt": {
          "yes_place_order": "是，提交订单",
          "no_go_back": "不，返回",
          "exit_checkout_cta": "退出结账",
          "cancel_webinar_plan_cta": "取消 Webinar {0} 套餐",
          "has_paid_event_block_title": "您不再有资格享受此优惠",
          "has_paid_event_block_desc": "我们无法将您的 {0} 套餐降级为 {1} 套餐，因为您安排了一个或多个即将举行的付费网络研讨会，其注册人数超过 {2}。",
          "has_free_event_soft_desc": "一旦提交订单，超出新观众容量 ({0}) 的其他观众将无法参加您的网络研讨会。"
        }
      },
      "cmr": {
        "title": "云存储空间",
        "desc": "为您的 {0} GB 云存储空间添加更多容量",
        "config_desc": "在每个付费套餐中，每个许可证最多有 {0} GB 云录制文件存储空间。 您可以从下列选项中选择一个，以添加更多存储空间。",
        "add_desc": "添加更多存储空间并在账户中的所有授权用户之间共享。",
        "important_tips": "*超出存储空间限制后，将收取超额费用。 费用因存储空间套餐而异。",
        "usage_in_excess": "{0}/GB",
        "cmr_free_upgrade": {
          "update_tip": "如果继续，您当前的云录制存储空间将更新为{0}，与当前计费周期的基本价格相同。",
          "update_title": "您的套餐将更新"
        },
        "recommended": "推荐",
        "option_incur_overage": "此选项将产生超额费用",
        "fees_vary_based_on_storage_plan": "费用因存储空间套餐而异。",
        "overage_fees_desc": "超出存储限制时，将根据计费周期内的最高使用量收取超额费用。",
        "account_cloud_storage_include_desc": "您的账户包含 {0} 云存储空间。 您的云存储空间已满，除非购买更多存储空间或在<a href='/recording/management' target='_blank'>录制管理</a>中管理当前文件，否则无法将任何其他会议或网络研讨会录制到云端。",
        "selection_will_incur_overage_desc": "根据您当前的使用情况，您的选择预计将产生至少 {0} 的超额费用。 要避免产生超额费用，您可以在<a href='/recording/management' target='_blank'>录制管理</a>中管理您的文件或在上面选择一个存储空间更大的套餐。",
        "account_cloud_storage_desc": "您的账户包含 {0} 云存储空间。",
        "current_usage": "当前使用情况",
        "paywall_tip": "{0}包括每个用户 {1} GB 的云存储空间。如果您想增加容量，可以从下面的附加组件部分添加{2}。"
      },
      "translation_caption": {
        "title": "已翻译字幕",
        "desc": "提供查看自动字幕的功能，可将字幕翻译为所选的受支持语言，从而助力全球协作",
        "config_desc": "提供查看自动字幕的功能，可将字幕翻译为所选的受支持语言，从而助力全球协作。",
        "license_tooltip": "字幕翻译许可证总数不能超过 Zoom One 许可证数。",
        "subtitle": "启用将字幕翻译为 Zoom Meetings 和 Webinars 中支持的另一种语言的功能。 <a href=\"https://support.zoom.us/hc/en-us/articles/6643133682957-Enabling-and-configuring-translated-captions\" target=\"_blank\">查看支持的语言</a>"
      },
      "pbx": {
        "tollFree": {
          "unit": "toll-free number(s)"
        },
        "local_number": {
          "unit": "local number(s)"
        },
        "more_than_license": "如果您需要的线路超过 {0} 条，请<a href=\"{1}\" target=\"_blank\">联系销售人员</a>",
        "intl_select_addon_countries": "\u7F8E\u56FD\u3001\u52A0\u62FF\u5927\u3001\u82F1\u56FD\u3001\u7231\u5C14\u5170\u3001\u6FB3\u5927\u5229\u4E9A\u3001\u65B0\u897F\u5170\u3001\u5965\u5730\u5229\u3001\u4E39\u9EA6\u3001\u6CD5\u56FD\u3001\u5FB7\u56FD\u3001\u610F\u5927\u5229\u3001\u8461\u8404\u7259\u3001\u897F\u73ED\u7259\u3001\u745E\u5178\u3001\u6BD4\u5229\u65F6\u3001\u8377\u5170\u3001\u745E\u58EB\u3001\u6CE2\u591A\u9ECE\u5404\u3001\u65E5\u672C\u3002",
        "pbx_comparison": "Zoom Phone 套餐比较",
        "comparison_desc": "您知道可以定制吗？ <a href=\"{0}\" target=\"_blank\">联系销售人员</a>可混合搭配您的方案！",
        "see_supported_country": "查看支持的 {0} 个国家/地区列表",
        "how_many_number_need": "您需要多少个号码？",
        "what_calling_plans": "您的用户需要哪种通话套餐？",
        "x_number_selected": "已选择 {0} 个号码",
        "one_calling_plan": "1 个通话套餐",
        "x_calling_plan": "{0} 个通话套餐",
        "toll_free_numbers": "免费号码",
        "local_numbers": "本地号码",
        "select_your_numbers": "选择您的号码",
        "edit_numbers": "编辑号码",
        "add_toll_free_numbers": "+ 添加免费号码",
        "ready_for_porting": "准备转移",
        "have_existing_number": "已有一个号码？",
        "valid_for_porting": "验证要转移的号码",
        "valid_more_porting": "验证更多要转移的号码",
        "port_number_desc": "结账后，您可以在设置期间开始转移过程。 当转移处于待处理状态时，您将获得临时号码。",
        "number_tips_1": "您可以在结账后选择电话号码。",
        "number_tips_2": "目前您只能编辑 10 个号码。 如果您需要编辑更多号码，请先结账。",
        "tf_pricing_line": "（再加 {0} 个）",
        "more_than_99_license": "如果您需要的线路超过 99 条，请<a href=\"{0}\" target=\"_blank\">联系销售人员</a>",
        "calling_fee_tips": "请选择您在{0}以外地区接听或拨打电话时的付款方式。 <a href=\"/billing/pbx/rates\" target=\"_blank\">查看费率和覆盖范围</a>",
        "number_selected_tips": "在您结账后我们才能确保预留您所需的电话号码。",
        "calling_plan_selected_tips": "完成信用卡付款后，您可以在设置账户时保留或转移电话号码。",
        "zpa_cant_exceed_calling": "Zoom Phone Power Pack 用户计数不得超过 Zoom Phone 通话套餐的总和。",
        "metered_calling_credits": "计费通话额度",
        "must_have_a_calling_plan": "In order to purchase, you must have a calling plan.",
        "calling_fee_name": {
          "pay_you_go": {
            "UC": "国际通话费用",
            "MC": "地区和国际通话费用"
          },
          "prepaid": {
            "UC": "预付费国际通话费用",
            "MC": "预付费地区和国际通话费用"
          }
        },
        "calling_fee_label": {
          "unlimited": "如何处理国际费用？",
          "metered": "如何处理地区费用和国际费用？"
        },
        "plan_desc": {
          "ZPI": "超过 15 个国家和地区的无限时国际通话。",
          "ZPA": "包括超级用户桌面体验，可简化通话处理过程、提供增强型实时分析和历史报告。"
        },
        "cart_summary": {
          "local_line": "{0} 个本地线路  •  {1}",
          "toll_free_line": "{0} 个免费线路  •  计费：{1}",
          "local_lines": "{0} 个本地线路  •  {1}",
          "toll_free_lines": "{0} 个免费线路  •  计费：{1}",
          "pay_you_go_calling_fee": "{0} 即付即用",
          "add_on_lines": "{0} 许可证 • {1}",
          "add_on_lines_2": "{0} user(s) • {1}"
        },
        "detail_dialog": {
          "unlimited": {
            "plan_name": "美国和加拿大 | 无限时区域通话"
          },
          "metered": {
            "plan_name": "美国和加拿大 | 计费版"
          }
        },
        "regions": {
          "US": "美国和加拿大",
          "UK": "英国和爱尔兰",
          "AUS": "澳大利亚和新西兰",
          "JP": "日本"
        },
        "divisions": {
          "CA": "公共区域电话",
          "PRO": "Phone 专业版"
        },
        "sub_types": {
          "UC": "无限",
          "MC": "计时",
          "PN": "本地录制",
          "TF": "免费"
        },
        "plan_name": {
          "ZVU": "美国和加拿大无限",
          "ZVM": "美国和加拿大计时",
          "ZPI": "国际通话附加服务",
          "ZPA": "Zoom Phone Power Pack",
          "ZVT": "免费号码",
          "ZVP": "计费通话额度",
          "ZVC": "计费通话额度",
          "ZUU": "无限国内通话计划",
          "ZAU": "无限国内通话计划",
          "ZUM": "计费通话套餐",
          "ZUT": "英国和爱尔兰免费",
          "ZUD": "本地（付费电话）",
          "ZAM": "计费通话套餐",
          "ZAT": "澳大利亚免费",
          "ZNT": "新西兰免费",
          "ZAD": "本地（付费电话）",
          "ZVD": "本地（付费电话）",
          "ZPD": "付费号码",
          "ZJU": "日本無限制",
          "ZJM": "日本計量",
          "ZJD": "Local",
          "ZPP": "通话套餐",
          "ZCA": "通话套餐",
          "ZSU": "Global Select Unlimited",
          "ZSM": "全球精选计时套餐",
          "ZSD": "全球号码",
          "ZGT": "全球免费"
        },
        "cart_name": {
          "ZVU": "美国和加拿大无限通话计划",
          "ZVM": "美国和加拿大计费通话套餐",
          "ZPI": "国际通话附加服务",
          "ZPA": "Zoom Phone Power Pack",
          "ZVT": "美国和加拿大免费电话号码",
          "ZVP": "计费通话额度",
          "ZVC": "计费通话额度",
          "ZUU": "英国和爱尔兰无限通话计划",
          "ZAU": "澳大利亚和新西兰无限通话计划",
          "ZUM": "英国和爱尔兰计费通话套餐",
          "ZUT": "英国和爱尔兰免费电话号码",
          "ZUD": "英国和爱尔兰附加电话号码",
          "ZAM": "澳大利亚和新西兰计费通话套餐",
          "ZAT": "澳大利亚免费电话号码",
          "ZNT": "新西兰免费电话号码",
          "ZAD": "澳大利亚和新西兰附加电话号码",
          "ZVD": "美国和加拿大附加电话号码",
          "ZPD": "付费电话号码",
          "ZJU": "日本无限时通话套餐",
          "ZJM": "日本计时通话套餐",
          "ZJD": "日本其他电话号码",
          "ZPP": "Zoom Phone 专业版",
          "ZCA": "公共区域电话",
          "ZSU": "Zoom Phone 专业版全球精选不限时套餐",
          "ZSM": "Zoom Phone 全球精选计时套餐",
          "ZSD": "Zoom Phone 全球号码",
          "ZGT": "Zoom Phone 全球免费号码"
        },
        "to_verify_notice": "\u4E3A\u4E86\u786E\u4FDD\u5BF9\u60A8\u7684\u7535\u8BDD\u53F7\u7801\u52A0\u5BC6\u6210\u529F\uFF0C\u8BF7\u8BBE\u7F6E\u60A8\u7684\u8D26\u6237\u3002",
        "pbx_specialist": "\u662F\u5426\u60F3\u8981\u5B89\u6392\u4E00\u573A\u4E0E\u4E13\u5458\u8FDB\u884C\u768460\u5206\u949F\u4F1A\u8BAE\u4EE5\u5F00\u59CB\u914D\u7F6E\u60A8\u7684\u7535\u8BDD\u7CFB\u7EDF\uFF1F \u70B9\u51FB\u4E0B\u65B9\u5B89\u6392\u65F6\u95F4\u3002 \u8981\u67E5\u770B\u60A8\u7684\u5957\u9910\uFF0C\u8BF7<a href=\"/billing\" target=\"_blank\" data-link-prod=\"User Management\" data-link-term=\"Phone Welcome Page Click\" data-link-label=\"Click Here - Review Plan\">\u70B9\u51FB\u6B64\u5904</a>\u3002",
        "pbx_specialist_new": "\u662F\u5426\u60F3\u8981\u5B89\u6392\u4E00\u573A\u4E0E\u4E13\u5458\u8FDB\u884C\u768460\u5206\u949F\u4F1A\u8BAE\u4EE5\u5F00\u59CB\u914D\u7F6E\u60A8\u7684\u7535\u8BDD\u7CFB\u7EDF\uFF1F \u70B9\u51FB\u4E0B\u65B9\u5B89\u6392\u65F6\u95F4\u3002",
        "book_specialist_button": "\u9884\u7EA6\u4E13\u5BB6",
        "setup_zoom_phone_button": "\u8BBE\u7F6EZoom Phone",
        "search_area_code": "按区号搜索",
        "search_area_code_length": "请输入 3 位数区号",
        "refresh": "刷新结果",
        "checked_number_title": "已选择 {0} 个号码",
        "max_phone_number_desc": "结账时最多只能选择 {0} 个号码。 如果您需要的号码超过 {0} 个，可以在结账后进行设置。",
        "local": {
          "title": "本地录制"
        },
        "toll_free": {
          "title": "免费",
          "search_tips": {
            "monthly": "免费号码为每个月每个号码另加 {0}",
            "annual": "免费号码为每年每个号码另加 {0}"
          },
          "popover_tips": "包含一个美国或加拿大的免费号码。 所有呼入通话分钟数都将按时间进行计费。 呼出通话分钟数的费用以实际通话计划为准。"
        },
        "port_number": {
          "placeholder": "输入或粘贴电话号码",
          "required": "需要提供端口号",
          "must_10_digits": "请输入一个有效的电话号码。",
          "not_valid": "此号码不可转移。 请使用其他号码重试。",
          "repeat": "该号码已被验证过。 请使用其他号码重试。",
          "title": "验证要转移的号码",
          "add_number": "添加号码",
          "verify_successful": "成功！ 您的号码可转移。 美国和加拿大无限量版通话套餐将添加到您的购物车。 结账后，在您启动转移过程之前，您将收到临时号码。",
          "verify_fail": "请使用其他号码重试，或联系我们的销售代表获取帮助。 <a class=\"port-number-verify-fail\" href=\"{0}\" target=\"_blank\">联系销售人员</a>",
          "max_licenses_check": "如果您需要的线路超过 99 条，请<a href=\"/contactsales\" target=\"_blank\" class=\"port-number-max-licenses-check\">联系销售人员</a>",
          "guarantee_tips": "在您结账后我们才能保证预留您所需的电话号码。 所有免费电话号码均可转移。",
          "validated_numbers_desc": "{0} 个有效号码",
          "verify_successful_metered": "Success! Your numbers are portable. An US & Canada Metered calling plan will be added to your cart. You'll receive temporary numbers until you initiate the porting process after checkout.",
          "validated_numbers_desc_v1": "{0} validated number(s)"
        },
        "search_number_title": "选择新号码",
        "phone_number_guarantee_tips": "在您结账后我们才能确保预留您所需的电话号码。 完成信用卡付款后，您可以在设置账户时保留或转移电话号码。",
        "search_vanity_length": "请输入 4 至 7 位数字或字母",
        "no_results": "未找到结果。 请重试。",
        "calling_plans": "通话套餐",
        "calling_plans_AUS_NZ": "每个通话套餐都包含澳大利亚或新西兰的本地电话号码",
        "calling_plans_UK_Ireland": "每个通话套餐都包含英国或爱尔兰的本地电话号码",
        "calling_plans_US_Canada": "每个通话套餐都包含美国或加拿大的本地电话号码",
        "calling_plans_JP": "每個通話計畫都包括日本的當地電話號碼",
        "calling_plans_Global_Select": "每个通话套餐包括每个许可证在 1 个选定国家/地区的 1 个号码。",
        "add_another_calling_plan": "+ 添加其他通话套餐",
        "add_additional_numbers": "+ 添加其他号码",
        "add_additional_numbers_tips": "为公司其他办公室分配其他号码，作为直线电话、个人直线电话或 Zoom Room 号码。",
        "additional_numbers": "其他号码",
        "additional_numbers_desc": "为公司其他办公室分配其他号码，作为直线电话、个人直线电话或 Zoom Room 号码。",
        "subscription_billing_cycle": "订阅计费周期",
        "phone_features": "电话功能",
        "bring_your_own_carrier": "如果您想自带运营商，请<a href=\"{0}\" target=\"_blank\">联系销售人员</a>。",
        "contact_us_if_you_like_change": "您目前需要支付的费用为 <b>{0}</b>，其中 <b>{1}</b> 是使用费。如果您想进行更改，请<a href=\"{2}\" target=\"_blank\">联系我们</a>。",
        "plan_details": {
          "view_more": "查看更多"
        },
        "calling_regions": "Calling Regions",
        "user_number": "User Number",
        "uk_ir_tollfree_tips": "包含一个英国或爱尔兰的免费号码。 所有呼入通话分钟数都将按时间进行计费。 呼出通话分钟数的费用以实际通话计划为准。",
        "AU_tollfree_tips": "包含一个澳大利亚的免费号码。 所有呼入通话分钟数都将按时间进行计费。 呼出通话分钟数的费用以实际通话计划为准。",
        "NZ_tollfree_tips": "包含一个新西兰的免费号码。 所有呼入通话分钟数都将按时间进行计费。 呼出通话分钟数的费用以实际通话计划为准。",
        "US_tollfree_tips": "包含一个美国或加拿大的免费号码。 所有呼入通话分钟数都将按时间进行计费。 呼出通话分钟数的费用以实际通话计划为准。",
        "UK_tollfree_tips": "包含一个英国或爱尔兰的免费号码。 所有呼入通话分钟数都将按时间进行计费。 呼出通话分钟数的费用以实际通话计划为准。",
        "GS_tollfree_tips": "United States, Canada, United Kingdom, Ireland, Australia, New Zealand, Austria, Denmark, Spain, Sweden, Netherlands, Switzerland, Argentina, Brazil, Mexico, Croatia, Czechia, Cyprus, Finland, Greece, Hungary, Latvia, Lithuania, Luxembourg, Poland, Romania, Slovakia, Slovenia, Israel",
        "calling_plans_metered_tips": "所有呼出通话分钟数都将按时间进行计费。 请参阅<a href=\"/billing/pbx/rates\" target=\"_blank\">计时费率</a>。",
        "more_than_numbers": "如果您需要的号码超过 {0} 个，请<a href=\"{1}\" target=\"_blank\">联系销售人员</a>",
        "phone_support_24_7_live_chat": "全天候实时聊天和电话支持",
        "phone_support_24_7_live_chat_tip": "适用于所有电话独立客户。 支持套餐与会议套餐搭配使用时会有所不同。",
        "multi_language": "多种语言",
        "auto_remove_unlimited_addons_info": "\u4F60\u5DF2\u79FB\u9664\u56FD\u9645\u4E0D\u9650\u65F6\u901A\u8BDD\u5957\u9910\u7684\u6240\u6709\u7B26\u5408\u6761\u4EF6\u7684\u5957\u9910\uFF0C\u7EE7\u7EED\u64CD\u4F5C\u524D\u8FD9\u4E9B\u5957\u9910\u5C06\u4ECE\u8BA2\u5355\u4E2D\u79FB\u9664\u3002",
        "auto_remove_unlimited_addons_title": "\u56FD\u9645\u4E0D\u9650\u65F6\u901A\u8BDD\u5957\u9910\u5C06\u88AB\u79FB\u9664",
        "proceed": "继续",
        "add_on_cant_exceed_pbx_sum": "Zoom Phone Power Pack 用户计数不得超过 Zoom Phone 通话套餐的总和。",
        "select_disabled_tips": "This plan is pending cancellation. To edit, go back to Plan Management and Reactivate.",
        "global_select": "全球计划"
      },
      "cmr_ldk": {
        "desc": "Additional storage to store, stream, share, and download meetings",
        "intro": "Enhance your storage capabilities with additional monthly storage to store, stream, share, and download meetings from the Zoom Cloud.",
        "tips_base": "Recording minute is calculated by session minutes recorded multiplied by the number of recording files processed/generated in a session.",
        "tips": "Excess fees are charged when storage limits ({0}/month) and/or recording minute limits ({1} recording minutes/month) are exceeded. Fees are as below and will be charged monthly to your account should you exceed storage and/or Recording minute limits：",
        "tips_2": "Storage overage：{0} per GB",
        "tips_3": "Recording minute overage：{0} per recording minute",
        "tips_tb_2": "– {0}：{1}/GB；{2}/录制分钟"
      },
      "video_sdk": {
        "subscription_video_sdk_msg": "\u8BF7\u67E5\u770B\u7535\u5B50\u90AE\u4EF6\u8FDB\u884C\u786E\u8BA4\uFF0C\u5176\u4E2D\u5305\u542B\u4F60\u7684\u5BC6\u94A5\u3001\u673A\u5BC6\u548C\u6240\u6709\u5165\u95E8\u8D44\u6E90\u3002",
        "desc": "Accelerate development and build customizable video-based applications with Zoom's industry leading video-first communications platform.",
        "free_min": "Free {0} minutes included every month",
        "switch_now": "Switch now",
        "switch_plan_to_universal": "Want to switch to the Zoom SDK Universal Credit plan and enjoy access to all Video SDK services?",
        "use_case": "Development Use Case",
        "use_case_other": "If Other, Please Specify",
        "unit": "minute thereafter",
        "plan_details": {
          "cloud_based": "Cloud-Based Architecture",
          "customizable": "Customizable Video Composition",
          "hd": "HD Video and Audio",
          "flexible": "Flexible Rate",
          "cloud_based_desc": "Designed for video, engineered for reliability and optimized for scalability",
          "customizable_desc": "Supporting up to {0} participants, 3rd-party live streaming, in-session chat, and more",
          "hd_desc": "High-resolution video conferencing for your virtual meetings",
          "flexible_desc": "Includes {0} free minutes every month with additional minutes charged at {1}",
          "unit_tooltip": "The SDK service usage is determined by monthly meeting session minutes. For example, five users in a ten minute meeting will count as 50 minutes. Partial minutes are rounded up."
        },
        "ldp": {
          "minute": "Video SDK Session"
        },
        "cmr": {
          "minute": "Video SDK Cloud Recording Minutes",
          "storage": "Video SDK Cloud Recording Storage"
        },
        "zvdktt": {
          "minute": "Video SDK Translation and Transcription"
        },
        "zvdcrcp": {
          "minute": "Video SDK Cloud Room Connector"
        },
        "adp": {
          "minute": "Audio Conferencing"
        },
        "zvsdkqss": {
          "minute": "Quality of Service Subscription"
        },
        "zvsdkcbwp": {
          "minute": "Cobrowse SDK"
        }
      },
      "zoom_whiteboard": {
        "plan_comparision_title": "Whiteboard",
        "title": "Zoom Whiteboard",
        "desc": "使用含高级文档控件的无限制白板进行协作，包括同时进行编辑功能和标准白板功能。",
        "concurrent_editable_boards_owned": "拥有可同时编辑白板",
        "zoom_cloud_storage": "Zoom 云存储",
        "maximum_size": "最大白板尺寸",
        "google_drive_doc_int": "Google Drive 和 OneDrive 文档集成",
        "unsigned_links": "具有评论和编辑权限的未登录访客链接",
        "personal_libraries": "个人自定义形状库",
        "private_editing_mode": "私人编辑模式",
        "pin_whiteboard": "Pin Whiteboard to Zoom Chats and Channels",
        "include_in_chat": "Include Shared whiteboards in Chat and channel Resource page",
        "open_in_chat": "Open and Edit whiteboard while in Chat and Channels",
        "add_to_events": "Add Whiteboard to events in Zoom Calendar",
        "create_in_doc": "Create and embed whiteboard in Zoom Doc",
        "quick_share": "Quick share whiteboard to Zoom Rooms",
        "embed_clips": "Embed Zoom Clips",
        "shared_projects": "共享项目",
        "stickers_reactions_gif_libraries": "贴纸、回应和 gif 库",
        "embed_live_whiteboards": "在 Coda 和 Confluence 中嵌入实时白板",
        "tags_notes_cards": "便条和卡片标签",
        "miro_importer": "Miro 导入器",
        "zoom_ai_companion": "使用 Zoom AI Companion 创建和修改内容",
        "zoom_ai_companion_desc": "需要专业版、商业版或企业版账户",
        "teams_gc_int": "Microsoft Outlook 和 Google Calendar 集成",
        "teams_gc_int_desc": "需要 Zoom Outlook 或 Google Calendar 附加组件",
        "unsigned_links_access": "具有查看权限的未登录访客链接",
        "unlimited_canvas_with_up_to_12_pages": "无限制画布，最多 12 页",
        "pen_and_highlighter_annotations": "钢笔和荧光笔注释",
        "shapes_lines_connectors_and_quick_diagraming": "形状、线条、连接线和快速绘图",
        "rich_text_urls_notes_and_reactions": "富文本、URL、便条纸和回应",
        "image_and_pdf_embed_and_cropping": "图像和 PDF 嵌入及裁剪",
        "tables_mind_maps_kanbans_and_cards": "表格、思维导图、图表、看板和卡片",
        "comments_mentions_and_notifications": "评论、@ 提及和通知",
        "align_distribute_rotate_group_and_lock_content": "对齐、分布、旋转、分组、过滤和锁定内容",
        "presence_cursors_live_editing_and_follow_along": "状态光标、实时编辑和跟随",
        "frames_and_presentation_mode": "框架和演示模式",
        "timer": "计时器、投票、激光笔",
        "export_to_high_resolution_image_pdf_and_csv": "导出为高分辨率图像、PDF 和 CSV 文件",
        "guest_collaboration": "访客查看、评论和编辑权限",
        "guest_collaboration_desc": "访客用户需要具有基本 Zoom 账户才能在会议之外访问",
        "sharing_roles_and_permission_management": "共享、角色以及权限管理",
        "microsoft_teams_and_slack_integration": "Microsoft Teams 和 Slack 集成",
        "requires_zoom_app_installation": "需要安装 Zoom Bot，允许在聊天中共享和访问 Zoom Whiteboard",
        "templates": "模板",
        "temporarily_lock_whiteboard_access": "暂时锁定白板",
        "version_history_and_activity_log": "版本历史记录和活动日志",
        "shared_folders_personal_labels": "共享文件夹和个人标签",
        "jira_cloud_cards": "Jira、Asana 和 Azure DevOps 卡片",
        "personal_templates": "Personal and Organizational Custom Templates",
        "organizational_templates": "组织模板",
        "also_supports_create_and_share_whiteboards": "还支持通过 Slack 和 Microsoft Teams 聊天和频道创建和共享白板",
        "included_in_zoom_one_basic_and_zoom_one_pro": "Zoom One 基础版和 Zoom One 专业版中均已包含",
        "unlimited_concurrently_editable_whiteboards": "无限制且可同时编辑的白板",
        "unlimited_concurrently_editable_whiteboards_and_cloud_storage": "无限制且可同时编辑的白板和云存储",
        "one_gb_cloud_storage_capacity": "1 GB 云存储容量"
      },
      "zoom_whiteboard_plus": {
        "plan_comparision_title": "Whiteboard 加强版",
        "title": "Zoom Whiteboard 加强版",
        "desc": "通过高级功能和集成优化工作流程。 获取完整的白板扩展包，以自定义模板和第三方集成为主要内容。",
        "add_on_desc": "Access the complete Whiteboard add-on package, featuring advanced tools, unlimited boards, customizable templates, and 3rd-party integrations.",
        "already_include_in_biz": "This is already included with Zoom Workplace Business. You can purchase more licenses and assign them to Basic or Pro users, or <a class=\"opc-wb-2-plus\" href=\"javascript:void(0);\">switch to Zoom Whiteboard Plus</a> to provide Business users with more whiteboard features.",
        "already_include_in_biz_plus": "This is already included with Zoom Workplace Business Plus. You can purchase more licenses and assign them to Basic or Pro users, or <a class=\"opc-wb-2-plus\" href=\"javascript:void(0);\">switch to Zoom Whiteboard Plus</a> to provide Business Plus users with more whiteboard features."
      },
      "zoom_whiteboard_basic": {
        "title": "Whiteboard 基础版"
      },
      "zone_edu_sch": {
        "title": "Zoom One 教育解决方案学校和校园版",
        "brief_title": "学校和校园",
        "switch_info": "Switching to {0} will cancel your {1} plan. Your new plan will activate right after purchase."
      },
      "zone_edu_plus": {
        "title": "Zoom One 教育解决方案学校和校园加强版",
        "brief_title": "学校和校园加强版",
        "at_least_desc": "您至少需要有 {0} 名用户才能完成购买"
      },
      "zoom_whiteboard_plan_comparsion": "Zoom Whiteboard 套餐比较",
      "meeting_license_decrease_tips_need_decrease_addon": "To decrease the number of users for Zoom One, you need to adjust the add-on {product} license quantity to be equal to or less than Zoom One. <a href=\"/billing\">Return to Plan Management</a>",
      "cancel_disable_contact_us": "If you would like to request to cancel this plan, please <a href=\"{url}\" target=\"_blank\">contact us</a>",
      "unit": {
        "license": "{0} 个许可证",
        "attendee": "{0} 名观众"
      },
      "pro": "\u4E13\u4E1A",
      "business": "\u5546\u4E1A",
      "first_name": "\u540D",
      "last_name": "\u59D3",
      "email": "\u7535\u5B50\u90AE\u4EF6",
      "required": "\u5FC5\u586B",
      "require_first_name": "\u540D\u5B57\u4E3A\u5FC5\u586B",
      "require_last_name": "\u59D3\u6C0F\u4E3A\u5FC5\u586B",
      "require_email_address": "\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u4E3A\u5FC5\u586B",
      "billing_contact": "\u8D26\u5355\u8054\u7CFB\u4EBA",
      "sold_to_contact": "\u9500\u552E\u8054\u7CFB\u4EBA",
      "email_address": "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
      "confirm_email_label": "\u786E\u8BA4\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
      "company_organization_optional": "\u516C\u53F8/\u7EC4\u7EC7\u540D\u79F0\uFF08\u53EF\u9009\uFF09",
      "employee_count": "\u5458\u5DE5\u8BA1\u6570",
      "address": "\u5730\u5740",
      "apt_suite_optional": "\u516C\u5BD3/\u623F\u95F4\u53F7\uFF08\u9009\u586B\uFF09",
      "city": "\u57CE\u5E02",
      "state": "\u5DDE/\u7701",
      "zip_postal": "\u90AE\u7F16",
      "country_region": "\u56FD\u5BB6/\u5730\u533A",
      "business_name": "Business Name",
      "business_country": "Business Headquaters Country",
      "business_size": "Business Size",
      "billing_contact_subtitle": "\u8FD9\u662F\u6536\u5230\u53D1\u7968\u6216\u8D26\u5355\u6D88\u606F\u7684\u8054\u7CFB\u4EBA\u6216\u90E8\u95E8",
      "select_country": "\u9009\u62E9\u56FD\u5BB6/\u5730\u533A",
      "select_total_employee_count": "\u9009\u62E9\u96C7\u5458\u603B\u6570",
      "just_me": "\u53EA\u6709\u6211",
      "same_as_bill_contact": "\u4E0E\u8D26\u5355\u8054\u7CFB\u4EBA\u76F8\u540C",
      "invalid_zip": "\u8BF7\u8F93\u51655\u4F4D\u7F8E\u56FD\u90AE\u7F16",
      "invalid": "\u65E0\u6548",
      "transaction_declined": "\u4EA4\u6613\u5DF2\u62D2\u7EDD",
      "accept_terms_of_service": "\u8BF7\u540C\u610F\u670D\u52A1\u6761\u6B3E\u3002",
      "unknown_error_try_again": "\u4EA4\u6613\u53D1\u751F\u672A\u77E5\u9519\u8BEF\u3002\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
      "invalid_quantity": "\u65E0\u6548\u6570\u91CF",
      "invalid_jp_zip": "\u90AE\u653F\u7F16\u7801\u53EA\u80FD\u5305\u542B\u6570\u503C",
      "invalid_in_zip": "请输入 6 位数字的印度邮政编码",
      "expirationDate": "\u671F\u6EE1\u65E5\u671F",
      "plan": "计划",
      "cvv": "\u4FE1\u7528\u5361\u9A8C\u8BC1\u7801",
      "credit_card_number": "\u4FE1\u7528\u5361\u53F7",
      "card_hold_name": "\u5361\u6301\u6709\u4EBA\u59D3\u540D",
      "unknown_error": "\u672A\u77E5\u9519\u8BEF\uFF01",
      "pop_up_blocked": "\u5F39\u51FA\u7A97\u53E3\u88AB\u5C4F\u853D\uFF0C\u8BF7\u5141\u8BB8\u5F39\u51FA\u7A97\u53E3\u5E76\u91CD\u8BD5\u3002",
      "select_state": "\u9009\u62E9\u5DDE/\u7701",
      "currencies": {
        "aud": "\u6FB3\u5143",
        "cad": "\u52A0\u5143",
        "cny": "\u4EBA\u6C11\u5E01",
        "eur": "\u6B27\u5143",
        "gbp": "\u82F1\u9551",
        "inr": "\u5370\u5EA6\u5362\u6BD4",
        "jpy": "\u65E5\u5143",
        "usd": "\u7F8E\u5143",
        "php": "\u83F2\u5F8B\u5BBE\u6BD4\u7D22",
        "krw": "\u97E9\u56FD\u97E9\u5143",
        "mxn": "\u58A8\u897F\u54E5\u6BD4\u7D22",
        "brl": "\u5DF4\u897F\u96F7\u4E9A\u5C14",
        "zar": "\u5357\u975E\u5170\u7279",
        "ils": "\u4EE5\u8272\u5217\u8C22\u514B\u5C14",
        "chf": "\u745E\u58EB\u6CD5\u90CE",
        "sgd": "\u65B0\u52A0\u5761\u5143",
        "try": "\u571F\u8033\u5176\u91CC\u62C9",
        "pen": "\u79D8\u9C81\u7D22\u5C14",
        "sek": "\u745E\u5178\u514B\u6717",
        "hkd": "\u9999\u6E2F\u6E2F\u5E01",
        "clp": "\u667A\u5229\u6BD4\u7D22",
        "cop": "\u54E5\u4F26\u6BD4\u4E9A\u6BD4\u7D22",
        "ars": "\u963F\u6839\u5EF7\u6BD4\u7D22",
        "nzd": "\u65B0\u897F\u5170\u5143",
        "pln": "\u6CE2\u5170\u5179\u7F57\u63D0",
        "dkk": "\u4E39\u9EA6\u514B\u6717",
        "nkk": "\u632A\u5A01\u514B\u6717",
        "vnd": "Vietnamese Dong \u20AB"
      },
      "coupon": {
        "support_coupon": {
          "offer_desc": "You have a {0}% coupon offer from Zoom Support",
          "redeem_btn": "Redeem now"
        },
        "downsell_edit_reason": "A minimum of {0} user(s) is required when switching to annual and claiming this offer.",
        "distribute": {
          "discount": {
            "page_title": "Zoom\u9762\u5411\u5458\u5DE5\u53CA\u5176\u4EB2\u53CB\u63D0\u4F9B\u7684\u6298\u6263",
            "content_line1": "\u52B2\u7206\u6D88\u606F - Zoom\u73B0\u9762\u5411\u5458\u5DE5\u53CA\u5176\u4EB2\u53CB\u63D0\u4F9B\u4F18\u60E0\u5238\u4EE3\u7801\uFF01",
            "content_line2": "\u70B9\u51FB\u63D0\u4EA4\u540E\uFF0C\u6211\u4EEC\u5C06\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u5411\u4F60\u53D1\u900110\u4E2A\u552F\u4E00\u7684\u4E00\u6B21\u6027\u4F18\u60E0\u5238\u4EE3\u7801\u3002\u4F60\u53EF\u4EE5\u4F7F\u7528\u6B64\u4F18\u60E0\u5238\u4EE3\u7801\u8D2D\u4E70Zoom\u8D26\u6237\uFF08\u4E13\u4E1A\u7248\uFF09\u4F9B\u4E2A\u4EBA\u4F7F\u7528\uFF0C\u6216\u8005\u4E0E\u6700\u591A10\u4E2A\u4EB2\u53CB\u5171\u4EAB\u3002",
            "content_line3": "\u8FD9\u79CD\u8D26\u6237\u7C7B\u578B\u975E\u5E38\u9002\u5408\u5C0F\u4F01\u4E1A\u4E3B\u548C\u5B9A\u671F\u4E0E\u5BA2\u6237\u5F00\u4F1A\u7684\u4E13\u4E1A\u4EBA\u58EB\u3002",
            "detail_title": "\u8BE6\u7EC6\u4FE1\u606F\uFF1A",
            "detail_line1": "\u65B0\u7528\u6237Zoom\u4F1A\u8BAE\u8BA2\u8D2D\u8D39\u7528\u51CF\u514D15%\u3002",
            "detail_line2": "\u81EA\u8D2D\u4E70\u4E4B\u65E5\u8D771\u5E74\u5185\u4EAB\u670915%\u6298\u6263\u3002",
            "detail_line3": "\u6BCF\u4F4D\u5168\u804C\u5458\u5DE5\uFF08\u4E0D\u5305\u542B\u5408\u540C\u5DE5\u548C\u4E34\u65F6\u5DE5\uFF09\u6700\u591A\u53EF\u4F7F\u7528/\u5206\u4EAB\u4F18\u60E0\u523810\u6B21\u3002",
            "detail_line4": "\u5982\u679C\u4F60\u4E0D\u518D\u662F\u5168\u804C\u5458\u5DE5\uFF0C\u5219\u8D26\u6237\u4E2D\u6240\u6709\u672A\u4F7F\u7528\u7684\u4EE3\u7801\u5C06\u65E0\u6CD5\u518D\u4F7F\u7528\u3002",
            "detail_line5": "\u4F60\u5FC5\u987B\u901A\u8FC7\u65B0\u8D26\u6237\u4F7F\u7528\u6B64\u4F18\u60E0\u5238\uFF1B\u65E0\u6CD5\u901A\u8FC7\u73B0\u6709\u8D26\u6237\u4F7F\u7528\u3002",
            "detail_line6": "\u6B64\u4F18\u60E0\u9002\u7528\u4E8E\u5728\u7EBF\u8D2D\u4E70\u6807\u51C6\u4E13\u4E1A\u7248\u5E74\u5EA6\u5957\u9910\u548C\u6807\u51C6\u5546\u4E1A\u7248\u5E74\u5EA6\u5957\u9910\u3002\u6BCF\u6B21\u6700\u591A\u53EF\u8D2D\u4E7020\u4E2A\u8BB8\u53EF\u8BC1\u3002\u8BF7\u6CE8\u610F\uFF0C\u5982\u679C\u5BA2\u6237\u5DF2\u7ECF\u4EAB\u6709\u6298\u6263\uFF0C\u5219\u65E0\u6CD5\u4F7F\u7528\u6B64\u4F18\u60E0\u3002",
            "detail_line7": "\u6B64\u4F18\u60E0\u5238\u4E0D\u5177\u6709\u73B0\u91D1\u4EF7\u503C\uFF0C\u4E14\u53EA\u80FD\u7528\u4E8E\u6807\u51C6\u4E13\u4E1A\u7248\u5E74\u5EA6\u5957\u9910\u548C\u6807\u51C6\u5546\u4E1A\u7248\u5E74\u5EA6\u5957\u9910\u3002\u53EA\u6709\u6709\u6548\u5458\u5DE5\u53EF\u4EE5\u5151\u6362\u4F18\u60E0\u5238\uFF0C\u53EA\u8981\u8D26\u6237\u6709\u6548\uFF0C\u5219\u4F18\u60E0\u5238\u6709\u6548\u3002\u6B64\u4F18\u60E0\u5238\u4E0D\u5F97\u5408\u5E76\u3001\u4EA4\u6613\u6216\u4E0E\u5176\u4ED6\u4F18\u60E0\u540C\u65F6\u4F7F\u7528\u3002",
            "submit_desc": "\u70B9\u51FB\u201C\u63D0\u4EA4\u201D\u540E\uFF0C\u6211\u4EEC\u4F1A\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u5C06\u4F60\u7684\u4EE3\u7801\u53D1\u9001\u81F3\uFF1A",
            "validation_title": "Zoom Discount for Employees",
            "success_content": "We have sent a confirmation email to your Zoom email address with your coupon codes and details on how to use them. Please check your email for next steps."
          }
        },
        "not_switch_plan_pending_plans": "使用此优惠券时，您无法进行此更改。",
        "not_eligible_dialog_title": "Coupon not eligible",
        "coupon_input_placeholder": "优惠码",
        "invalid_code_tips": "错误：优惠券代码无效",
        "reach_limit": "错误：此优惠券已达到兑换上限",
        "invalid_code_default": "错误：此折扣代码不适用于您选择的任何套餐。",
        "success_tips": "折扣仅适用于符合条件的商品。",
        "terms_and_conditions": "\u6761\u6B3E\u548C\u6761\u4EF6",
        "add_coupon_code": "添加优惠码",
        "pending_coupon_desc": "\u5F85\u751F\u6548\u7684\u4F18\u60E0\u5238\u5C06\u5728 {0} \u751F\u6548\uFF0C\u5728\u6B64\u4E4B\u524D\u60A8\u65E0\u6CD5\u4FEE\u6539\u8BA1\u5212\u3002\u60A8\u53EF\u4EE5\u5148\u53D6\u6D88\u5F85\u751F\u6548\u7684\u4F18\u60E0\u5238\uFF0C\u7136\u540E\u91CD\u65B0\u5C1D\u8BD5\u7ACB\u5373\u751F\u6548\u3002",
        "error": {
          "invalid": "您输入的优惠券代码无效。 请检查您的拼写或输入其他代码。",
          "ineligible": "抱歉，您没有资格使用此优惠券。",
          "inactive": "此优惠券不再有效。",
          "maximum_times": "此优惠券已达到最大使用次数，不再有效。",
          "maximum_licence": "此优惠券限制为最多 {0} 个许可证。 请调整选择的数量，然后重试。",
          "maximum_licences": "此优惠券限制为最多 {0} 个许可证。 请调整选择的数量，然后重试。",
          "with_new_subscription": "此优惠券仅适用于新订阅。",
          "with_replace_subscription": "此优惠券仅适用于当前已注册订阅套餐的用户。",
          "pre_existing": "您现有的优惠券目前有效。 不能同时使用多张优惠券。",
          "same_coupon_code": "我们的记录显示您已经为此套餐使用了相同的优惠券。",
          "currency": "此优惠券仅适用于某些货币。 请切换到另一种货币，然后重试。",
          "not_match_mandatory_plan": "此优惠券需要 {0} 才能添加到购物车中。",
          "with_billing_cycle": "此优惠券只能用于 {0} 订阅周期。",
          "with_pending_downsell": "即将降价销售，无法兑换此优惠券，您可以“撤销”降价销售并立即兑换，或在降价销售生效后兑换。",
          "maximum_coupon_count": "您现有的 2 张优惠券目前有效。 目前最多只能使用 2 张优惠券。",
          "pending_renewal_apply": "如果您想添加新的优惠券，请先取消账户中待生效的优惠券。",
          "with_pending_downgrade": "\u53D6\u6D88\u5C06\u5728 {0} \u751F\u6548\uFF0C\u5728\u6B64\u4E4B\u524D\u60A8\u65E0\u6CD5\u5151\u6362\u6B64\u4F18\u60E0\u5238\u3002 \u5B8C\u6210\u540E\uFF0C\u8BF7\u91CD\u65B0\u5C1D\u8BD5\u5151\u6362\u4F18\u60E0\u5238\u3002",
          "with_partner": "We're sorry, you are currently not eligible for the {0} promotion.",
          "country": "您的当前位置不符合使用此优惠券的资格。",
          "redeemed": "此优惠券已被使用，不再有效"
        },
        "discount": "折扣",
        "expiresDesc": "于 {0} 失效"
      },
      "common": {
        "cart_bag": {
          "continue_shopping_btn": "浏览更多产品",
          "cart_title": "您的购物车"
        },
        "optional": "可选",
        "require_field_indicate": "必填字段",
        "before_taxes": "税前",
        "learn_more_about_edu": "了解更多关于 <a href=\"https://support.zoom.com/hc/en/article?id=zm_kb&sysparm_article=KB0057649\" target=\"_blank\">Zoom 教育版资格要求<i class=\"zm-icon-window-new\"></i></a>的信息",
        "max_license_exceed_contact_us": "\u5982\u9700\u8D2D\u4E70 {0} \u4E2A\u4EE5\u4E0A\u7684\u8BB8\u53EF\u8BC1\uFF0C\u8BF7<a href=\"https://zoom.us/phonesystem#signup-phone\" target=\"_blank\">\u8054\u7CFB\u9500\u552E\u4EBA\u5458</a>\u3002",
        "max_exceed_contact_us": "\u5982\u9700\u8D2D\u4E7099\u4E2A\u4EE5\u4E0A\u7684\u8BB8\u53EF\u8BC1\uFF0C\u8BF7<a href=\"https://zoom.us/phonesystem#signup-phone\" target=\"_blank\">\u8054\u7CFB\u9500\u552E\u4EBA\u5458</a>\u3002",
        "apply": "\u5E94\u7528",
        "cancel": "\u53D6\u6D88",
        "add": "添加",
        "remove": "\u79FB\u9664",
        "edit": "\u7F16\u8F91",
        "view": "查看",
        "edit_plan": "编辑套餐",
        "place_order": "下订单",
        "submit": "提交",
        "place_order_and_confirm_payment": "下单并确认付款",
        "proceed_to_payment": "继续付款",
        "reject": "拒绝",
        "accept": "接受",
        "expire_brief": "导出",
        "per_billing_cycle_number": {
          "monthly": "/month/number",
          "annual": "/year/number",
          "one_month": "/number",
          "quarterly": "/quarter/number",
          "two_years": "/two years/number",
          "three_years": "/three years/number"
        },
        "per_billing_cycle_line": {
          "monthly": "/月/线路",
          "annual": "/年/线路"
        },
        "per_billing_cycle_license": {
          "monthly": "/月/许可证",
          "annual": "/年/许可证",
          "one_month": "/许可证",
          "quarterly": "/季度/许可证",
          "two_years": "/两年/许可证",
          "three_years": "/三年/许可证",
          "price_monthly": "{price}/月/用户",
          "price_annual": "{price}/月/用户（按年计费）"
        },
        "per_billing_cycle_user": {
          "monthly": "/月/用户",
          "annual": "/年/用户",
          "one_month": "/用户",
          "quarterly": "/季度/用户",
          "two_years": "/两年/用户",
          "three_years": "/三年/用户"
        },
        "per_billing_cycle_room": {
          "monthly": "/月/会议室",
          "annual": "/年/room",
          "one_month": "/会议室",
          "quarterly": "/季度/会议室",
          "two_years": "/两年/会议室",
          "three_years": "/三年/会议室"
        },
        "per_billing_cycle_port": {
          "monthly": "/月/端口",
          "annual": "/年/端口",
          "one_month": "/端口",
          "quarterly": "/季度/端口",
          "two_years": "/两年/端口",
          "three_years": "/三年/端口"
        },
        "per_billing_cycle": {
          "monthly": "/月",
          "annual": "/年",
          "one_month": "/月",
          "quarterly": "/季度",
          "two_years": "/两年",
          "three_years": "/三年"
        },
        "per_billing_cycle_attendee": {
          "monthly": "观众数/月",
          "annual": "观众数/年",
          "one_month": "观众"
        },
        "from": "\u4ECE",
        "learn_more": "了解更多",
        "Learn_more": "了解更多",
        "Learn_More": "了解更多",
        "new": "新功能",
        "popular": "热门",
        "beta": "测试版",
        "select": "特选",
        "contact_sales": "联系销售人员",
        "legacy_limit_dialog_title": "很抱歉...",
        "legacy_limit_dialog_content": "{0} 不可购买。 请联系我们的销售团队了解更多详情。",
        "confirm": "确认",
        "company_organization": "\u516C\u53F8/\u7EC4\u7EC7\u540D\u79F0",
        "update_plan": "更新套餐",
        "update_plan_error": "您的套餐无法更新。 请重试。",
        "limit_block": "请求待处理，请等待，请稍后再试。",
        "checkout": "结账",
        "search": "搜索",
        "or": "或",
        "validate": "验证",
        "can_not_continue": "无法继续",
        "billing_cycle_auto_update_desc": "{0} 的订阅周期现已更新为与 {1} 的订阅周期一致。",
        "license_equal_to_base": "每次购买的 {1} 许可证数必须与 {0} 用户数一致。",
        "license_equal_to_base_for_webinar": "每次购买的 {1} 许可证数（不包括单次套餐）必须与付费 {0} 用户数相一致",
        "consumption_equal_to_base": "{0} 需要 {1} 付费订阅",
        "billing_cycle": {
          "monthly": "\u6708",
          "yearly": "\u6BCF\u5E74"
        },
        "per_billing_cycle_one_month": {
          "one_month": "/月"
        },
        "return_to_plan_management": "返回到套餐管理",
        "order_confirmation_send_to": "Your order confirmation will be sent to {0}",
        "auto_remove_notification": "{0} have been removed from your cart due to purchase restrictions."
      },
      "payment": {
        "paypal": "PayPal",
        "credit": "信用卡或借记卡",
        "backup_apm_desc": "您将转至 {0} 授权计费协议。 请确保未阻止弹出窗口。 这将成为您存档的付款方式。",
        "apple_pay": "Apple Pay",
        "google_pay": "Google Pay",
        "credit_name": "\u4FE1\u7528\u5361",
        "change_payment": "更改付款方式",
        "apple_pay_desc": "单击下面的按钮，可从 Apple Pay 钱包中选择付款方式。 您可以在完成购买前查看订单。",
        "apple_pay_not_supported": "Apple Pay 付款选项仅在符合条件且运行 Safari 浏览器的 Apple 设备上受支持。",
        "google_pay_desc": "单击下面的按钮，可从 Google Pay 钱包中选择付款方式。 您可以在完成购买前查看订单。",
        "google_pay_not_supported": "Google Pay 付款选项在您的设备或 Web 浏览器上不受支持。",
        "payment_title": "\u652F\u4ED8\u65B9\u5F0F",
        "payment_upi_title": "请输入您的 UPI 付款详细信息",
        "paypal_pending_desc": "您将转至 PayPal 授权计费协议。 请确保未阻止弹出窗口。 此时不会向您收取费用。",
        "sofort": "Sofort",
        "sofort_sepa": "SOFORT/SEPA",
        "sofort_desc": "\u7CFB\u7EDF\u5C06\u8DF3\u8F6C\u5230SOFORT\u4EE5\u6388\u6743\u8BA1\u8D39\u534F\u8BAE\u3002\u8BF7\u786E\u4FDD\u672A\u963B\u6B62\u5F39\u51FA\u7A97\u53E3\u3002\u8FD9\u5C06\u6210\u4E3A\u60A8\u5B58\u6863\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "sofort_upgrade_message": "SOFORT/SEPA\u65E0\u6CD5\u7528\u4E8E\u5347\u7EA7\u3002\u8BF7\u5355\u51FB\u201C\u7F16\u8F91\u201D\u94FE\u63A5\u66F4\u6539\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "apm_option_no_longer_supported": "不再支持 {0}。请更改您的付款方式。",
        "customer_balance": "\u632f\u8fbc",
        "furikomi": "Furikomi",
        "customer_balance_desc": "\u7CFB\u7EDF\u5C06\u8DF3\u8F6C\u5230Furikomi\u4EE5\u6388\u6743\u8BA1\u8D39\u534F\u8BAE\u3002\u8BF7\u786E\u4FDD\u672A\u963B\u6B62\u5F39\u51FA\u7A97\u53E3\u3002\u8FD9\u5C06\u6210\u4E3A\u60A8\u5B58\u6863\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "customer_balance_upgrade_message": "Furikomi 不能用于升级。 请单击“编辑”链接更改您的付款方式。",
        "ideal": "iDEAL",
        "ideal_desc": "\u7CFB\u7EDF\u5C06\u8DF3\u8F6C\u5230iDEAL\u4EE5\u6388\u6743\u8BA1\u8D39\u534F\u8BAE\u3002\u8BF7\u786E\u4FDD\u672A\u963B\u6B62\u5F39\u51FA\u7A97\u53E3\u3002\u8FD9\u5C06\u6210\u4E3A\u60A8\u5B58\u6863\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "ideal_upgrade_message": "iDEAL/SEPA\u65E0\u6CD5\u7528\u4E8E\u5347\u7EA7\u3002\u8BF7\u5355\u51FB\u201C\u7F16\u8F91\u201D\u94FE\u63A5\u66F4\u6539\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "us_bank_account": "\u7f8e\u56fd ACH \u76f4\u63a5\u501f\u8bb0",
        "us_ach_direct_debit": "US ACH Direct Debit",
        "us_bank_account_desc": "\u60a8\u5c06\u8f6c\u81f3\u201c\u94f6\u884c\u8d26\u6237\u8f6c\u8d26\u201d\u6388\u6743\u8ba1\u8d39\u534f\u8bae\u3002 \u8bf7\u786e\u4fdd\u672a\u963b\u6b62\u5f39\u51fa\u7a97\u53e3\u3002\u8fd9\u5c06\u6210\u4e3a\u60a8\u5b58\u6863\u7684\u4ed8\u6b3e\u65b9\u5f0f\u3002\u8bf7\u6ce8\u610f\uff1a\u6240\u9700\u7684\u8d26\u6237\u53d8\u66f4\u4fe1\u606f\u53ef\u80fd\u4f1a\u56e0\u94f6\u884c\u8f6c\u8d26\u65f6\u6548\u800c\u5ef6\u8fdf\u3002\u5982\u6709\u6025\u9700\uff0c\u8bf7\u9009\u62e9\u94f6\u884c\u5361\u4ed8\u6b3e\u3002",
        "us_bank_account_upgrade_message": "ACH \u94f6\u884c\u8f6c\u8d26\u4e0d\u80fd\u7528\u4e8e\u5347\u7ea7\u3002 \u8bf7\u5355\u51fb\u201c\u7f16\u8f91\u201d\u94fe\u63a5\u66f4\u6539\u60a8\u7684\u4ed8\u6b3e\u65b9\u5f0f\u3002",
        "klarna": "Klarna",
        "klarna_de_se": "立即购买，稍后付款",
        "klarna_desc": "您将转至 Klarna 授权计费协议。 请确保未阻止弹出窗口。 这将成为您存档的付款方式。",
        "klarna_upgrade_message": "Klarna 不能用于升级。请单击“编辑”链接更改您的付款方式。",
        "klarna_billing_cycle_message": "Klarna 只能用于相同订阅周期的产品（例如，全部为年度订阅或全部为月度订购）。请更新您的订阅周期以使之匹配，或选择“编辑”更改您的付款方式。",
        "klarna_p2p_financing_message": "Your default Klarna payment option may not carry over automatically. Klarna will default to 'Pay in full'.",
        "klarna_payment_catgory": {
          "pay_in_installments": "分期付款",
          "pay_later": "稍后付款",
          "pay_now": "立即支付",
          "pay_with_financing": "融资"
        },
        "p24": "Przelewy24",
        "p24_desc": "您将转至 Przelewy24 授权计费协议。 请确保未阻止弹出窗口。 这将成为您存档的付款方式。",
        "p24_upgrade_message": "Przelewy24 不能用于升级。 请单击“编辑”链接更改您的付款方式。",
        "p24_upgrade_payment_due": "您的付款到期。",
        "p24_upgrade_future_payments": "Zoom 将发送电子邮件通知，向您提醒未来的付款。",
        "p24_upgrade_complete_payment": "您的订阅已更新。请点击下面的链接完成付款。",
        "p24_upgrade_pay_now": "立即支付",
        "banktransfer": "银行转账 +",
        "sepa": "SEPA",
        "wise_plus_banktransfer": "Wise + 银行转账",
        "trustly": "Trustly +",
        "wise_plus_trustly": "Wise + Trustly",
        "interac": "Interac +",
        "wise_plus_interac": "Wise + Interac",
        "payid": "PayID +",
        "wise_plus_payid": "Wise + PayID",
        "fpx": "FPX +",
        "wise_plus_fpx": "Wise + FPX",
        "poli": "POLI +",
        "wise_plus_poli": "Wise + POLI",
        "paynow": "PayNow +",
        "wise_plus_paynow": "Wise + PayNow",
        "bacs": "BACS +",
        "wise_plus_bacs": "Wise + BACS",
        "fps": "FPS +",
        "wise_plus_fps": "Wise + FPS",
        "openbanking": "开放银行 +",
        "wise_plus_openbanking": "Wise + 开放银行",
        "pix": "PIX +",
        "wise_plus_pix": "Wise + PIX",
        "boleto": "Boleto +",
        "wise_plus_boleto": "Wise + Boleto",
        "dana": "Dana +",
        "wise_plus_dana": "Wise + Dana",
        "ovo": "ovo +",
        "wise_plus_ovo": "Wise + ovo",
        "wise": "Wise",
        "wise_upgrade_message": "Wise cannot be used for upgrades. Please click on the \"Edit\" link to change your Payment method.",
        "wise_business_account_message": "不支持 Wise 商业账户。请在登录 Wise 后选择个人账户。",
        "wise_desc": "您将转至 WISE 授权计费协议。 请确保未阻止弹出窗口。 这将成为您存档的付款方式。",
        "pay_with": "付款方式",
        "bill_same_as_contact": "账单地址与联系人地址相同",
        "waiting_auth_pay_method_title": "授权付款方式",
        "waiting_auth_pay_method_desc": "请勿关闭此页面或点击返回按钮。 前往弹出窗口完成授权。",
        "waiting_updating_pay_method_title": "更新支付方式",
        "waiting_updating_pay_method_desc": "请不要关闭此页面。",
        "waiting_check_title": "请稍等，正在处理您的订单...",
        "waiting_check_desc": "请等待确认，然后再返回或关闭浏览器。",
        "update_pay_method_tips": "请更新或取消对付款方式所作的更改",
        "ach": {
          "name": "ACH",
          "verify_failed": "您的付款方式验证失败。 请前往<a href=\"/billing/payment\">账单信息</a>更新您的付款方式。",
          "verify_pending_error": "由于您的付款方式正在等待验证，您无法完成此次付款。 请转至<a href=\"/billing/payment\">账单信息</a>并完成验证，然后重试。"
        },
        "cash": "Cash",
        "check": "Check",
        "bank_transfer": "Bank Transfer",
        "wire_transfer": "Wire Transfer",
        "others": "其他",
        "pay_with_international_card": "使用支持境外消费的信用卡或借记卡支付。 向银行确认是否可使用信用卡及其使用费用。",
        "apm_payment_error": "请更换付款方式。",
        "apm_flow_lost_message": "看起来流程存在问题。 请重试并使用 {0} 完成付款。",
        "upi": "Unified Payments Interface",
        "upi_one_time_payment": "对于所有周期性套餐，我们都将在您每个计费周期的付款到期时向您发送通知，并且您每次都需要通过 <a href=\"/paynow\" target=\"_blank\">zoom.us/paynow</a> 进行手动支付。",
        "recurring_apm_payment_warning": {
          "ideal": "使用此方式的未来周期性付款最多可能需要 5 个工作日才能处理完毕。在此期间，您的订阅将保持有效，但您将无法编辑您的账户或进行购买。",
          "customer_balance": "为了使您的订阅保持有效状态，您需要在 5 个工作日内通过 Furikomi 完成付款。在此之前，您将无法编辑您的账户或进行购买。",
          "p24": "使用此方式的未来周期性付款需要在付款历史记录部分进行手动付款。每次续订日期之后，在付款完成之前，您将无法编辑您的账户或进行购买。",
          "us_bank_account": "使用此方式的付款最多可能需要 5 个工作日才能处理完毕。在此期间，您的订阅将保持有效，但您将无法编辑您的账户或进行购买。"
        }
      },
      "addr": {
        "enter_tip": {
          "first_name": "输入您的名字",
          "last_name": "输入您的姓氏",
          "email": "输入您的电子邮件地址",
          "address": "输入您的地址",
          "city": "输入您的城市",
          "phone": "输入您的电话号码",
          "zip_postal": "输入您的邮政编码",
          "company_organization_legal": "输入您的法定公司名称",
          "org_name": "输入您的组织名称",
          "password": "输入您的密码"
        },
        "select_tip": {
          "age": "选择您的年龄",
          "business_size": "选择您的公司规模",
          "account_type": "选择您的账户类型",
          "biz_org_type": "选择您的公司/组织类型",
          "state": "选择您的州/省",
          "country_region": "选择您的国家/地区",
          "hq": "选择您的公司总部所在国家/地区",
          "org_size": "选择您的组织规模",
          "use_case": "选择您的开发用例"
        },
        "state": {
          "AU": {
            "act": "\u6FB3\u5927\u5229\u4E9A\u9996\u90FD\u9886\u5730",
            "nsw": "\u65B0\u5357\u5A01\u5C14\u58EB\u5DDE",
            "nt": "\u5317\u90E8\u5730\u533A",
            "ql": "\u6606\u58EB\u5170\u5DDE",
            "sa": "\u5357\u6FB3\u5927\u5229\u4E9A\u5DDE",
            "ta": "\u5854\u65AF\u9A6C\u5C3C\u4E9A\u5DDE",
            "va": "\u7EF4\u591A\u5229\u4E9A\u5DDE",
            "wa": "\u897F\u6FB3\u5927\u5229\u4E9A\u5DDE"
          },
          "AE": {
            "ad": "\u963F\u5E03\u624E\u6BD4",
            "an": "\u963F\u5409\u66FC",
            "di": "\u8FEA\u62DC",
            "fh": "\u5BCC\u67E5\u4F0A\u62C9",
            "rak": "Ras Al Khaimah",
            "sh": "\u6C99\u8FE6",
            "eouaq": "Emirate of Umm Al Quwain"
          }
        },
        "account_type": "账户类型",
        "biz_account": "企业账户",
        "personal_account": "个人账户",
        "country_not_match": "Unfortunately, your country or region is not eligible for this purchase. If you need assistance, please <a href=\"/contactsales\" target=\"_blank\">contact sales</a>",
        "update_address_tips": "请更新或取消地址变更信息",
        "street_info": "街道地址信息将用作“买方”地址，以确定可能适用的任何税费。",
        "update_btn": "更新地址信息",
        "continue_btn": "继续付款",
        "line_2": "地址行 2",
        "biz_info": "这是公司地址",
        "hq": "公司总部所在国家/地区",
        "business_name": "公司名称",
        "doing_biz_as": "经营别称",
        "doing_biz_as_name": "\u516C\u53F8\u7ECF\u8425\u522B\u79F0",
        "doing_biz_as_name_tips": "\u5982\u679C\u4F01\u4E1A\u7ECF\u8425\u6240\u7528\u540D\u79F0\u4E0E\u6240\u6709\u8005\u540D\u79F0\u6216\u516C\u53F8\u6CD5\u5B9A\u540D\u79F0\u4E0D\u540C\uFF0C\u5219\u9002\u7528\u3002",
        "business_size": "公司规模",
        "org_name": "组织名称",
        "org_size": "组织规模",
        "for_edu": {
          "tip": "此账户适用于为 18 岁以下儿童及青少年提供服务的学校或其他组织。",
          "select_apply": "该组织为哪个年龄段提供服务？ （选择所有适用选项）*",
          "under_13": "13 岁以下",
          "required_tip": "请至少选择 1 个年龄段",
          "range_n_m": "{0} 至 {1} 岁"
        }
      },
      "usecase": {
        "gaming": "Gaming",
        "retail": "Retail",
        "social": "Social",
        "wellness": "Wellness",
        "e_learning": "E-Learning",
        "telehealth": "Telehealth",
        "fintech": "FinTech",
        "legal": "Legal",
        "hr_staffing": "HR/Staffing",
        "fitness": "Fitness",
        "events": "Events",
        "other": "Others"
      },
      "tax_exemption": {
        "ttr": {
          "tax_status_label": "税务状况：{0}",
          "link": "验证免税资格",
          "link_desc": "请确保弹出窗口未被阻止，以便您跳转至 ECMS 并验证您的免税资格。",
          "in_progress_title": "正在进行免税验证",
          "in_progress_desc": "请在我们的合作伙伴网站上完成免税验证。 税务状况验证完成后，您将返回此处完成订单。<br/><br/>在验证完成之前，请勿关闭或对此页面进行任何修改。 如果您不再需要进行免税申请，您可以关闭并继续下订单。",
          "in_progress_close_button": "关闭",
          "quit_progress_title": "确定？",
          "quit_progress_desc": "您确定要放弃免税验证，并以符合纳税条件的身份继续执行吗？",
          "quit_progress_confirm": "是，放弃",
          "quit_progress_cancel": "不，继续",
          "status_exempt": "免税",
          "status_pending": "待定",
          "status_retrieving": "正在检索...",
          "status_nonexempt": "不免税",
          "status_pending_desc": "目前正在审查您的免税资格。 下订单时，我们将向您收取税费，如果审核通过，我们将抵免向该账户收取的税费。",
          "status_retrieving_desc": "我们正在检索您的免税资格，请稍候。",
          "status_incomplete": "验证未完成，如果您希望免税，请重新单击",
          "verify_now_title": "免税？",
          "verify_now_btn": "立即验证",
          "verify_checkout_notice": "作为一种选择，此步骤可以在结账后完成。",
          "status_title": "免税资格",
          "status_rejected_desc": "提交的文件被确定不符合您的司法管辖区要求。",
          "status_approved_text": "已批准",
          "status_pending_text": "待定",
          "status_rejected_text": "已拒绝",
          "abandon_new_tax_dialog": {
            "title": "放弃免税验证？",
            "content": "如果您放弃验证，您可能会被收取适用的税款/费用。购买后，您仍可以在“账单管理”部分提交免税文件，供 Zoom 审核和批准。验证成功之后，所有已征收的税款将予以退还。",
            "cancel_btn": "返回",
            "confirm_btn": "放弃验证"
          },
          "ios_lower_version_dialog": {
            "title": "Tax verification is only available on iOS 16 and later, or Android Chrome V85 and later.",
            "step": "You can place your order now and apply for tax exemption later from a desktop. After purchase, submit your tax exemption document in the Billing Management section for Zoom’s review. Once validated, a refund will be issued for any applicable taxes charged."
          }
        }
      },
      "success": {
        "download_app": "Download Zoom for {0}",
        "launch_meeting": "Launch Meeting",
        "ppm": {
          "extension_purchased": "已购买会议延长",
          "extension_desc": "此延长将在会议结束前有效。 如果此会议已经结束，我们将保留您的延长供将来使用。",
          "download_desc": "为了得到最佳体验并获取最新功能，请在我们的<a href=\"{downloadUrl}\" target=\"_blank\">下载中心</a>下载 {version} 版本或更高版本的客户端"
        },
        "title": "感谢您选择 Zoom",
        "btn": "查看我的账户",
        "subtitle": "您将在接下来的 24 小时内收到确认电子邮件",
        "start_time_new": "\u4F60\u7684\u8BA2\u8D2D\u5C06\u4E8E{0}\u5F00\u59CB\u3002\u6536\u5230\u8D26\u5355{1}{2}\u3002",
        "auto_renew_time": "\u60A8\u7684\u8BA2\u8D2D\u5C06\u81EA\u52A8\u4E8E{0}\u7EED\u671F\u3002",
        "receive_email_with_inr_invoice_processing": "\u63D0\u4F9B\u7535\u5B50\u7B7E\u540D\u540E\uFF0C\u4F60\u5C06\u572824\u5C0F\u65F6\u5185\u6536\u5230\u786E\u8BA4\u66F4\u6539\u7684\u7535\u5B50\u90AE\u4EF6\u3002",
        "download_the_zoom_app": "\u4E0B\u8F7DZoom App",
        "download_mac_brief": "MAC",
        "download_mac": "<span>\u642D\u8F7D</span><br />Apple Silicon\u82AF\u7247\u7684Mac\u8BBE\u5907",
        "download_windows": "Windows\u7535\u8111",
        "download_windows_64": "<span>Windows</span><br /> 64\u4F4D",
        "download_windows_arm": "<span>Windows</span><br /> ARM",
        "book_specialist_button": "\u9884\u7EA6\u4E13\u5BB6",
        "get_started": "开始",
        "view_doc": "查看开发人员文档",
        "need_help_getting_started": "需要为您提供入门帮助吗？",
        "start_your_meeting_now": "\u7ACB\u5373\u5F00\u59CB\u4F1A\u8BAE",
        "go_to_user_management": "\u8F6C\u5230\u201C\u7528\u6237\u7BA1\u7406\u201D",
        "review_your_subscription": "\u5BA1\u6838\u60A8\u7684\u8BA2\u9605",
        "view_phia_agreement_canada": "\u8981\u67E5\u770B\u300A\u53D7\u4FDD\u62A4\u7684\u5065\u5EB7\u4FE1\u606F\u9644\u4EF6\u300B\u7684\u526F\u672C\uFF0C\u8BF7\u8BBF\u95EE<a href=\"/billing\">\u8BA1\u8D39\u95E8\u6237</a>\u3002",
        "view_hipaa_agreement_us": "\u8981\u67E5\u770B\u300A\u4E1A\u52A1\u4F19\u4F34\u534F\u8BAE\u300B\u7684\u526F\u672C\uFF0C\u8BF7\u8BBF\u95EE<a href=\"/billing\">\u8BA1\u8D39\u95E8\u6237</a>\u3002",
        "success_unassigned_licenses": "\u8981\u4F7F\u7528\u65B0\u7684\u8BA1\u5212\u548C/\u6216\u6269\u5C55\u8BA1\u5212\uFF0C\u4F60\u9700\u8981\u5C06\u529F\u80FD\u5206\u914D\u7ED9\u7528\u6237\u3002",
        "coppa": {
          "tip": "\u5982\u679C\u88AB\u786E\u5B9A\u4E3A\u9762\u541113\u5C81\u4EE5\u4E0B\u513F\u7AE5\u63D0\u4F9B\u6559\u80B2\u670D\u52A1\u7684\u673A\u6784\uFF0C\u5219\u6211\u4EEC\u4F1A\u8981\u6C42\u4F60\u63D0\u4F9B\u7EC4\u7EC7\u4FE1\u606F\u5E76\u540C\u610F\u6559\u80B2\u6570\u636E\u6536\u96C6\u884C\u4E3A\u6216\u63D0\u4F9B\u6709\u6743\u540C\u610F\u6559\u80B2\u6570\u636E\u6536\u96C6\u884C\u4E3A\u7684\u4E2A\u4EBA\u7684\u8054\u7CFB\u65B9\u5F0F\u3002\u6B64\u6D41\u7A0B\u5B8C\u6210\u540E\uFF0C\u4F60\u5373\u53EF\u5F00\u59CB\u4F7F\u7528Zoom\u670D\u52A1\u3002",
          "coppa_desc": "作为向儿童提供教育服务的学校或其他组织，您必须提供额外信息才能继续使用 Zoom 服务。",
          "click_to_proceed": "\u70B9\u51FB\u4EE5\u7EE7\u7EED",
          "data_collection_practice": "Zoom\u7684\u6559\u80B2\u6570\u636E\u6536\u96C6\u884C\u4E3A",
          "your_org_info": "\u4F60\u7684\u7EC4\u7EC7\u4FE1\u606F",
          "org_website": "\u7EC4\u7EC7\u4E3B\u9875\u7F51\u7AD9\u5730\u5740\uFF08\u53EF\u9009\uFF09",
          "your_role_in_org": "\u4F60\u5728\u7EC4\u7EC7\u4E2D\u7684\u89D2\u8272",
          "superintendent": "\u76D1\u7763\u4EBA/\u6821\u957F/\u884C\u653F\u4EBA\u5458",
          "teacher": "\u6559\u5E08",
          "other": "\u5176\u4ED6",
          "name_of_superintendent": "\u540C\u610F\u7EC4\u7EC7\u6559\u80B2\u6570\u636E\u6536\u96C6\u7684\u76D1\u7763\u4EBA/\u6821\u957F/\u884C\u653F\u4EBA\u5458/\u6559\u5E08\u7684\u59D3\u540D",
          "email_of_above": "\u4E0A\u8FF0\u4E2A\u4EBA\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740"
        },
        "setup_zoom_account": "设置 Zoom 账户",
        "setup_zoom_one_pro": "设置 Zoom One 专业版",
        "setup_zoom_one_biz": "设置 Zoom One 商业版",
        "setup_zoom_one_biz_plus": "设置 Zoom Workplace 商业加强版",
        "setup_zoom_one_pro_plus": "设置 Zoom Workplace 专业加强版",
        "what_is_next": "下一步操作是什么？",
        "update_success": "您的账户已更新",
        "review_plan": "查看您的套餐",
        "email_confirm": "您将在接下来的 24 小时内收到确认电子邮件。",
        "print_invoice": "打印发票",
        "update_success_plan": "您的套餐已更新",
        "downgrade_txt": "您的更改将在当前计费期限结束时生效。",
        "downgrade_unassign_licenses": "请在“用户管理”中取消分配 {0} 个用户，必须在 {1} 前，否则将无法处理降级。",
        "downgrade_unassign_licenses_zs2ze": "请在 {2} 之前从 {1} 用户中取消分配 {0}，否则将不会处理套餐变更。",
        "unassign_users": "取消分配用户",
        "unassign_licenses": "取消分配许可证",
        "seat_management": "许可证管理",
        "downgrade_seat_licenses_hub": "在 {1} 之前，请记得在许可证管理中删除追加的 {0} 名主持人",
        "downgrade_seat_licenses_co": "在 {1} 之前，请记得在许可证管理中删除追加的 {0} 名合编者",
        "downgrade_seat_co_process": "一旦成功删除追加的合编者，系统将进行降级处理。",
        "downgrade_seat_hub_process": "一旦成功删除追加的主持人，系统将进行降级处理。",
        "downgrade_title": "我们正在处理您的请求。",
        "sdk_para_1": "Starting on {0}, your subscription is active, and you have been charged {1}. It will automatically renew on {2}.",
        "sdk_para_2": "Be sure to check your email for a confirmation that provides you with all the resources you need to get started.",
        "sdk_btn": "Start Building Your App",
        "sdk_title": "Thanks for your order!",
        "subscription_activated": "您的订阅已激活。",
        "subscription_upgraded": "您的订阅已升级。",
        "process_payment_once_verified": "我们将在核实后处理您的付款信息，并在收到款项后通过 {0} 通知您。",
        "basic_plus_client_verison_required": "需要 5.15.5 或更高版本的客户端。 请访问我们的<a href='https://zoom.us/download#client_4meeting' target='_blank'>下载中心</a>进行更新。",
        "confirmation": {
          "view_my_plan": "查看我的套餐",
          "thank_you_for_choosing_zoom": "感谢您选择Zoom！",
          "thank_you_for_choosing_zoom_with_user_name": "感谢您选择Zoom，{0}！",
          "receive_a_confirmation_email": "您的 {0} 邮箱将很快收到一封含有订单详情的确认电子邮件。",
          "experience_with_zoom": "您今天使用 Zoom 的体验如何？",
          "show_full_order_details": "显示订单摘要",
          "show_less": "显示较少内容",
          "download_zoom": "下载 Zoom",
          "continue_shopping": "借助附加组件充分利用您的套餐",
          "tax_title": "税",
          "tax_desc": "根据您提供的账单信息，您的购买可能需要缴纳地方税。",
          "set_up_desc": "下一步操作是什么？设置您的套餐以便您的组织和团队成员可以正常使用。",
          "set_up_zp_desc": "下一步操作是什么？设置 Zoom Phone，将其激活并解锁主要功能。",
          "user_assign_desc": "下一步操作是什么？将新的许可证分配给账户中的用户。您需要先添加新用户，才能向其分配许可证。",
          "user_cta": "向用户分配许可证"
        },
        "complete_payment_once_received_notice": "Please complete your payment to keep your subscription active. Once we receive your payment, you will be notified at  {0}. Zoom will also send a reminder email for future payments."
      },
      "marketing": {
        "currency": {
          "aud": "\u6FB3\u5143 $",
          "cad": "\u52A0\u5143($)",
          "cny": "\u4EBA\u6C11\u5E01\uFFE5",
          "eur": "\u6B27\u5143 \u20AC",
          "gbp": "\u82F1\u9551 \u00A3",
          "inr": "\u5370\u5EA6\u5362\u6BD4\u20B9",
          "jpy": "\u65E5\u5143\uFFE5",
          "usd": "\u7F8E\u5143 $",
          "php": "\u83F2\u5F8B\u5BBE\u6BD4\u7D22\u20B1",
          "krw": "\u97E9\u5143 (\u20A9)",
          "mxn": "\u58A8\u897F\u54E5\u6BD4\u7D22 ($)",
          "brl": "\u5DF4\u897F\u96F7\u4E9A\u5C14 ($)",
          "zar": "\u5357\u975E\u5170\u7279 (R)",
          "ils": "\u4EE5\u8272\u5217\u9551 (\u20AA)",
          "chf": "\u745E\u58EB\u6CD5\u90CE",
          "sgd": "\u65B0\u52A0\u5761\u5143 ($)",
          "try": "\u571F\u8033\u5176\u91CC\u62C9 (\u20BA)",
          "pen": "\u79D8\u9C81\u65B0\u7D22\u5C14 (S)",
          "sek": "\u745E\u5178\u514B\u6717 (kr)",
          "hkd": "\u6E2F\u5143 ($)",
          "clp": "\u667A\u5229\u6BD4\u7D22 ($)",
          "cop": "\u54E5\u4F26\u6BD4\u4E9A\u6BD4\u7D22 ($)",
          "ars": "\u963F\u6839\u5EF7\u6BD4\u7D22 ($)",
          "nzd": "\u65B0\u897F\u5170\u5143 ($)",
          "pln": "\u6CE2\u5170\u5179\u7F57\u63D0 (z\u0142)",
          "dkk": "\u4E39\u9EA6\u514B\u6717 (Kr)",
          "nkk": "\u632A\u5A01\u514B\u6717 (Kr)",
          "vnd": "\u8D8A\u5357\u76FE (\u20AB)",
          "myr": "\u9A6C\u6765\u897F\u4E9A\u6797\u5409\u7279 (RM)",
          "idr": "\u5370\u5C3C\u5362\u6BD4 (Rp)"
        }
      },
      "terms": {
        "privacy_desc_proceeding": "继续即表示本人同意 <a href=\"/zh-CN/privacy.html\" target=\"_blank\">Zoom 隐私声明</a>和<a href=\"/zh-CN/terms.html\" target=\"_blank\">服务条款</a>。",
        "unchecked_alert_message": "您必须阅读并同意条款和隐私政策，才能继续使用",
        "unchecked_alert_message_eu": "您必须同意条款才能继续使用",
        "eu_14loss": "购买本套餐即表示您明确同意在撤销期限结束前开始履行服务，并确认失去 14 天撤销期限的权利。",
        "tos_14loss": "\u8D2D\u4E70\u5E74\u4ED8\u5957\u9910\u5373\u8868\u793A\u60A8\u540C\u610FZoom\u7684<a target=\"_blank\" href=\"/terms\">\u300A\u670D\u52A1\u6761\u6B3E\u300B</a>\u3001<a target=\"_blank\" href=\"/privacy\">\u300A\u9690\u79C1\u58F0\u660E\u300B</a>\u548C<a target=\"_blank\" href=\"https://explore.zoom.us/en/cookie-policy/\">Cookie\u653F\u7B56</a>\u3002 \u8D2D\u4E70\u672C\u5957\u9910\u5373\u8868\u793A\u60A8\u660E\u786E\u540C\u610F\u5728\u64A4\u9500\u671F\u9650\u7ED3\u675F\u524D\u5F00\u59CB\u5C65\u884C\u670D\u52A1\uFF0C\u5E76\u786E\u8BA4\u5931\u53BB14\u5929\u64A4\u9500\u671F\u9650\u7684\u6743\u5229\u3002",
        "tos_14loss_desc": "\u60A8\u7279\u6B64\u786E\u8BA4\uFF0C\u5728\u4E00\u4E2A\u65E5\u5386\u5E74\u7684\u521D\u59CB\u5408\u540C\u671F\u9650\u7ED3\u675F\u65F6\uFF0C\u82E5\u60A8\u6CA1\u6709\u53D6\u6D88\u6216\u7EED\u7B7E\u65B0\u7684\u5408\u540C\u671F\u9650\uFF0C\u5C06\u6388\u6743Zoom\u65E0\u9650\u671F\u5730\u7EE7\u7EED\u60A8\u7684\u670D\u52A1\uFF0C\u6B64\u540E\u6BCF\u6708\u6536\u53D6\u6708\u4ED8\u91D1\u989D\u4E3A{0}{1}\u6B27\u5143\u7684\u8D39\u7528\uFF08\u542B\u589E\u503C\u7A0E\uFF09\u3002",
        "privacy_desc": "点击“{0}”即表明本人同意 <a class=\"opc-terms-link\" href=\"/terms\" target=\"_blank\">Zoom 的服务条款</a>和<a class=\"opc-terms-privacy-link\" href=\"/privacy\" target=\"_blank\">隐私声明</a>。",
        "privacy_desc_confirm": "点击“{0}”即表明本人同意  <a class=\"opc-terms-link\" href=\"/terms\" target=\"_blank\">Zoom 的服务条款</a>和<a class=\"opc-terms-privacy-link\" href=\"/privacy\" target=\"_blank\">隐私声明</a>。",
        "privacy_desc_inr": "继续即表明本人同意 <a class=\"opc-terms-privacy-link\" href=\"/privacy\" target=\"_blank\">Zoom 的隐私声明</a>和<a class=\"opc-terms-link\" href=\"/terms\" target=\"_blank\">服务条款</a>",
        "recurring_charge_desc": "定期套餐将通过您今天使用的存档付款方式自动续订，并且可以从 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a> 进行访问和更新。 在您取消该套餐之前，系统将在每个续订期向您收取费用。 取消方法是导航至 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a>，然后单击“取消订阅”。 您可以在自动续费生效前一天申请取消。",
        "recurring_charge_desc_append": "如果在发票到期日之前未收到付款，服务可能会暂停，恕不另行通知。",
        "recurring_charge_desc_inr": "周期性套餐将按上述方式自动续订。每次续订都会收取您的费用，直到您取消订阅。您可以导航至 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a> 并选择“取消订阅”来取消。您可以在自动续订生效的前一天申请取消。",
        "recurring_charge_desc_inr_upi_one_time_payment": "在您取消该套餐之前，系统将在每个续订期向您收取费用。取消方法是导航至 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a>，然后选择“取消订阅”。您可以在自动续订生效日之前申请取消套餐。",
        "india_emandate_registering_mandate_with_card": "为了向您的发卡机构注册电子授权，您需要特别授权 {companyName} 根据以下电子授权详细信息从您的卡中划走您所购买服务的订阅费：",
        "india_emandate_registering_mandate_with_bank": "为了向您的银行注册电子授权，您需要特别授权 {companyName} 根据以下电子授权详细信息从您的银行账户中划走您所购买服务的订阅费：",
        "india_emandate_start_date": "电子授权开始日期：{0}",
        "india_emandate_end_date": "电子授权结束日期：{0}",
        "india_emandate_amount_up_to": "金额：达到 {0}（Zoom 仅收取应付总额以内的费用）",
        "india_emandate_confirm_declaration_carefully_read_card": "确认已仔细阅读并理解本声明。您知晓，此电子授权的注册需要按照发卡机构的正当程序进行额外的身份验证，并且您可以随时撤回、查看或修改此电子授权。",
        "india_emandate_confirm_declaration_carefully_read_bank": "确认已仔细阅读并理解本声明。您知晓，此电子授权的注册需要按照银行的正当程序进行额外的身份验证，并且您可以随时撤回、查看或修改此电子授权。",
        "india_emandate_how_recurring_charges_processed": "如何处理周期性费用？",
        "india_emandate_agreement": "电子授权协议",
        "india_emandate_charge_amount": "费用金额",
        "india_emandate_action": "操作",
        "india_emandate_charge_amount_up_to": "达到 15,000 印度卢比",
        "india_emandate_process_payments_through_autopay": "我们将根据下面的电子授权协议，通过自动支付处理您每个计费周期的付款。",
        "india_emandate_charge_amount_more_than": "超过 15,000 印度卢比",
        "india_emandate_manual_payment_through_pay_now": "我们将在您每个计费周期的付款到期时通知您。您每次都需要通过 <a href=\"/paynow\" target=\"_blank\">zoom.us/paynow</a> 进行手动支付。",
        "consent_tokenization_of_card": "您同意，我们授权的第三方令牌服务商对您的卡数据进行标记，以使我们能够保存您的首选付款方式并将其用于支付周期性费用。",
        "consent_tokenization_of_bank": "您同意，我们授权的第三方令牌服务商对您的银行账户数据进行标记，以使我们能够保存您的首选付款方式并将其用于支付周期性费用。",
        "rosca_desc": "定期套餐将通过您今天使用的存档付款方式自动续订，并且可以通过 <a href=\"/billing\" target=\"_blank\">zoom.us/billing</a> 进行访问和更新。 在您取消该套餐之前，系统将在每个续订期向您收取费用。",
        "zoom_events": "我已阅读并同意 <a href=\"https://explore.zoom.us/docs/en-us/zoom_events_host_tou.html\" target=\"_blank\">Zoom Events 主持人使用条款</a>和<a href=\"https://explore.zoom.us/docs/en-us/zoom_events_privacy.html\" target=\"_blank\">Zoom Events 隐私声明</a>。",
        "zoom_events_ppa": "按观众付费套餐规定了自购买之日起的 12 个月内所有活动的观众总数。 超额观众人数将按每位额外观众的费用向您开具发票。 任何未使用的观众额度将在订阅期结束时到期，并且不予退款。",
        "video_sdk": "本人已阅读并同意",
        "video_sdk_term_1": "视频SDK服务条款",
        "video_sdk_term_2": "其他视频SDK条款",
        "and": "和",
        "pay_you_go": {
          "p1": "对于 SDK 服务的使用，其衡量依据应该是客户或其用户在一个月内通过客户应用发起的会议分钟总数（“会议分钟数”）。 例如，有五（5）个最终用户通过客户应用参加 10 分钟的会议，会议分钟总数将为五十（50）分钟。 非整数分钟数将四舍五入。",
          "p2": "即付即用 (「PAYG」) 是 SDK 服務的單月制訂閱。 每個日曆月中，PAYG 內含免費 10,000 會議會程分鐘數。",
          "p3": "某月未使用的会议分钟数不会递延到后续月份。 如某月内客户用完了该月的免费会议分钟数，将按照订单审查页面上的规定向客户收费。 超额的会议分钟数和每次使用费将按月收取，采取后付制。",
          "p4": "费用 - SDK 服务费用，如订单审查页面所述。",
          "p5": "在客户开始使用 SDK 服务的首日开具 SDK 服务发票，在此后的订阅期内每月开具发票。",
          "p6": "Zoom 服务可能需要缴纳州和/地方税费。"
        }
      },
      "signup": {
        "agreements": {
          "collection": "我同意 <a id=\"opc-signup-policy-dc-a\" target=\"_blank\" href=\"https://explore.zoom.us/docs/ko-ko/data-collection-notice.html\">Zoom 的数据收集和使用许可</a>。",
          "reviewAgreement": "我愿意接收 Zoom 发送的有关产品、服务和行业趋势的营销信息。 我了解我可以随时取消订阅。",
          "terms": "我同意 <a id=\"opc-signup-policy-a\" target=\"_blank\" href=\"https://zoom.us/privacy\">Zoom 隐私声明</a>和<a id=\"opc-signup-terms-a\" target=\"_blank\" href=\"https://zoom.us/terms\">服务条款</a>。",
          "title": "请接受必选项才能继续操作。 如果您不接受，您将无法注册 Zoom。 标有 <span class=\"opc-signup-terms__item__important\">*</span> 的项为必选项。",
          "zoom_phone_tos_new": "Zoom Voice Communications 是美国境内的 Zoom Phone 提供商。Zoom 是美国境外的 Zoom Phone 提供商。详情参见<a href=\"https://explore.zoom.us/en/services-description/\" target=\"_blank\"> Zoom 服务说明</a> (Zoom Phone)。"
        }
      },
      "soldtowarn": "\u60A8\u7684\u4E70\u65B9\u56FD\u5BB6/\u5730\u533A\u65E0\u6CD5\u4F7F\u7528\u8BE5\u5E01\u79CD",
      "scheduler": {
        "short_title": "计划程序",
        "title": "Zoom Scheduler",
        "desc": "通过 Google 日历和 Microsoft 365 轻松共享和预订会议时段",
        "more_than_99_users": "如果您需要的用户超过 {0} 个，请<a href=\"{1}\" target=\"_blank\">联系销售人员</a>",
        "exceed_assigned_licenses": "您目前已分配 {0} 个许可证。 {2} 至少需要取消分配 {1} 个许可证才能处理降级，否则无法处理降级。",
        "feature_tooltip": "Zoom Scheduler 通过共享可用性来优化安排，让其他人方便地预约。 与 Zoom Meetings、Zoom Mail 和 Zoom Calendar 无缝配合使用，并与 Google 和 Microsoft 365 集成。",
        "feature_details": {
          "item1": "轻松共享会议时段，轻松预订",
          "item2": "与 Zoom Meetings、Zoom Mail 和 Calendar、Google 和 Microsoft 365 配合使用"
        },
        "plan_details": {
          "calender_integration": "<span class=\"{0}\">日历集成</span> <span class=\"{1}\"> Google、Microsoft 365 等</span>",
          "recurring_availability": "<span class=\"{0}\">周期性可用性</span> <span class=\"{1}\"> 共享可预订时段</span>",
          "scalable_meeting": "<span class=\"{0}\">可扩展会议</span> <span class=\"{1}\"> 一个或多个观众的单次会议（使用基础版套餐时，每次最多 40 分钟）</span>",
          "customizable_notifications": "<span class=\"{0}\">可定制的通知</span> <span class=\"{1}\"> 自动发送电子邮件或短信提醒和确认</span>"
        },
        "free_trial_descriptions": {
          "duration": "一名用户可免费使用 Zoom Scheduler {0} 天",
          "sharelink": "通过一个链接分享可用时段",
          "customizable": "发送可定制的确认和提醒",
          "cancel": "随时取消"
        },
        "free_trial_footer": "需要适用于多个用户的 Zoom Scheduler？ <a href=\"{0}\">立即购买</a>",
        "biz_include_tip": "您账户中的每个 Zoom Workplace 商业版或商业版 Plus 用户都可以访问 Zoom Scheduler。如果您购买更多名额，您可以将其分配给账户中的任何基本用户。",
        "basic_include_tip": "Scheduler 包含在商业版和商业版 Plus 套餐中。使用基本版套餐时，每次会议限时 40 分钟。",
        "remove_in_biz_message": "Scheduler 包含在 Workplace 商业版套餐中，已从您的购物车中移除。"
      },
      "planform": {
        "zoom_meeting": {
          "less_than_assigned_number_tips": "您当前有{0}个免费试用用户，您需要为这些现有用户购买许可证。<br/>或者<a href=\"/account/user\" target=\"_blank\">前往“用户管理”</a>，至少取消分配{1}个许可证。",
          "less_than_assigned_number_tips_no_br": "您当前有{0}个免费试用用户，您需要为这些现有用户购买许可证。或者<a href=\"/account/user\" target=\"_blank\">前往“用户管理”</a>，至少取消分配{1}个许可证。",
          "less_than_assigned_number_tips_for_expire": "You currently have {0} user(s) with free trials, you will need to purchase licenses for those existing user(s)."
        },
        "unit": {
          "number": "号码",
          "user": "\u7528\u6237",
          "license": "许可证",
          "room": "Room(s)",
          "host": "Host(s)",
          "port": "\u7AEF\u53E3",
          "account": "Account(s)",
          "membership": "Membership(s)",
          "credits": "Credits"
        },
        "singular_unit": {
          "number": "号码"
        },
        "can_not_select_monthly": "如果您想按月订阅 {0}，您需要先将 {1} 套餐更新为月度订阅。  <a href=\"/billing\">返回到套餐管理</a>",
        "can_not_select_with_special_addon": "如果您想按{2}订阅 {0}，您需要先将 {1} 套餐更新为{2}订阅。  <a href=\"/billing\">返回到套餐管理</a>",
        "can_not_select_monthly_with_base": "如果您想按月订阅，您需要先将 {1} 套餐更新为月度订阅。 <a href=\"/billing\">返回到套餐管理</a>",
        "can_not_select_annual_with_base": "如果您想按年订阅，您需要先将 {0} 套餐更新为年度订阅。 <a href=\"/billing\">返回到套餐管理</a>",
        "can_not_select_annual_with_base_without_link": "如果您想按年订阅，您需要先将 {0} 套餐更新为年度订阅。",
        "can_not_select_monthly_with_annual_addon": "{0} 已选为按年计费，{1} 无法按月计费，因为您的基础套餐为按月计费。",
        "monthly_base_disable_tooltip": "根据您的 {0} 订阅周期，您只能为 Zoom One 选择按年付费选项。 如果您想按月付费，请将您的附加组件订阅切换为月付套餐。",
        "monthly_as_base_disable_tooltip": "Based on your subscription cycle for {0}, you can only select the annual payment option for {1}. Switch your add-on subscriptions to monthly plans if you want to pay monthly.",
        "annual_addon_disable_tooltip": "根据您的 {0} 订阅周期，您只能为 {1} 选择按月付费选项。 如果您想按年付费，请将您的 {0} 订阅转换为年付套餐。",
        "annual_addon_disable_alert": "如果您需要其他人数名额或按年订阅 {0}，您需要先将 {1} 套餐更新为年度订阅。 <a href=\"/billing\">返回到套餐管理</a>",
        "up_to": "最多 {0} 名",
        "large_meeting": {
          "capacity_intro": "The Large Meeting add-on increases limits of your other licenses:"
        },
        "introduction": {
          "participant": {
            "panelists": "嘉宾",
            "share_screen": "Share Screen",
            "audio": "Audio",
            "video": "Video",
            "panelist_desc": "Speakers and people helping to run your event (moderators, interpreters, etc.)",
            "attendees": "Attendees",
            "attendees_desc": "Joined people",
            "listen_only": "Listen-Only",
            "view_only": "View-Only",
            "remark_1": "Your panelists and participants can join your webinars with <strong>no need</strong> to purchase or download Zoom.",
            "remark_2": "A participant can be promoted to a panelists by the host or co-host of the webinar."
          }
        },
        "title": {
          "webinar": "Zoom Webinars",
          "zoomroom": "Zoom Rooms",
          "zoomphone": "Zoom Phone",
          "zoom_contact_center": "Zoom Contact Center",
          "phone_number": "Phone Number",
          "rc": "Conference Room Connector",
          "large_meeting": "Large Meeting",
          "tollfree": "Audio Conferencing",
          "cmr": "Cloud Recording Storage",
          "zoom_meeting": "Zoom Meetings",
          "zoom_meeting_zoomonenew": "Zoom One",
          "pro": "Pro",
          "biz": "Business",
          "zoom_one_education": "Zoom Meetings 教育版",
          "zo_edu_sch_cmp": "Zoom One 教育解决方案学校和校园版",
          "education": "education",
          "biz_inr": "Business India",
          "zoom_united": "Zoom United",
          "bundle": "\u4F01\u4E1A",
          "video_sdk": "Video SDK",
          "zoom_hardware": "Zoom Hardware",
          "hipaa_compliance": "Business Associate Agreement (US Only)",
          "phia_compliance": "Protected Health Information Annex (Canada Only)",
          "paid_developer": "Premier Developer Support",
          "zoom_events": "Zoom Events",
          "quality_streaming_service": "Quality Streaming Service",
          "zoom_node": "Zoom Node",
          "mio": "Mio Chat Interoperability (US Only)",
          "zoom_iq": "Zoom IQ for Sales",
          "zoom_whiteboard": "Zoom Whiteboard",
          "zoom_whiteboard_plus": "Zoom Whiteboard Plus",
          "zwbbasic": "Zoom Whiteboard",
          "zwbplus": "Zoom Whiteboard Plus",
          "zoom_one": "Zoom One",
          "zoom_one_pro": "Zoom One Pro",
          "zoom_one_ent": "Zoom One Enterprise",
          "zoom_one_ent_plus": "Zoom One Enterprise Plus",
          "zoom_one_plus": "Zoom One Plus",
          "zoom_one_biz": "Zoom One Business",
          "zoom_one_biz_plus": "Zoom One Business Plus",
          "zoom_one_enterprise": "Zoom One Enterprise",
          "zoom_one_ent_essentials": "Zoom One Enterprise Essentials",
          "biz_plus": "Business Plus",
          "translation": "Zoom Translated Captions",
          "video_sdk_translation": "Video SDK transcription and translation",
          "workspace_reservation": "Workspace Reservation",
          "cmk": "Zoom Customer Managed Key",
          "ldk_cmr": "Zoom Video SDK Recording",
          "whiteboard_subtitle": "You can purchase both Whiteboard and Whiteboard Plus license and assign to different users.",
          "zoom_mesh": "Zoom Mesh",
          "zva": "Zoom Virtual Agent",
          "additional_host": "Additional Host",
          "additional_co_editor": "Additional Co-Editor",
          "eventsaascore": "Zoom Sessions",
          "eventsaascore_consumption": "Zoom Sessions Pay Per Attendee",
          "eventsaas_consumption": "Zoom Events Pay Per Attendee",
          "api_csp": "Integration Meeting Plan",
          "video_sdk_crc": "Video SDK Cloud Room Connector",
          "zsu": "Zoom Phone",
          "zoom_revenue_accelerator": "Zoom Revenue Accelerator"
        }
      },
      "error": {
        "field_required": "\u6B64\u5B57\u6BB5\u4E3A\u5FC5\u586B\u5B57\u6BB5\u3002",
        "email_invalid_address": "\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u65E0\u6548",
        "email_address_incorrect": "输入有效的电子邮件地址",
        "edu_email_address_tip": "您的电子邮件地址必须以“.edu”结尾才能购买此产品",
        "confirm_email_address_no_match": "Confirm email address doesn’t match",
        "invalid_url": "\u65E0\u6548\u7F51\u5740",
        "has_pending_plans_change_tips": "\u65E0\u6CD5\u66F4\u6539\u6B64\u8BA1\u5212\uFF0C\u56E0\u4E3A\u5F53\u524D\u5B58\u5728\u53EF\u80FD\u4F1A\u5F71\u54CD\u6B64\u7C7B\u53D8\u66F4\u7684\u5F85\u5904\u7406\u5957\u9910\u3002\u8BF7\u8054\u7CFB<a href='/contactsales' target='_blank'>\u9500\u552E\u4EBA\u5458</a>\u66F4\u6539\u5F53\u524D\u6216\u5F85\u5904\u7406\u7684\u8BA1\u5212\u3002",
        "has_time_based_discount_change_tips": "\u4F60\u5F53\u524D\u7684\u8BA1\u5212\u53EF\u4EAB\u53D7\u6298\u6263\u81F3{0}\u3002\u5982\u679C\u73B0\u5728\u5347\u7EA7\uFF0C\u5219\u5F53\u524D\u5957\u9910\u6298\u6263\u5C06\u5931\u6548\u3002\u4F60\u4E5F\u53EF\u4EE5\u7B49\u5230\u6298\u6263\u5230\u671F\u540E\u518D\u5347\u7EA7\u3002",
        "can_not_bought_plan_tips": "您无法对您的账户进行此更改。 您<a target=\"_blank\" href=\"/contactsales\">提交此表单</a>后，我们的团队可以帮助您解决任何问题。",
        "downgrade_alert_info": "要继续降级，请在 {1} 之前取消分配 {0} 个用户。 否则，将不会处理降级。",
        "downgrade_alert_info_in_plan_change": "要继续套餐变更，请在 {1} 前取消分配 {0}。 否则，将不会处理套餐变更。",
        "downgrade_alert_info_license": "To proceed with the downgrade, unassign {0} license(s) by {1}. Otherwise, downgrade will not be processed.",
        "downgrade_alert_info_no_date": "要继续降级，请在下一个计费日期之前取消分配 {0} 个用户。 否则，将不会处理降级。",
        "downgrade_alert_info_no_date_license": "To proceed with the downgrade, unassign {0} license(s) by before your next billing date. Otherwise, downgrade will not be processed.",
        "buld_acount_license": "您的账户具有批量许可证，无法在线更改。 要更改您的账户，请<a href='/billing/contactus' target='_blank'>联系我们</a>。",
        "downsell_desc_title": "您确定要将您的套餐降级吗？",
        "downsell_desc_tips": "您为减少此套餐的许可证数量所做的变更将在 {0} 之后生效，您将在下一张发票上看到此更改。",
        "downsell_desc_tips_common": "您对此套餐所做的变更将在 {0} 之后生效，下一张发票上将显示此变更。",
        "downsell_desc_tips_common_generic": "If you’d like to proceed with the downgrade, changes for each plan will take effect at the end of their current billing term.",
        "one_month_error_tips": "您不能更改此套餐，因为这些变更将在下一个计费周期生效，并且此单月套餐将在其一个月期限结束时到期。",
        "annual_addon_disable_tooltip": "\u7531\u4e8e\u4f60\u7684\u57fa\u7840\u5957\u9910{1}\u76ee\u524d\u6309\u6708\u5ea6\u8ba1\u8d39\uff0c\u56e0\u6b64\u65e0\u6cd5\u4e3a{0}\u9009\u62e9\u5e74\u5ea6\u8ba1\u8d39\u3002\u5982\u679c\u8981\u4e3a\u8be5\u5957\u9910\u9009\u62e9\u5e74\u5ea6\u8ba1\u8d39\uff0c\u8bf7\u5c06{1}\u7684\u8ba1\u8d39\u5468\u671f\u4fee\u6539\u4e3a\u5e74\u5ea6\u3002",
        "downgrade_alert_for_ze_addon": "若要继续降级，请于 {2} 之前在许可证管理中取消分配 {0} 名 {1}，否则将无法处理降级。",
        "downgrade_pre_confirm_for_ze_addon": "您需要于 {2} 之前在许可证管理中删除追加的 {0} 名 {1}，否则将无法在您的账户中处理降级。",
        "existing_plan_msg": "Your account {0} already has {1}. Manage your existing plan or <a href='/billing'>click here</a> to view our other offers.",
        "smb_plan_billing_cycle_change_title": "是否确定要更改订阅周期？",
        "smb_plan_billing_cycle_change_content": "您当前处于自定义订阅周期。更改为标准版套餐后，将无法恢复为此自定义套餐。",
        "smb_plan_billing_cycle_change_yes": "是的，下订单",
        "smb_plan_billing_cycle_change_no": "否，立即返回",
        "upi": {
          "invalid_request": "由于所提供的付款方式存在未知问题，我们无法处理这笔付款。 请尝试使用其他付款方式。 如果问题仍然存在，请联系开户行。"
        },
        "cant_add_100": "每次交易的用户人数上限为 99 人。",
        "email_cant_use_confirm": {
          "title": "Email address cannot be used",
          "message": "You’re currently signed in with a non-education email address. To purchase an education plan, please sign out and then sign in with an email from an educational domain. If you need assistance, <a href=\"/contactsales\" target=\"_blank\">contact sales</a> for manual verification.",
          "confirm_text": "Sign out",
          "cancel_text": "View my current plan"
        },
        "form_with_error_fields": "请更正上面所有高亮显示的字段才能继续。"
      },
      "rps_no_purchase": "\u5F88\u9057\u61BE\uFF0C\u7531\u4E8E\u76D1\u7BA1\u539F\u56E0\uFF0C\u6211\u4EEC\u65E0\u6CD5\u5B8C\u6210\u672C\u6B21\u4EA4\u6613\u3002 \u60A8\u5C06\u65E0\u6CD5\u8D2D\u4E70 Zoom \u4EA7\u54C1\uFF0C\u4E0D\u4FBF\u4E4B\u5904\uFF0C\u656C\u8BF7\u539F\u8C05\u3002 \u5982\u679C\u60A8\u8BA4\u4E3A\u5B58\u5728\u9519\u8BEF\uFF0C\u60A8\u53EF\u4EE5\u4F7F\u7528\u6B64<a href=\"/compliance-appeals?zan={0}\" target=\"_blank\">\u8868\u5355</a>\u63D0\u4EA4\u8BF7\u6C42\u3002",
      "rps_no_purchase_product": "Unfortunately, due to regulatory reasons, we are not able to complete your request. We apologize for any inconvenience, but you will not be able to make the requested change. If you think this is an error, you can submit a request using this <a href=\"/compliance-appeals?zan={0}\" target=\"_blank\">form</a>.",
      "rps_still_processing": "\u6211\u4EEC\u4ECD\u5728\u5904\u7406\u60A8\u7684\u4EA4\u6613\u3002 \u60A8\u5C06\u5728 1-2 \u4E2A\u5DE5\u4F5C\u65E5\u5185\u6536\u5230\u4E00\u5C01\u6709\u5173\u66F4\u65B0\u8BE6\u60C5\u7684\u7535\u5B50\u90AE\u4EF6\u3002 \u8BF7\u52FF\u5C1D\u8BD5\u91CD\u590D\u8D2D\u4E70\uFF0C\u5426\u5219\u53EF\u80FD\u9020\u6210\u591A\u6B21\u6536\u8D39\u3002",
      "rps_still_processing_product": "We are still working on processing your request. You will receive an email with more information within 1-2 business days with an update. Please do not attempt this change again, as it may result in errors.",
      "rps_block_new_pending": "\u5F88\u9057\u61BE\uFF0C\u6211\u4EEC\u65E0\u6CD5\u5904\u7406\u8FD9\u7B14\u65B0\u4EA4\u6613\u3002 \u6211\u4EEC\u4ECD\u5728\u5904\u7406\u60A8\u7684\u7B2C\u4E00\u7B14\u4EA4\u6613\u3002 \u60A8\u5C06\u5728 1-2 \u4E2A\u5DE5\u4F5C\u65E5\u5185\u6536\u5230\u4E00\u5C01\u542B\u6709\u66F4\u591A\u8BE6\u60C5\u7684\u7535\u5B50\u90AE\u4EF6\uFF0C\u5176\u4E2D\u5305\u542B\u60A8\u7B2C\u4E00\u7B14\u4EA4\u6613\u7684\u6700\u65B0\u4FE1\u606F\u3002 \u5728\u5904\u7406\u5B8C\u7B2C\u4E00\u7B14\u4EA4\u6613\u4E4B\u524D\uFF0C\u60A8\u5C06\u65E0\u6CD5\u5904\u7406\u65B0\u7684\u4EA4\u6613\u3002",
      "return_home": "回到主页",
      "rps_no_update": "\u60A8\u5F53\u524D\u65E0\u6CD5\u66F4\u65B0\u6B64\u4FE1\u606F\u3002 \u8BF7\u5728 1-2 \u4E2A\u5DE5\u4F5C\u65E5\u540E\u91CD\u8BD5\u3002",
      "pro2biz": {
        "title": "专业版至商业版"
      },
      "cycle": {
        "monthly": "\u6708\u5EA6",
        "annual": "\u5E74",
        "one_month": "单月",
        "quarterly": "季度",
        "two_years": "两年",
        "three_years": "三年"
      },
      "partner": {
        "landing": {
          "dropbox": {
            "title": "使用可享受 {0}% 折扣的 Dropbox 基本版，提高工作效率",
            "desc_01": "购买 Zoom Workplace 年付套餐的 Dropbox 新客户有资格享受 Dropbox 基本版 {0}% 的折扣优惠。",
            "desc_02": "Dropbox 基本版包括适用于一个用户的 3 TB 存储空间、无限制签名请求、高达 100 GB 的文件共享和高级共享分析。",
            "get_offer": "获得报价",
            "terms": "Zoom 可能会与 Dropbox 共享我的电子邮件，以验证我是否有资格参加此促销活动",
            "feature_title": "提高效率并优化连接方式",
            "feature_desc01": "使用 Dropbox Sign 发送不受限制的签名请求",
            "feature_desc02": "使用 Zoom AI Companion 重塑团队合作与协作",
            "feature_desc03": "通过 Zoom Clips 录制短视频，并在 Dropbox 上进行标记、评论和定稿。",
            "error": {
              "title": "您目前没有资格享受此优惠",
              "upgrade_now": "立即升级",
              "defaultCase": {
                "message": "感谢您对 Dropbox 优惠的关注。该优惠不适用于购买年付套餐的 Zoom 客户或 Dropbox 现有客户。您可能有资格获得其他 Zoom 合作伙伴提供的优惠。请查看我们的客户优惠页面了解更多信息。",
                "action_btn": "访问客户优惠"
              },
              "freeExist": {
                "message": "您仍然可以升级到 Zoom Workplace 专业版。通过具有 AI Companion 功能的协作平台 Zoom Workplace，重塑您的连接方式。探索一系列高级功能 — 无限会议、生产力应用等。"
              },
              "monthlyExist": {
                "message": "感谢您对 Dropbox 优惠的关注。该优惠不适用于 Dropbox 现有客户。升级到 {0}年付套餐，您还可以节省高达 16% 的费用。"
              },
              "dropboxApiUnavailable": {
                "title": "Oops! Something went wrong",
                "message": "\u7CFB\u7EDF\u76EE\u524D\u65E0\u6CD5\u5904\u7406\u4F60\u7684\u8BF7\u6C42\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002"
              }
            }
          }
        },
        "disabled_4_monthly": "{0} 提供的优惠仅适用于年度订阅。",
        "offer_detail_title": "优惠详情",
        "offer_detail_cta": "优惠详情",
        "special_offer": "特价",
        "offer_no_longer_applies_title": "优惠不再适用",
        "proceed_without_offer": "继续，不使用优惠",
        "unsupport_device_tips": "很抱歉！ 此优惠目前在移动设备上不可用。 要继续，请在桌面设备上兑换此优惠。",
        "exclusive_discount": {
          "subtitle": "Zoom Customer Discount"
        },
        "special_promo": {
          "title": "Special Promotion",
          "limit_time": "LIMITED TIME"
        },
        "masterclass": {
          "title": "MasterClass",
          "display_title": "MasterClass - Individual ({0}-months)",
          "license_tooltip": "The Masterclass user count cannot exceed Zoom One license count.",
          "license_alert": "The {0} membership count must be equal to or less than the {1} user count.",
          "cycle_amount": "{0} for {1} months",
          "desc": "Gain access to 185+ classes and original series led by industry experts while discovering new classes every month.",
          "unit_tips": "The MasterClass Membership is a non-recurring plan.  At the end of the 12 months, you may purchase a membership renewal directly from MasterClass.",
          "cart_cycle_desc": "{0} Months (One-Time Payment)",
          "provide_tips": "*Service is provided by MasterClass",
          "cart_title": "MasterClass - Individual",
          "goto_billing_page_tips": "To increase the number of membership for {addon}, you need to adjust your {base} user quantity to equal to or more than {addon}. <a href=\"/billing\">Return to Plan Management</a>"
        },
        "error": {
          "expire_partner": "We're sorry, the {0} promotion has ended on {1}."
        }
      },
      "export_control": {
        "biz_org_type": "\u4F01\u4E1A/\u7EC4\u7EC7\u7C7B\u578B",
        "biz": "零售/批发",
        "fin": "\u94F6\u884C\u6216\u5176\u4ED6\u91D1\u878D\u673A\u6784",
        "edu": "幼儿园及中小学教育",
        "med": "\u516C\u5171\u536B\u751F\u6216\u533B\u7597\u7EC4\u7EC7",
        "util": "\u516C\u7528\u4E8B\u4E1A",
        "telcomm": "\u56FD\u5BB6\u7535\u4FE1\u516C\u53F8",
        "edu_high": "\u5927\u5B66/\u9AD8\u7B49\u6559\u80B2",
        "sci_tech_inst": "\u79D1\u6280\u7814\u7A76\u673A\u6784\u6216\u56FD\u5BB6\u5B9E\u9A8C\u5BA4",
        "gov": "\u56FD\u5BB6\u3001\u7701/\u5DDE\u6216\u5F53\u5730\u653F\u5E9C\u673A\u6784\u3001\u529E\u516C\u5BA4\u6216\u653F\u5E9C\u90E8\u95E8",
        "other": "\u5176\u4ED6",
        "input_placeholder": "\u8F93\u5165\u4F01\u4E1A/\u7EC4\u7EC7\u7C7B\u578B",
        "adv": "广告",
        "mfg": "制造业和工业",
        "ps": "专业服务和咨询",
        "bp": "生物技术/制药",
        "cnstr": "建筑",
        "ent": "娱乐",
        "lgl": "法律",
        "hpy": "酒店服务",
        "np": "非营利",
        "tech": "技术",
        "trans": "运输",
        "re": "房地产"
      },
      "visitor_management": {
        "title": "Visitor Management",
        "desc": "Check-in and manage visitors through a secure and efficient registration platform.",
        "tips_invitations_access": "Send customizable office invitations and securely manage access",
        "tips_kiosks": "Set up registrations in advance or on the spot with kiosks",
        "tips_alerts": "Get instant alerts when guests arrive",
        "tips_track": "Keep track of how the office space is used with detailed metrics"
      },
      "config": {
        "select_number_license": "选择许可证数量"
      },
      "zoom_revenue_accelerator": {
        "tooltip": "{0} 许可证数量必须等于或小于 {1} 用户数量。"
      },
      "zoom_session": {
        "select_label": "Zoom sessions select number of attendees"
      },
      "zoom_events": {
        "select_label": "Zoom events select number of attendees",
        "upgrade": {
          "prompt_title": "确定要下单吗？",
          "ppa_lose_prompt_desc": "您将永久失去当前  {0}  套餐中的任何剩余观众数量，并且不会收到退款。",
          "saas_has_free_event_desc": "一旦本套餐的变更在  {1}  生效，超过新观众容量  {0}  的额外观众将无法参加。",
          "saas_has_paid_event_desc": "您至少有一次即将举行的付费活动，其观众容量高于  {0} 。 若要继续更改套餐，请让许可证所有者于  {1}  之前减少活动观众容量或取消活动。",
          "saas_has_free_and_paid_event_desc": "若要继续更改套餐，请确保许可证所有者于 {1}之前将即将举行的付费活动观众容量减少至 {0} 名或取消活动。<br/><br/>此外，{1}之后，参加免费活动的观众人数将不得超过 {0} 名。"
        }
      },
      "concurrent_meeting_basic": {
        "title": "并行会议（基础版）",
        "select_license_tip": "一名授权主持人最多可以同时主持 4 场会议。"
      },
      "concurrent_meeting_plus": {
        "title": "Concurrent Meeting Plus"
      },
      "delta": {
        "add_user": "将更多的用户添加到您的当前套餐",
        "cur_users": "您的当前套餐有 {X} 名用户。",
        "cur_plan_details": "当前套餐详细信息",
        "cur_plan_detail": "查看当前套餐详情",
        "not_eligible_for_offer": "很抱歉，您不符合享受此优惠的条件",
        "offer_exclusive_to": "此优惠活动仅限于 {0} 用户。",
        "new_users": "新用户"
      },
      "prorated": {
        "cur_users": "您的当前套餐有 {0} 个{1}。",
        "prorated_period_tooltip": "此按比例收取的费用是根据您从今天起到下次收费日期为止的新订阅计算的。",
        "charge_tooltip": "今日费用是根据当前订阅中新增用户的剩余天数，加上适用的按比例分摊税款计算得出的。",
        "xx_new_unit": "{0} 个新{1}",
        "transaction_credit_applied": "已应用的折抵金额",
        "transaction_credit_tip": "今天，您将收到现有套餐中未用天数的折抵金额{0}。",
        "existing_credit_applied": "已应用的现有折抵余额",
        "remaining_credit": "今天购买后，您的折抵余额将为 {0}。",
        "refund_credit_usage": "剩余折抵金额将应用于未来的购买。",
        "current_summary": "当前套餐摘要",
        "updated_summary": "更新的套餐摘要",
        "charged_period": "{0} 按比例收费"
      },
      "healthcare": {
        "title": "Zoom 医疗保健解决方案",
        "desc": "美国医疗保健客户需要签署 BAA 以符合 HIPAA 规定，而加拿大客户则需要签署 PHIA 协议。",
        "business_country_select": {
          "label": "选择业务所在国家/地区",
          "option_label": {
            "united_states": "美国协议 (BAA)",
            "canada": "加拿大协议 (PHIA)",
            "other": "其他"
          }
        },
        "read_agreement": "阅读协议",
        "baa_accepted": "已接受商业伙伴协议",
        "phia_accepted": "已接受受保护健康信息附件",
        "not_eligible_tip": "根据您的选择，无法启用 BAA 或 PHIA。您可以继续购买不含 Zoom 医疗保健解决方案的 {0}，或者<a class=\"zm-button zm-button--link opc-link-btn\" href=\"/contactsales\" target=\"_blank\">联系销售人员</a>寻求帮助。",
        "agreement_dialog": {
          "guide_to_accept_tip": "在接受协议之前，请仔细阅读协议内容。",
          "accept": "我接受"
        },
        "switch_plan_confirm": {
          "title": "不符合 BAA 或 PHIA 的套餐",
          "desc": "BAA 或 PHIA 合规性仅包含在专业版套餐中。切换到商业版套餐将从您的购物车中删除此合规性。<br /><br />如需了解更多信息，请<a class=\"zm-button zm-button--link opc-link-btn\" href=\"/contactsales\" target=\"_blank\">联系销售人员</a>。"
        },
        "address": {
          "not_eligible_tip": "根据您所在的国家或地区，无法启用 BAA 或 PHIA 协议，如果您继续操作，这些协议将被删除。您可以继续购买不含 Zoom 医疗保健解决方案的 {0}，或者<a class=\"zm-button zm-button--link opc-link-btn\" href=\"/contactsales\" target=\"_blank\">联系销售人员</a>寻求帮助。"
        }
      },
      "license_assigned_limit_toolips": "许可证数量必须等于当前分配给您账户中用户的 Webinar 许可证数量。",
      "zuoraoutage": {
        "terms": "现在，您只需支付首{0}的费用。您可以导航至 <a href=\"https://zoom.us/billing\" target=\"_blank\">zoom.us/billing</a> 进行续订或取消套餐。",
        "payment_warning": "很遗憾，我们的付款系统目前存在延迟情况，我们正在努力解决该问题。如果您使用借记卡或信用卡下单，您将可以立即使用 Zoom 基础版功能，并且系统将在几个小时内自动处理您的付款。",
        "payment_blocking_warning": "很遗憾，我们的付款系统目前存在延迟情况，我们正在努力解决该问题。请在几小时后重试。感谢您耐心等待。",
        "expire_date": "于 {0} 到期",
        "confirmation_warning": "我们已收到您的订单，但遗憾的是，我们的付款系统目前存在延迟情况，我们正在努力解决该问题。系统将在几个小时内自动处理您的订单，在此之前，您可以使用 Zoom 基础版功能。",
        "success_title": "您的套餐即将准备就绪",
        "success_subtitle": "一旦订单处理完毕，您将通过 {0} 收到一封含有订单详细信息的确认电子邮件。",
        "view_my_plan_status": "查看我的套餐状态",
        "payment_processing": "付款处理",
        "zoom_workplace_basic_title": "Zoom Workplace 基础版",
        "zoom_workplace_basic_introduction_1": "每次会议 40 分钟，最多可容纳 100 名参会者",
        "zoom_workplace_basic_introduction_2": "3 个可编辑白板",
        "zoom_workplace_basic_introduction_3": "将录制的会议保存在本地设备上",
        "zoom_workplace_basic_introduction_4": "团队聊天"
      },
      "event_services": {
        "title": "Webinars 活动服务咨询",
        "desc": "与您的 Zoom 专家合作，最大限度地提升单次网络研讨会的效果。服务内容包括一小时规划、一小时活动前技术检查以及长达三小时的活动监控。在工作日和周末均可提供支持服务。",
        "view_terms": "查看条款",
        "hide_terms": "隐藏条款",
        "terms_content": "单次网络研讨会订阅和网络研讨会活动服务咨询必须在购买之日起的三个月内使用，如果客户在三个月期限内未使用，将会自动失效。<br /><br />\n\n 作为客户单次网络研讨会订阅的一部分，Zoom 将向客户提供下列额外的活动技术支持服务：<br /><br />\n\n 活动顾问将以电话形式提供 1 小时的规划服务，用于查看设置、功能并讨论议程和活动角色；活动将要开始前，将与演讲者一起进行 1 小时的音频和视频技术检查；提供最长达 3 小时的实时活动支持，Zoom 将在此期间主动监控演讲者连接情况并提供会议内技术支持。超过三小时的网络研讨会可能需要额外的付费咨询服务。对于订阅单次网络研讨会（观众人数为 250,000 人以上）的客户，Zoom 制作专家将代替活动顾问提供音视频制作技术支持（“网络研讨会活动服务咨询”）。所有网络研讨会活动服务咨询均由 Zoom 以远程方式提供。网络研讨会活动服务咨询仅限于上述包含的特定技术支持服务，为清楚起见，不包括（但不限于）以下服务：针对第三方提供商的支持或管理服务、音视频制作服务、音视频硬件、故障排除或更换服务、内容创建服务、促销、市场营销或注册服务、报告和数据分析、随叫随到的支持以及定制制作工具的持续技术支持。<br /><br />\n\n 最多有 100,000 名观众的网络研讨会必须在购买后至少 48 小时内安排。对于观众人数在 250,000 到 1,000,000 的网络研讨会，活动必须在您与我们的活动服务团队进行初次咨询后至少 7 天内安排。Zoom 将发送一封电子邮件，确认约定的日期和时间。客户可以提出一次性请求更改活动日期，但须事先获得 Zoom 批准，并且 Zoom 将在时间允许的情况下提供网络研讨会活动服务咨询。",
        "unit": {
          "million_1": "100 万",
          "million_1_uppercase": "100 万"
        },
        "price_included": "包含",
        "x_hours_per_license": "每个许可证 5 小时"
      },
      "single_use_webinar": {
        "notification": "最多有 100,000 名观众的网络研讨会必须在购买后至少 48 小时内安排。对于观众人数在 250,000 到 1,000,000 的网络研讨会，活动必须在您与我们的活动服务团队进行初次咨询后至少 7 天内安排。活动服务专家将在 48 小时内与您联系，帮助您规划活动。与您联系前，您可以测试您的网络研讨会并主持最多有 10 名观众的网络研讨会。超过三小时的网络研讨会可能需要额外的付费咨询服务。",
        "terms": "单次网络研讨会必须在购买之日起的三个月内举办。任何未使用的单次网络研讨会和咨询服务将在购买之日起的三个月后失效。此购买项不可退款。",
        "success_thanks": "您的 <b style='font-weight: 600'>{email}</b> 邮箱将收到一封包含订单详情的确认电子邮件，我们的活动服务咨询团队将在 48 小时内与您取得联系。如有紧急请求，请发送邮件至 <a href='javascript:void(0);'>eventservices+customer@zoom.us</a> 联系我们。"
      },
      "single_use_meeting": {
        "desc": "畅享无限时会议、云录制、AI Companion 等功能！",
        "expire_desc_for_pro": "三个月后到期",
        "within_three_months": "三个月内",
        "terms": "需要有 Zoom One Pro 许可证才能获取网络研讨会服务，许可证已包含在内，无需支付费用。您的 Zoom One Pro 许可证将在购买之日起三个月后到期。",
        "a_to_b_attendees": "{0} 至 {1} 名观众"
      },
      "attendees_remark_1": "您的嘉宾和观众<strong>无需</strong>购买或下载 Zoom 即可加入您的网络研讨会。",
      "attendees_remark_2": "网络研讨会的主持人或联席主持人可以将观众提升为嘉宾。",
      "ai_companion_learn_more": {
        "ai_companion_desc": "Zoom AI Companion 是您的智能 AI 助手，可帮助您完成更多工作、与同事进行协作并增强您的沟通方式",
        "ai_tips1": "获取会后总结，并通过团队聊天或电子邮件轻松与他人共享",
        "ai_tips2": "使用可搜索的转录文字、主题章节等功能，更快地查看录制文件",
        "ai_tips3": "如果您迟到了，借助 AI Companion 进行聊天以赶上进度，并查看正在讨论的内容的详细信息",
        "ai_tips4": "对聊天内容和电子邮件的风格、篇幅和内容偏好进行个性化设置",
        "ai_footer_text": "AI Companion 包含在 Zoom 用户账户的付费服务中，无需支付额外费用。可能不包括部分垂直行业和地区。"
      }
    },
    "country": {
      "AF": "\u963F\u5BCC\u6C57",
      "AX": "\u963F\u5170\u7FA4\u5C9B",
      "AL": "\u963F\u5C14\u5DF4\u5C3C\u4E9A",
      "DZ": "\u963F\u5C14\u53CA\u5229\u4E9A",
      "AS": "\u7F8E\u5C5E\u8428\u6469\u4E9A",
      "AD": "\u5B89\u9053\u5C14",
      "AO": "\u5B89\u54E5\u62C9",
      "AI": "\u5B89\u572D\u62C9",
      "AQ": "\u5357\u6781\u6D32",
      "AG": "\u5B89\u63D0\u74DC\u548C\u5DF4\u5E03\u8FBE",
      "AR": "\u963F\u6839\u5EF7",
      "AM": "\u4E9A\u7F8E\u5C3C\u4E9A",
      "AW": "\u963F\u9C81\u5DF4",
      "AC": "\u963F\u68EE\u677E\u5C9B",
      "AU": "\u6FB3\u5927\u5229\u4E9A",
      "AT": "\u5965\u5730\u5229",
      "AZ": "\u963F\u585E\u62DC\u7586",
      "BS": "\u5DF4\u54C8\u9A6C\u7FA4\u5C9B",
      "BH": "\u5DF4\u6797",
      "BD": "\u5B5F\u52A0\u62C9\u56FD",
      "BB": "\u5DF4\u5DF4\u591A\u65AF",
      "BY": "\u767D\u4FC4\u7F57\u65AF",
      "BE": "\u6BD4\u5229\u65F6",
      "BZ": "\u4F2F\u5229\u5179\u57CE",
      "BJ": "\u8D1D\u5B81",
      "BM": "\u767E\u6155\u5927\u7FA4\u5C9B",
      "BT": "\u4E0D\u4E39",
      "BO": "\u591A\u6C11\u65CF\u73BB\u5229\u7EF4\u4E9A\u56FD",
      "BA": "\u6CE2\u65AF\u5C3C\u4E9A\u548C\u9ED1\u585E\u54E5\u7EF4\u90A3",
      "BW": "\u535A\u8328\u74E6\u7EB3",
      "BV": "\u5E03\u7EF4\u5C9B",
      "BR": "\u5DF4\u897F",
      "BQ": "\u535A\u5185\u5C14\u5C9B\u3001\u5723\u5965\u4F9D\u65AF\u5766\u56FE\u65AF\u548C\u8428\u5DF4\u5C9B",
      "IO": "\u82F1\u5C5E\u5370\u5EA6\u6D0B\u9886\u5730",
      "VG": "\u7EF4\u5C14\u4EAC\u7FA4\u5C9B\uFF08\u82F1\u5C5E\uFF09",
      "BN": "\u6587\u83B1\u8FBE\u9C81\u8428\u5170\u56FD",
      "BG": "\u4FDD\u52A0\u5229\u4E9A",
      "BF": "\u5E03\u57FA\u7EB3\u6CD5\u7D22",
      "BI": "\u5E03\u9686\u8FEA",
      "KH": "\u67EC\u57D4\u5BE8",
      "CM": "\u5580\u9EA6\u9686",
      "CA": "\u52A0\u62FF\u5927",
      "IC": "\u52A0\u90A3\u5229\u7FA4\u5C9B",
      "CT": "\u574E\u987F\u548C\u6069\u5FB7\u4F2F\u91CC\u7FA4\u5C9B",
      "CV": "\u4F5B\u5F97\u89D2",
      "KY": "\u5F00\u66FC\u7FA4\u5C9B",
      "CF": "\u4E2D\u975E\u5171\u548C\u56FD",
      "EA": "\u4F11\u8FBE\u548C\u6885\u5229\u4E9A",
      "TD": "\u4E4D\u5F97",
      "CL": "\u667A\u5229",
      "CN": "\u4E2D\u56FD",
      "CN-ML": "\u4E2D\u56FD\u5927\u9646",
      "CX": "\u5723\u8BDE\u5C9B",
      "CP": "\u514B\u5229\u4F2F\u987F\u5C9B",
      "CC": "\u79D1\u79D1\u65AF\uFF08\u57FA\u6797\uFF09\u7FA4\u5C9B",
      "CO": "\u54E5\u4F26\u6BD4\u4E9A",
      "KM": "\u79D1\u6469\u7F57",
      "CD": "\u521A\u679C\u6C11\u4E3B\u5171\u548C\u56FD",
      "CK": "\u5E93\u514B\u7FA4\u5C9B",
      "CR": "\u54E5\u65AF\u8FBE\u9ECE\u52A0",
      "CI": "\u8C61\u7259\u6D77\u5CB8",
      "HR": "\u514B\u7F57\u5730\u4E9A",
      "CU": "\u53E4\u5DF4",
      "CW": "\u5E93\u62C9\u7D22\u5C9B",
      "CY": "\u585E\u6D66\u8DEF\u65AF",
      "CZ": "\u6377\u514B",
      "DK": "\u4E39\u9EA6",
      "DG": "\u8FED\u6208\u52A0\u897F\u4E9A\u5C9B",
      "DJ": "\u5409\u5E03\u63D0",
      "DM": "\u591A\u7C73\u5C3C\u514B",
      "DO": "\u591A\u7C73\u5C3C\u52A0\u5171\u548C\u56FD",
      "NQ": "\u6BDB\u5FB7\u7687\u540E\u5730",
      "EC": "\u5384\u74DC\u591A\u5C14",
      "EG": "\u57C3\u53CA",
      "SV": "\u8428\u5C14\u74E6\u591A",
      "GQ": "\u8D64\u9053\u51E0\u5185\u4E9A",
      "ER": "\u5384\u7ACB\u7279\u5C3C\u4E9A",
      "EE": "\u7231\u6C99\u5C3C\u4E9A",
      "ET": "\u57C3\u585E\u4FC4\u6BD4\u4E9A",
      "EU": "\u6B27\u76DF",
      "FK": "\u798F\u514B\u5170\u7FA4\u5C9B\uFF08\u9A6C\u5C14\u7EF4\u7EB3\u65AF\u7FA4\u5C9B\uFF09",
      "FO": "\u6CD5\u7F57\u7FA4\u5C9B",
      "FJ": "\u6590\u6D4E",
      "FI": "\u82AC\u5170",
      "FR": "\u6CD5\u56FD",
      "GF": "\u6CD5\u5C5E\u572D\u4E9A\u90A3",
      "PF": "\u6CD5\u5C5E\u6CE2\u5229\u5C3C\u897F\u4E9A",
      "TF": "\u6CD5\u5C5E\u5357\u534A\u7403\u9886\u5730",
      "FQ": "\u6CD5\u5C5E\u5357\u65B9\u548C\u5357\u6781\u9886\u5730",
      "GA": "\u52A0\u84EC",
      "GM": "\u5188\u6BD4\u4E9A",
      "GE": "\u683C\u9C81\u5409\u4E9A",
      "DE": "\u5FB7\u56FD",
      "GH": "\u52A0\u7EB3",
      "GI": "\u76F4\u5E03\u7F57\u9640",
      "GR": "\u5E0C\u814A",
      "GL": "\u683C\u6797\u5170\u5C9B",
      "GD": "\u683C\u6797\u7EB3\u8FBE",
      "GP": "\u74DC\u5FB7\u7F57\u666E\u5C9B",
      "GU": "\u5173\u5C9B",
      "GT": "\u5371\u5730\u9A6C\u62C9",
      "GG": "\u6839\u897F\u5C9B",
      "GN": "\u51E0\u5185\u4E9A",
      "GW": "\u51E0\u5185\u4E9A\u6BD4\u7ECD",
      "GY": "\u572D\u4E9A\u90A3",
      "HT": "\u6D77\u5730",
      "HM": "\u8D6B\u5FB7\u5C9B\u548C\u9EA6\u514B\u5510\u7EB3\u7FA4\u5C9B",
      "HN": "\u6D2A\u90FD\u62C9\u65AF",
      "HK": "\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A",
      "HU": "\u5308\u7259\u5229",
      "IS": "\u51B0\u5C9B",
      "IN": "\u5370\u5EA6",
      "ID": "\u5370\u5EA6\u5C3C\u897F\u4E9A",
      "IR": "\u4F0A\u6717\u4F0A\u65AF\u5170\u5171\u548C\u56FD",
      "IE": "\u7231\u5C14\u5170",
      "IM": "\u82F1\u56FD\u5C5E\u5730\u66FC\u5C9B",
      "IL": "\u4EE5\u8272\u5217",
      "IQ": "\u4F0A\u62C9\u514B",
      "IT": "\u610F\u5927\u5229",
      "JM": "\u7259\u4E70\u52A0",
      "JP": "\u65E5\u672C",
      "JE": "\u6CFD\u897F\u5C9B",
      "JT": "\u7EA6\u7FF0\u65AF\u987F\u5C9B",
      "JO": "\u7EA6\u65E6",
      "KZ": "\u54C8\u8428\u514B\u65AF\u5766",
      "KE": "\u80AF\u5C3C\u4E9A",
      "KI": "\u57FA\u91CC\u5DF4\u65AF",
      "KP": "\u671D\u9C9C\u6C11\u4E3B\u4E3B\u4E49\u4EBA\u6C11\u5171\u548C\u56FD",
      "KR": "\u97E9\u56FD",
      "XK": "\u79D1\u7D22\u6C83",
      "KW": "\u79D1\u5A01\u7279",
      "KG": "\u5409\u5C14\u5409\u65AF\u65AF\u5766",
      "LA": "\u8001\u631D\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD",
      "LV": "\u62C9\u8131\u7EF4\u4E9A",
      "LB": "\u9ECE\u5DF4\u5AE9",
      "LS": "\u83B1\u7D22\u6258",
      "LR": "\u5229\u6BD4\u91CC\u4E9A",
      "LY": "\u5229\u6BD4\u4E9A",
      "LI": "\u5217\u652F\u6566\u58EB\u767B",
      "LT": "\u7ACB\u9676\u5B9B",
      "LU": "\u5362\u68EE\u5821",
      "MO": "\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A",
      "MK": "\u5317\u9A6C\u5176\u987F",
      "MG": "\u9A6C\u8FBE\u52A0\u65AF\u52A0",
      "MW": "\u9A6C\u62C9\u7EF4",
      "MY": "\u9A6C\u6765\u897F\u4E9A",
      "MV": "\u9A6C\u5C14\u4EE3\u592B",
      "ML": "\u9A6C\u91CC",
      "MT": "\u9A6C\u8033\u4ED6",
      "MH": "\u9A6C\u7ECD\u5C14\u7FA4\u5C9B",
      "MQ": "\u9A6C\u63D0\u5C3C\u514B",
      "MR": "\u6BDB\u91CC\u5854\u5C3C\u4E9A",
      "MU": "\u6BDB\u91CC\u6C42\u65AF",
      "YT": "\u9A6C\u7EA6\u7279\u5C9B",
      "FX": "\u6CD5\u56FD\u5927\u90FD\u4F1A",
      "MX": "\u58A8\u897F\u54E5",
      "FM": "\u5BC6\u514B\u7F57\u5C3C\u897F\u4E9A\u8054\u90A6",
      "MI": "\u4E2D\u9014\u5C9B",
      "MD": "\u6469\u5C14\u591A\u74E6\u5171\u548C\u56FD",
      "MC": "\u6469\u7EB3\u54E5",
      "MN": "\u8499\u53E4",
      "ME": "\u9ED1\u5C71\u5171\u548C\u56FD",
      "MS": "\u8499\u7279\u585E\u62C9\u7279\u5C9B",
      "MA": "\u6469\u6D1B\u54E5",
      "MZ": "\u83AB\u6851\u6BD4\u514B",
      "MM": "\u7F05\u7538",
      "NA": "\u7EB3\u7C73\u6BD4\u4E9A",
      "NR": "\u7459\u9C81",
      "NP": "\u5C3C\u6CCA\u5C14",
      "NL": "\u8377\u5170",
      "AN": "\u8377\u5C5E\u5B89\u7684\u5217\u65AF",
      "NT": "\u4E2D\u7ACB\u533A",
      "NC": "\u65B0\u5580\u91CC\u591A\u5C3C\u4E9A",
      "NZ": "\u65B0\u897F\u5170",
      "NI": "\u5C3C\u52A0\u62C9\u74DC",
      "NE": "\u5C3C\u65E5\u5C14",
      "NG": "\u5C3C\u65E5\u5229\u4E9A",
      "NU": "\u7EBD\u57C3",
      "NF": "\u8BFA\u798F\u514B\u5C9B",
      "VD": "\u8D8A\u5357\u6C11\u4E3B\u5171\u548C\u56FD",
      "MP": "\u5317\u9A6C\u91CC\u4E9A\u7EB3\u7FA4\u5C9B",
      "NO": "\u632A\u5A01",
      "OM": "\u963F\u66FC",
      "OM_mobile": "\u963F\u66FC\u79FB\u52A8\u901A\u4FE1\u516C\u53F8",
      "QO": "\u8FB9\u8FDC\u5927\u6D0B\u6D32",
      "PC": "\u592A\u5E73\u6D0B\u5C9B\u5C7F\u6258\u7BA1\u5730",
      "PK": "\u5DF4\u57FA\u65AF\u5766",
      "PW": "\u5E15\u52B3",
      "PS": "\u5DF4\u52D2\u65AF\u5766",
      "PA": "\u5DF4\u62FF\u9A6C",
      "PZ": "\u5DF4\u62FF\u9A6C\u8FD0\u6CB3\u533A",
      "PY": "\u5DF4\u62C9\u572D",
      "YD": "\u4E5F\u95E8\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD",
      "PE": "\u79D8\u9C81",
      "PH": "\u83F2\u5F8B\u5BBE",
      "PN": "\u76AE\u7279\u51EF\u6069\u7FA4\u5C9B",
      "PL": "\u6CE2\u5170",
      "PT": "\u8461\u8404\u7259",
      "PR": "\u6CE2\u591A\u9ECE\u5404",
      "QA": "\u5361\u5854\u5C14",
      "RE": "\u7559\u5C3C\u65FA\u5C9B",
      "RO": "\u7F57\u9A6C\u5C3C\u4E9A",
      "RU": "\u4FC4\u7F57\u65AF\u8054\u90A6",
      "RW": "\u5362\u65FA\u8FBE",
      "BL": "\u5723\u5DF4\u6258\u6D1B\u7F2A\u5C9B",
      "SH": "\u5723\u8D6B\u52D2\u62FF\u3001\u963F\u68EE\u677E\u548C\u7279\u91CC\u65AF\u5766-\u8FBE\u5E93\u5C3C\u4E9A",
      "KN": "\u5723\u57FA\u8328\u548C\u5C3C\u7EF4\u65AF",
      "LC": "\u5723\u5362\u897F\u4E9A\u5C9B",
      "MF": "\u5723\u9A6C\u4E01\uFF08\u6CD5\u5C5E\uFF09",
      "PM": "\u5723\u76AE\u57C3\u5C14\u53CA\u5BC6\u514B\u9686\u5C9B",
      "VC": "\u5723\u6587\u68EE\u7279\u548C\u683C\u6797\u7EB3\u4E01\u65AF",
      "WS": "\u8428\u6469\u4E9A",
      "SM": "\u5723\u9A6C\u529B\u8BFA",
      "ST": "\u5723\u591A\u7F8E\u548C\u666E\u6797\u897F\u6BD4",
      "SA": "\u6C99\u7279\u963F\u62C9\u4F2F",
      "SN": "\u585E\u5185\u52A0\u5C14",
      "RS": "\u585E\u5C14\u7EF4\u4E9A",
      "CS": "\u585E\u5C14\u7EF4\u4E9A\u548C\u9ED1\u5C71",
      "SC": "\u585E\u820C\u5C14",
      "SL": "\u585E\u62C9\u5229\u6602",
      "SG": "\u65B0\u52A0\u5761",
      "SX": "\u5723\u9A6C\u4E01\uFF08\u8377\u5C5E\uFF09",
      "SK": "\u65AF\u6D1B\u4F10\u514B",
      "SI": "\u65AF\u6D1B\u6587\u5C3C\u4E9A",
      "SB": "\u6240\u7F57\u95E8\u7FA4\u5C9B",
      "SO": "\u7D22\u9A6C\u91CC",
      "ZA": "\u5357\u975E",
      "GS": "\u5357\u4E54\u6CBB\u4E9A\u5C9B\u548C\u5357\u6851\u5A01\u5947\u7FA4\u5C9B",
      "ES": "\u897F\u73ED\u7259",
      "LK": "\u65AF\u91CC\u5170\u5361",
      "SR": "\u82CF\u91CC\u5357",
      "SJ": "\u65AF\u74E6\u5C14\u5DF4\u548C\u626C\u9A6C\u5EF6",
      "SZ": "\u53F2\u74E6\u5E1D\u5C3C",
      "SE": "\u745E\u5178",
      "CH": "\u745E\u58EB",
      "SY": "\u963F\u62C9\u4F2F\u53D9\u5229\u4E9A\u5171\u548C\u56FD",
      "TW": "\u4E2D\u56FD\u53F0\u6E7E",
      "TW_mobile": "\u53F0\u6E7E\u79FB\u52A8",
      "TJ": "\u5854\u5409\u514B\u65AF\u5766",
      "TZ": "\u5766\u6851\u5C3C\u4E9A\u8054\u5408\u5171\u548C\u56FD",
      "TH": "\u6CF0\u56FD",
      "TL": "\u4E1C\u5E1D\u6C76",
      "TG": "\u591A\u54E5",
      "TK": "\u6258\u514B\u52B3",
      "TO": "\u6C64\u52A0",
      "TT": "\u7279\u7ACB\u5C3C\u8FBE\u548C\u591A\u5DF4\u54E5",
      "TA": "\u7279\u91CC\u65AF\u5766\u8FBE\u5E93\u5C3C\u4E9A\u7FA4\u5C9B",
      "TN": "\u7A81\u5C3C\u65AF",
      "TR": "\u571F\u8033\u5176",
      "TM": "\u571F\u5E93\u66FC\u65AF\u5766",
      "TC": "\u7279\u514B\u65AF\u548C\u51EF\u79D1\u65AF\u7FA4\u5C9B",
      "TV": "\u56FE\u74E6\u5362",
      "UM": "\u7F8E\u56FD\u672C\u571F\u5916\u5C0F\u5C9B\u5C7F",
      "PU": "\u7F8E\u5C5E\u592A\u5E73\u6D0B\u7FA4\u5C9B",
      "VI": "\u7EF4\u5C14\u4EAC\u7FA4\u5C9B\uFF08\u7F8E\u5C5E\uFF09",
      "UG": "\u4E4C\u5E72\u8FBE",
      "UA": "\u4E4C\u514B\u5170",
      "AE": "\u963F\u62C9\u4F2F\u8054\u5408\u914B\u957F\u56FD",
      "GB": "\u82F1\u56FD",
      "US": "\u7F8E\u56FD",
      "UY": "\u4E4C\u62C9\u572D",
      "UZ": "\u4E4C\u5179\u522B\u514B\u65AF\u5766",
      "VU": "\u74E6\u52AA\u963F\u56FE",
      "VA": "\u68B5\u8482\u5188",
      "VE": "\u59D4\u5185\u745E\u62C9\u73BB\u5229\u74E6\u5C14\u5171\u548C\u56FD",
      "VN": "\u8D8A\u5357",
      "WK": "\u590D\u6D3B\u5C9B",
      "WF": "\u74E6\u5229\u7FA4\u5C9B\u548C\u5BCC\u56FE\u7EB3\u7FA4\u5C9B",
      "EH": "\u897F\u6492\u54C8\u62C9",
      "YE": "\u4E5F\u95E8",
      "ZM": "\u8D5E\u6BD4\u4E9A",
      "SD": "\u82CF\u4E39",
      "SS": "\u5357\u82CF\u4E39",
      "ZW": "\u6D25\u5DF4\u5E03\u97E6",
      "CG": "\u521A\u679C",
      "PG": "\u5DF4\u5E03\u4E9A\u65B0\u51E0\u5185\u4E9A",
      "XG": "\u5168\u7403\u79FB\u52A8\u536B\u661F\u7CFB\u7EDF",
      "XC": "ITPCS\u8BD5\u7528",
      "XT": "\u56FD\u9645\u514D\u8D39\u7535\u8BDD",
      "XV": "\u56FD\u9645\u7F51\u7EDC",
      "XR": "\u56FD\u9645\u4ED8\u8D39\u670D\u52A1",
      "XS": "\u6210\u672C\u5171\u62C5\u670D\u52A1",
      "XD": "\u51CF\u707E\u901A\u4FE1",
      "XP": "\u901A\u7528\u4E2A\u4EBA\u901A\u4FE1",
      "language": {
        "display": "{0} ({1})"
      },
      "en-US": "USA",
      "en-GB": "UK",
      "zh-CN": "\u4E2D\u56FD",
      "es-ES": "\u897F\u73ED\u7259",
      "fr-FR": "\u6CD5\u56FD",
      "jp-JP": "\u65E5\u672C",
      "de-DE": "\u5FB7\u56FD",
      "pt-PT": "\u8461\u8404\u7259\u8BED",
      "ru-RU": "\u4FC4\u8BED",
      "TW-TW": "\u53F0\u6E7E"
    },
    "us": {
      "state_aa": "\u7F8E\u6D32\u519B\u961F",
      "state_ae": "\u6B27\u6D32\u3001\u4E2D\u4E1C\u5730\u533A\u3001\u52A0\u62FF\u5927\u6B66\u88C5\u90E8\u961F",
      "state_ap": "\u592A\u5E73\u6D0B\u6B66\u88C5\u90E8\u961F",
      "state_al": "\u963F\u62C9\u5DF4\u9A6C",
      "state_ak": "\u963F\u62C9\u65AF\u52A0",
      "state_az": "\u4E9A\u5229\u6851\u90A3",
      "state_ar": "\u963F\u80AF\u8272",
      "state_ca": "\u52A0\u5229\u798F\u5C3C\u4E9A",
      "state_co": "\u79D1\u7F57\u62C9\u591A",
      "state_ct": "\u5EB7\u6D85\u72C4\u683C",
      "state_wd": "\u534E\u76DB\u987F\u7279\u533A",
      "state_de": "\u7279\u62C9\u534E",
      "state_fl": "\u4F5B\u7F57\u91CC\u8FBE",
      "state_ga": "\u4F50\u6CBB\u4E9A",
      "state_gu": "\u5173\u5C9B",
      "state_hi": "\u590F\u5A01\u5937",
      "state_id": "\u7231\u8FBE\u8377",
      "state_il": "\u4F0A\u5229\u8BFA\u4F0A",
      "state_in": "\u5370\u7B2C\u5B89\u7EB3",
      "state_ia": "\u7231\u8377\u534E",
      "state_ks": "\u582A\u8428\u65AF",
      "state_ky": "\u80AF\u5854\u57FA",
      "state_la": "\u8DEF\u6613\u65AF\u5B89\u90A3",
      "state_me": "\u7F05\u56E0",
      "state_md": "\u9A6C\u91CC\u5170\u5DDE",
      "state_ma": "\u9A6C\u8428\u8BF8\u585E\u5DDE",
      "state_mi": "\u5BC6\u6B47\u6839",
      "state_mn": "\u660E\u5C3C\u82CF\u8FBE",
      "state_ms": "\u5BC6\u897F\u897F\u6BD4",
      "state_mo": "\u5BC6\u82CF\u91CC",
      "state_mt": "\u8499\u5927\u62FF",
      "state_ne": "\u5185\u5E03\u62C9\u65AF\u52A0",
      "state_nv": "\u5185\u534E\u8FBE",
      "state_nh": "\u65B0\u7F55\u5E03\u4EC0\u5C14",
      "state_nj": "\u65B0\u6CFD\u897F",
      "state_nm": "\u65B0\u58A8\u897F\u54E5",
      "state_ny": "\u7EBD\u7EA6",
      "state_nc": "\u5317\u5361\u7F57\u6765\u7EB3",
      "state_nd": "\u5317\u8FBE\u79D1\u4ED6",
      "state_oh": "\u4FC4\u4EA5\u4FC4",
      "state_ok": "\u4FC4\u514B\u62C9\u8377\u9A6C",
      "state_or": "\u4FC4\u52D2\u5188",
      "state_pa": "\u5BBE\u5915\u6CD5\u5C3C\u4E9A",
      "state_pr": "\u6CE2\u591A\u9ECE\u5404",
      "state_ri": "\u7F57\u5F97\u5C9B",
      "state_sc": "\u5357\u5361\u7F57\u6765\u7EB3",
      "state_sd": "\u5357\u8FBE\u79D1\u4ED6",
      "state_tn": "\u7530\u7EB3\u897F",
      "state_tx": "\u5FB7\u514B\u8428\u65AF",
      "state_ut": "\u72B9\u4ED6",
      "state_vt": "\u4F5B\u8499\u7279",
      "state_va": "\u5F17\u5409\u5C3C\u4E9A",
      "state_vi": "\u7EF4\u4EAC\u7FA4\u5C9B",
      "state_wa": "\u534E\u76DB\u987F",
      "state_wv": "\u897F\u5F17\u5409\u5C3C\u4E9A",
      "state_wi": "\u5A01\u65AF\u5EB7\u8F9B",
      "state_wy": "\u6000\u4FC4\u660E"
    },
    "ca": {
      "state_aa": "\u963F\u5C14\u4F2F\u8FBE",
      "state_ba": "\u82F1\u5C5E\u54E5\u4F26\u6BD4\u4E9A",
      "state_ma": "\u66FC\u5C3C\u6258\u5DF4",
      "state_nd": "\u65B0\u4E0D\u4F26\u745E\u514B",
      "state_nr": "\u7EBD\u82AC\u5170\u548C\u62C9\u5E03\u62C9\u591A",
      "state_ns": "\u897F\u5317\u5730\u533A",
      "state_na": "\u65B0\u65AF\u79D1\u820D",
      "state_nt": "\u52AA\u7EB3\u6B66\u7279",
      "state_oo": "\u5B89\u5927\u7565",
      "state_pe": "\u7231\u5FB7\u534E\u738B\u5B50\u5C9B",
      "state_qc": "\u9B41\u5317\u514B",
      "state_sn": "\u8428\u514B\u5176\u4E07",
      "state_yn": "\u80B2\u7A7A"
    },
    "mx": {
      "state_ags": "\u963F\u74DC\u65AF\u5361\u8FDE\u7279\u65AF\u5DDE",
      "state_bc": "\u4E0B\u52A0\u5229\u798F\u5C3C\u4E9A\u5DDE",
      "state_bcs": "\u5357\u4E0B\u52A0\u5229\u798F\u5C3C\u4E9A\u5DDE",
      "state_cam": "\u574E\u4F69\u5207\u5DDE",
      "state_chs": "\u6070\u5E15\u65AF\u5DDE",
      "state_chh": "\u5947\u74E6\u74E6\u5DDE",
      "state_co": "\u79D1\u963F\u97E6\u62C9\u5DDE",
      "state_col": "\u79D1\u5229\u9A6C\u5DDE",
      "state_dg": "\u675C\u5170\u6208\u5DDE",
      "state_gt": "\u74DC\u7EB3\u534E\u6258\u5DDE",
      "state_gr": "\u683C\u96F7\u7F57\u5DDE",
      "state_hg": "\u4F0A\u8FBE\u5C14\u6208\u5DDE",
      "state_ja": "\u54C8\u5229\u65AF\u79D1\u5DDE",
      "state_me": "\u58A8\u897F\u54E5\u5DDE",
      "state_mi": "\u7C73\u5374\u80AF\u5DDE",
      "state_mo": "\u83AB\u96F7\u6D1B\u65AF\u5DDE",
      "state_na": "\u7EB3\u4E9A\u91CC\u7279\u5DDE",
      "state_nl": "\u65B0\u83B1\u6602\u5DDE",
      "state_oa": "\u74E6\u54C8\u5361\u5DDE",
      "state_pu": "\u666E\u57C3\u5E03\u62C9\u5DDE",
      "state_qr": "\u514B\u96F7\u5854\u7F57\u5DDE",
      "state_qo": "\u91D1\u5854\u7EB3\u7F57\u5965\u5DDE",
      "state_sl": "\u5723\u8DEF\u6613\u65AF\u6CE2\u6258\u897F\u5DDE",
      "state_si": "\u9521\u90A3\u7F57\u4E9A\u5DDE",
      "state_so": "\u7D22\u8BFA\u62C9\u5DDE",
      "state_tab": "\u5854\u5DF4\u65AF\u79D1\u5DDE",
      "state_tam": "\u5854\u6BDB\u5229\u5E15\u65AF\u5DDE",
      "state_tl": "\u7279\u62C9\u65AF\u5361\u62C9\u5DDE",
      "state_ve": "\u7EF4\u62C9\u514B\u9C81\u65AF\u5DDE",
      "state_yu": "\u5C24\u5361\u5766\u5DDE",
      "state_za": "\u8428\u5361\u7279\u5361\u65AF\u5DDE",
      "state_df": "\u8054\u90A6\u76F4\u8F96\u533A"
    },
    "au": {
      "state_nsw": "\u65B0\u5357\u5A01\u5C14\u58EB\u5DDE",
      "state_qld": "\u6606\u58EB\u5170\u5DDE",
      "state_sa": "\u5357\u6FB3\u5927\u5229\u4E9A\u5DDE",
      "state_vic": "\u7EF4\u591A\u5229\u4E9A\u5DDE",
      "state_tas": "\u5854\u65AF\u9A6C\u5C3C\u4E9A\u5DDE",
      "state_nt": "\u5317\u90E8\u5730\u533A",
      "state_wa": "\u897F\u6FB3\u5927\u5229\u4E9A\u5DDE",
      "state_act": "\u6FB3\u5927\u5229\u4E9A\u9996\u90FD\u9886\u5730"
    },
    "inr": {
      "state_an": "\u5B89\u8FBE\u66FC\u548C\u5C3C\u79D1\u5DF4",
      "state_ap": "\u5B89\u5F97\u62C9\u90A6",
      "state_ar": "\u963F\u9C81\u7EB3\u6070\u5C14\u90A6",
      "state_as": "\u963F\u8428\u59C6\u90A6",
      "state_br": "\u6BD4\u54C8\u5C14\u90A6",
      "state_ch": "\u660C\u8FEA\u52A0\u5C14",
      "state_cg": "\u6070\u8482\u65AF\u52A0\u5C14\u90A6",
      "state_dnh": "\u8FBE\u5FB7\u62C9\u7EB3\u52A0\u5C14\u54C8\u7EF4\u5229",
      "state_dd": "\u8FBE\u66FC\u548C\u7B2C\u4E4C",
      "state_dl": "\u5FB7\u91CC",
      "state_ga": "\u679C\u963F",
      "state_gj": "\u53E4\u5409\u62C9\u7279\u90A6",
      "state_hr": "\u54C8\u91CC\u4E9A\u7EB3\u90A6",
      "state_hp": "\u559C\u9A6C\u5055\u5C14\u90A6",
      "state_jk": "\u67E5\u8C1F\u548C\u514B\u4EC0\u7C73\u5C14",
      "state_jh": "\u8D3E\u574E\u5FB7\u90A6",
      "state_ka": "\u5361\u7EB3\u5854\u514B\u90A6",
      "state_kl": "\u5580\u62C9\u62C9\u90A6",
      "state_la": "\u62C9\u8FBE\u514B",
      "state_ld": "\u62C9\u514B\u6C99\u5A01",
      "state_mp": "\u4E2D\u592E\u90A6",
      "state_mh": "\u9A6C\u54C8\u62C9\u65BD\u7279\u62C9\u90A6",
      "state_mn": "\u66FC\u5C3C\u666E\u5C14\u90A6",
      "state_ml": "\u6885\u52A0\u62C9\u4E9A\u90A6",
      "state_mz": "\u7C73\u4F50\u62C9\u59C6\u90A6",
      "state_nl": "\u90A3\u52A0\u5170\u90A6",
      "state_or": "\u5965\u91CC\u8428\u90A6",
      "state_ot": "\u5176\u4ED6\u5730\u533A",
      "state_ph": "\u672C\u5730\u6CBB\u91CC",
      "state_pb": "\u65C1\u906E\u666E\u90A6",
      "state_rj": "\u62C9\u8D3E\u65AF\u5766\u90A6",
      "state_sk": "\u9521\u91D1\u90A6",
      "state_tn": "\u6CF0\u7C73\u5C14\u7EB3\u5FB7\u90A6",
      "state_tg": "\u6CF0\u4F26\u52A0\u7EB3",
      "state_tr": "\u7279\u91CC\u666E\u62C9\u90A6",
      "state_up": "\u5317\u65B9\u90A6",
      "state_uk": "\u5317\u963F\u574E\u5FB7\u90A6",
      "state_wb": "\u897F\u5B5F\u52A0\u62C9\u90A6"
    },
    "language": {
      "en-US": "\u82F1\u8BED",
      "en-GB": "\u82F1\u8BED",
      "zh-CN": "\u7B80\u4F53\u4E2D\u6587",
      "zh-TW": "\u7E41\u4F53\u4E2D\u6587",
      "es-ES": "\u897F\u73ED\u7259",
      "fr-FR": "\u6CD5\u56FD",
      "jp-JP": "\u65E5\u672C",
      "de-DE": "\u5FB7\u8BED",
      "pt-PT": "\u8461\u8404\u7259\u8BED",
      "ru-RU": "\u4FC4\u8BED",
      "ko-KO": "\u97E9\u8BED",
      "it-IT": "\u610F\u5927\u5229",
      "vi-VN": "\u8D8A\u5357",
      "nl-NL": "Dutch"
    },
    "crc": {
      "region": {
        "": "\u5168\u5C40",
        "US": "\u7F8E\u56FD",
        "SC": "\u7F8E\u56FD\u897F\u90E8",
        "NY": "\u7F8E\u56FD\u4E1C\u90E8",
        "DV": "\u7F8E\u56FD\u4E2D\u90E8",
        "CN": "\u4E2D\u56FD",
        "IN": "\u5370\u5EA6",
        "MB": "\u5370\u5EA6\u5B5F\u4E70",
        "HY": "\u5370\u5EA6\u6D77\u5F97\u62C9\u5DF4",
        "EU": "\u6B27\u6D32\u3001\u4E2D\u4E1C\u548C\u975E\u6D32",
        "AU": "\u6FB3\u5927\u5229\u4E9A",
        "HK": "\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A",
        "BR": "\u5DF4\u897F",
        "CA": "\u52A0\u62FF\u5927",
        "TY": "\u65E5\u672C",
        "AM": "\u8377\u5170\u963F\u59C6\u65AF\u7279\u4E39",
        "FR": "\u5FB7\u56FD"
      }
    },
    "common": {
      "btn_remove": "\u79FB\u9664",
      "btn_cancel": "\u53D6\u6D88",
      "btn_save": "\u4FDD\u5B58",
      "btn_yes": "\u662F",
      "btn_no": "\u5426",
      "btn_ok": "\u786E\u8BA4",
      "btn_back": "\u8FD4\u56DE",
      "btn_continue": "\u7EE7\u7EED",
      "btn_close": "\u5173\u95ED",
      "btn_print": "\u6253\u5370",
      "btn_sign_in": "\u767B\u5F55\u3002",
      "month": "\u6708",
      "time_day": "\u65E5",
      "year": "\u5E74",
      "pwd_must": "\u5BC6\u7801\u5FC5\u987B\uFF1A",
      "months": "\u6708",
      "pwd_has_at_least_characters": "\u6709\u81F3\u5C11{0}\u4E2A\u5B57\u7B26",
      "pwd_has_one_letter": "\u6709\u81F3\u5C111\u4E2A\u5B57\u6BCD(a, b, c...)",
      "pwd_has_one_number": "\u6709\u81F3\u5C111\u4E2A\u6570\u5B57(1, 2, 3...)",
      "pwd_has_one_special_character": "\u6709\u81F3\u5C111\u4E2A\u7279\u6B8A\u5B57\u7B26(!, @, #...)",
      "pwd_has_both_upper_lower_characters": "\u5305\u542B\u5927\u5199\u548C\u5C0F\u5199\u5B57\u7B26",
      "pwd_must_not": "\u5BC6\u7801\u4E0D\u5F97\uFF1A",
      "pwd_contain_consecutive_character_length_rule": "\u5305\u542B{0}\u4E2A\u8FDE\u7EED\u5B57\u7B26\uFF08\u4F8B\u5982\u201C11111\u201D\u3001\u201C12345\u201D\u3001\u201Cabcde\u201D\u6216\u201Cqwert\u201D\uFF09",
      "pwd_contain_only_one_character": "\u4EC5\u5305\u542B\u67D0\u4E2A\u76F8\u540C\u7684\u5B57\u7B26\uFF0811111111 \u6216 aaaaaaaa\uFF09",
      "pwd_contain_only_one_consecutive_character": "\u4EC5\u5305\u542B\u8FDE\u7EED\u5B57\u7B26\uFF0812345678 \u6216 abcdefgh\uFF09"
    },
    "user": {
      "signup": {
        "already_have_account_signin": "\u5DF2\u6709\u8D26\u53F7? <a href=\"/signin\">\u767B\u5F55</a>."
      },
      "age_gating_question": {
        "title": "\u4E3A\u8FDB\u884C\u9A8C\u8BC1\uFF0C\u8BF7\u786E\u8BA4\u4F60\u7684\u51FA\u751F\u65E5\u671F\u3002",
        "age_title": "For verification, please confirm your age.",
        "not_stored_data": "\u7CFB\u7EDF\u4E0D\u4F1A\u4FDD\u5B58\u6B64\u6570\u636E",
        "not_eligible": "\u4F60\u76EE\u524D\u4E0D\u7B26\u5408\u6CE8\u518CZoom\u7684\u8D44\u683C",
        "not_eligible_for_sign_in": "\u4F60\u76EE\u524D\u4E0D\u7B26\u5408\u767B\u5F55Zoom\u7684\u8D44\u683C"
      },
      "existing_user_sign_in_prompt": "\u73B0\u6709\u7528\u6237\u8BF7\u767B\u5F55",
      "have_account_sign_in": "\u5DF2\u6709\u8D26\u6237\uFF1F",
      "resend_invite_email": "Resend invite email to {0} success."
    },
    "error": {
      "billing": {
        "zr_trial_host_validate_tip": "\u4F60\u5F53\u524D\u6709{0}\u4E2A\u514D\u8D39\u8BD5\u7528\u7684\u4F1A\u8BAE\u5BA4\u3002\u4E3A\u4E86\u589E\u52A0\u989D\u5916\u7684\u4F1A\u8BAE\u5BA4\uFF0C\u4F60\u9700\u8981\u4E3A\u73B0\u6709\u7684\u8FD9\u4E9B\u4F1A\u8BAE\u5BA4\u8D2D\u4E70\u8BB8\u53EF\u8BC1\u3002",
        "zr_trial_hosts_validate_tip": "\u4F60\u76EE\u524D\u6709{0}\u4E2A\u514D\u8D39\u8BD5\u7528\u7684\u4F1A\u8BAE\u5BA4\u3002\u4E3A\u4E86\u589E\u52A0\u989D\u5916\u7684\u4F1A\u8BAE\u5BA4\uFF0C\u4F60\u9700\u8981\u4E3A\u73B0\u6709\u7684\u8FD9\u4E9B\u4F1A\u8BAE\u5BA4\u8D2D\u4E70\u8BB8\u53EF\u8BC1\u3002",
        "adyen": {
          "error_1": "\u4ED8\u6B3E\u65B9\u5F0F\u5B58\u5728\u95EE\u9898\uFF0C\u6211\u4EEC\u65E0\u6CD5\u5904\u7406\u6B64\u8BF7\u6C42\u3002\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5C1D\u8BD5\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_2": "\u7531\u4E8E\u4FE1\u7528\u5361\u53F7\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u4F60\u7684\u8D2D\u4E70\u3002\u8BF7\u66F4\u65B0\u4FE1\u7528\u5361\u4FE1\u606F\u6216\u5C1D\u8BD5\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002\u5982\u679C\u95EE\u9898\u4ECD\u5B58\u5728\uFF0C\u5EFA\u8BAE\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u3002",
          "error_3": "\u7531\u4E8E\u8D26\u6237\u8D44\u91D1\u4E0D\u8DB3\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5C1D\u8BD5\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_4": "\u4F60\u591A\u6B21\u4F7F\u7528\u65E0\u6548\u53F7\u7801\u5904\u7406\u6B64\u5361\u7684\u4ED8\u6B3E\u8BF7\u6C42\uFF0C\u73B0\u5DF2\u8D85\u8FC7\u5141\u8BB8\u7684\u5C1D\u8BD5\u6B21\u6570\u3002\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_5": "\u7CFB\u7EDF\u76EE\u524D\u65E0\u6CD5\u5904\u7406\u4F60\u7684\u8BF7\u6C42\uFF0C\u8BF7\u7A0D\u540E\u518D\u8BD5\u6216\u4F7F\u7528\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002\u5982\u679C\u95EE\u9898\u4ECD\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5C1D\u8BD5\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_6": "\u4F60\u591A\u6B21\u5904\u7406\u6B64\u4ED8\u6B3E\u65B9\u5F0F\u7684\u4ED8\u6B3E\u8BF7\u6C42\uFF0C\u73B0\u5DF2\u8D85\u8FC7\u5141\u8BB8\u7684\u5C1D\u8BD5\u6B21\u6570\u3002\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "error_7": "\u7531\u4E8E\u5730\u5740\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u4F60\u7684\u8D2D\u4E70\u3002\u8BF7\u66F4\u65B0\u652F\u4ED8\u4FE1\u606F\u6216\u9009\u62E9\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002",
          "currency_not_supported": "\u7531\u4E8E\u6B64\u5361\u4E0D\u652F\u6301\u6B64\u7B14\u4ED8\u6B3E\u7684\u5E01\u79CD\uFF0C\u56E0\u6B64\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C06\u8D27\u5E01\u6362\u6210\u7F8E\u5143\u518D\u8BD5\u4E00\u6B21\uFF0C\u6216\u8005\u6362\u4E00\u5F20\u5361\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_cvc": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_request": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "merchant_blacklist": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "do_not_try_again": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "incorrect_zip": "\u5730\u5740\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8BF7\u786E\u4FDD\u60A8\u4E3A\u5361\u8F93\u5165\u7684\u5730\u5740\u4E0E\u60A8\u7684\u94F6\u884C\u5B58\u6863\u7684\u5730\u5740\u5339\u914D\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "issuer_not_available": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "withdrawal_count_limit_exceeded": "\u7531\u4E8E\u8D44\u91D1\u95EE\u9898\uFF0C\u4F8B\u5982\u94F6\u884C\u8D26\u6237\u8D44\u91D1\u4E0D\u8DB3\u6216\u8D85\u8FC7\u4FE1\u7528\u5361\u9650\u989D\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "insufficient_funds": "\u7531\u4E8E\u8D44\u91D1\u95EE\u9898\uFF0C\u4F8B\u5982\u94F6\u884C\u8D26\u6237\u8D44\u91D1\u4E0D\u8DB3\u6216\u8D85\u8FC7\u4FE1\u7528\u5361\u9650\u989D\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "generic_decline": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "offline_pin_required": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "not_permitted": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "expired_card": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "online_or_offline_pin_required": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "pickup_card": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "incorrect_pin": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "call_issuer": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "card_velocity_exceeded": "\u7531\u4E8E\u8D44\u91D1\u95EE\u9898\uFF0C\u4F8B\u5982\u94F6\u884C\u8D26\u6237\u8D44\u91D1\u4E0D\u8DB3\u6216\u8D85\u8FC7\u4FE1\u7528\u5361\u9650\u989D\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "card_not_supported": "\u8FD9\u5F20\u5361\u4E0D\u5141\u8BB8\u6B64\u7C7B\u4EA4\u6613\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "lost_card": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "incorrect_number": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_amount": "\u7531\u4E8E\u91D1\u989D\u6216\u8D27\u5E01\u95EE\u9898\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "incorrect_cvc": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "do_not_honor": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "approve_with_id": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "new_account_information_available": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "no_action_taken": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_account": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "enter_valid_upi_id": "请输入有效的 UPI ID。",
          "vpa": "UPI 标识"
        },
        "stripe": {
          "approve_with_id": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "authentication_required": "\u4FE1\u7528\u5361\u53F7\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u4F60\u7684\u8D2D\u4E70\u8BF7\u6C42\u3002\u8BF7\u66F4\u65B0\u4FE1\u7528\u5361\u4FE1\u606F\u6216\u5C1D\u8BD5\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u3002\u5982\u679C\u95EE\u9898\u4ECD\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u3002",
          "call_issuer": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "card_not_supported": "\u8FD9\u5F20\u5361\u4E0D\u5141\u8BB8\u6B64\u7C7B\u4EA4\u6613\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "card_not_supported_invoice": "\u8BE5\u4FE1\u7528\u5361\u4E0D\u652F\u6301\u6B64\u4EA4\u6613\u7C7B\u578B\uFF0C\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5BFC\u822A\u81F3<a href=\"/billing/payment\">\u8D26\u5355\u4FE1\u606F</a>\u5E76\u66F4\u65B0\u60A8\u7684\u652F\u4ED8\u4FE1\u606F\u3002",
          "card_velocity_exceeded": "\u7531\u4E8E\u8D44\u91D1\u95EE\u9898\uFF0C\u4F8B\u5982\u94F6\u884C\u8D26\u6237\u8D44\u91D1\u4E0D\u8DB3\u6216\u8D85\u8FC7\u4FE1\u7528\u5361\u9650\u989D\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "card_velocity_exceeded_invoice": "\u7531\u4E8E\u8D26\u6237\u8D44\u91D1\u4E0D\u8DB3\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5BFC\u822A\u81F3<a href=\"/billing/payment\">\u8D26\u5355\u4FE1\u606F</a>\u5E76\u66F4\u65B0\u60A8\u7684\u652F\u4ED8\u4FE1\u606F\u3002",
          "currency_not_supported": "\u7531\u4E8E\u6B64\u5361\u4E0D\u652F\u6301\u6B64\u7B14\u4ED8\u6B3E\u7684\u5E01\u79CD\uFF0C\u56E0\u6B64\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C06\u8D27\u5E01\u6362\u6210\u7F8E\u5143\u518D\u8BD5\u4E00\u6B21\uFF0C\u6216\u8005\u6362\u4E00\u5F20\u5361\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "currency_not_supported_invoice": "\u7531\u4E8E\u8BE5\u5361\u4E0D\u652F\u6301\u6B64\u8D27\u5E01\u7C7B\u578B\uFF0C\u6B64\u4EA4\u6613\u5DF2\u88AB\u62D2\u7EDD\u3002\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5BFC\u822A\u81F3<a href=\"/billing/payment\">\u8D26\u5355\u4FE1\u606F</a>\u5E76\u66F4\u65B0\u60A8\u7684\u652F\u4ED8\u4FE1\u606F\u3002",
          "do_not_honor": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "do_not_try_again": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "expired_card": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "expired_card_invoice": "\u4FE1\u7528\u5361\u53F7\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8D2D\u4E70\u8BF7\u6C42\u3002\u8BF7\u5BFC\u822A\u81F3<a href=\"/billing/payment\">\u8D26\u5355\u4FE1\u606F</a>\u5E76\u66F4\u65B0\u60A8\u7684\u652F\u4ED8\u4FE1\u606F\u3002\u5982\u679C\u95EE\u9898\u4ECD\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u3002",
          "fraudulent": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "generic_decline": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "generic_error": "\u9519\u8BEF\uFF01\u7CFB\u7EDF\u76EE\u524D\u65E0\u6CD5\u5904\u7406\u4F60\u7684\u8BF7\u6C42\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u6216\u4F7F\u7528\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u3002\u5982\u679C\u95EE\u9898\u4ECD\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5C1D\u8BD5\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u3002\u5982\u679C\u95EE\u9898\u4ECD\u672A\u89E3\u51B3\uFF0C\u8BF7<a href=\"https://support.zoom.us/hc/en-us/requests/new?ticket_form_id=360000983032\" target=\"_blank\">\u63D0\u4EA4\u8BF7\u6C42</a>\u5411Zoom\u5BFB\u6C42\u5E2E\u52A9\u3002",
          "incorrect_cvc": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "incorrect_number": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "incorrect_pin": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "incorrect_zip": "\u5730\u5740\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8BF7\u786E\u4FDD\u60A8\u4E3A\u5361\u8F93\u5165\u7684\u5730\u5740\u4E0E\u60A8\u7684\u94F6\u884C\u5B58\u6863\u7684\u5730\u5740\u5339\u914D\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "incorrect_zip_invoice": "\u5730\u5740\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8D2D\u4E70\u8BF7\u6C42\u3002\u8BF7\u5BFC\u822A\u81F3<a href=\"/billing/payment\">\u8D26\u5355\u4FE1\u606F</a>\u5E76\u66F4\u65B0\u60A8\u7684\u652F\u4ED8\u4FE1\u606F\u3002",
          "insufficient_funds": "\u7531\u4E8E\u8D44\u91D1\u95EE\u9898\uFF0C\u4F8B\u5982\u94F6\u884C\u8D26\u6237\u8D44\u91D1\u4E0D\u8DB3\u6216\u8D85\u8FC7\u4FE1\u7528\u5361\u9650\u989D\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "insufficient_funds_invoice": "\u7531\u4E8E\u8D26\u6237\u8D44\u91D1\u4E0D\u8DB3\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5BFC\u822A\u81F3<a href=\"/billing/payment\">\u8D26\u5355\u4FE1\u606F</a>\u5E76\u66F4\u65B0\u60A8\u7684\u652F\u4ED8\u4FE1\u606F\u3002",
          "invalid_account": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_amount": "\u7531\u4E8E\u91D1\u989D\u6216\u8D27\u5E01\u95EE\u9898\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_cvc": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_expiry_month": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_expiry_year": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_number": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_pin": "\u94F6\u884C\u5361\u8BE6\u7EC6\u4FE1\u606F\u65E0\u6548\uFF0C\u65E0\u6CD5\u5904\u7406\u60A8\u7684\u8BA2\u5355\u3002 \u8FD9\u53EF\u80FD\u5305\u62EC\u4E0D\u6B63\u786E\u7684\u5361\u53F7\u3001\u5230\u671F\u65E5\u671F\u6216\u5B89\u5168\u7801\u3002 \u8BF7\u786E\u4FDD\u8F93\u5165\u7684\u5361\u8BE6\u7EC6\u4FE1\u606F\u4E0E\u5361\u4E0A\u663E\u793A\u7684\u5B8C\u5168\u4E00\u81F4\uFF0C\u7136\u540E\u91CD\u8BD5\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "issuer_not_available": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "lost_card": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "lost_card_invoice": "\u4FE1\u7528\u5361\u5B58\u5728\u95EE\u9898\uFF0C\u6211\u4EEC\u65E0\u6CD5\u5904\u7406\u6B64\u8BF7\u6C42\u3002\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5BFC\u822A\u81F3<a href=\"/billing/payment\">\u8D26\u5355\u4FE1\u606F</a>\u5E76\u66F4\u65B0\u60A8\u7684\u652F\u4ED8\u4FE1\u606F\u3002",
          "merchant_blacklist": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "new_account_information_available": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "no_action_taken": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "not_permitted": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "offline_pin_required": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "online_or_offline_pin_required": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "pickup_card": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "pickup_card_invoice": "\u4FE1\u7528\u5361\u5B58\u5728\u95EE\u9898\uFF0C\u6211\u4EEC\u65E0\u6CD5\u5904\u7406\u6B64\u8BF7\u6C42\u3002\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5BFC\u822A\u81F3<a href=\"/billing/payment\">\u8D26\u5355\u4FE1\u606F</a>\u5E76\u66F4\u65B0\u60A8\u7684\u652F\u4ED8\u4FE1\u606F\u3002",
          "pin_try_exceeded": "\u4F60\u591A\u6B21\u4F7F\u7528\u65E0\u6548\u53F7\u7801\u5904\u7406\u6B64\u5361\u7684\u4ED8\u6B3E\u8BF7\u6C42\uFF0C\u73B0\u5DF2\u8D85\u8FC7\u5141\u8BB8\u7684\u5C1D\u8BD5\u6B21\u6570\u3002\u8BF7\u5C1D\u8BD5\u5176\u4ED6\u652F\u4ED8\u65B9\u5F0F\u3002",
          "processing_error": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "reenter_transaction": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "restricted_card": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "revocation_of_all_authorizations": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "revocation_of_authorization": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "security_violation": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "service_not_allowed": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "stolen_card": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "stolen_card_invoice": "\u4FE1\u7528\u5361\u5B58\u5728\u95EE\u9898\uFF0C\u6211\u4EEC\u65E0\u6CD5\u5904\u7406\u6B64\u8BF7\u6C42\u3002\u8BF7\u8054\u7CFB\u76F8\u5173\u94F6\u884C\u6216\u5BFC\u822A\u81F3<a href=\"/billing/payment\">\u8D26\u5355\u4FE1\u606F</a>\u5E76\u66F4\u65B0\u60A8\u7684\u652F\u4ED8\u4FE1\u606F\u3002",
          "stop_payment_order": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "testmode_decline": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "transaction_not_allowed": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "transaction_not_allowed_inr": "\u4F60\u7684\u5361\u4E0D\u652F\u6301\u7ECF\u5E38\u6027\u4EA4\u6613\uFF0C\u5F88\u53EF\u80FD\u662F\u56E0\u4E3A\u5B83\u662F\u501F\u8BB0\u5361\u3002\u8BF7\u4F7F\u7528\u4FE1\u7528\u5361\u5B8C\u6210\u8D2D\u4E70\u3002",
          "try_again_later": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "withdrawal_count_limit_exceeded": "\u7531\u4E8E\u8D44\u91D1\u95EE\u9898\uFF0C\u4F8B\u5982\u94F6\u884C\u8D26\u6237\u8D44\u91D1\u4E0D\u8DB3\u6216\u8D85\u8FC7\u4FE1\u7528\u5361\u9650\u989D\uFF0C\u4ED8\u6B3E\u88AB\u62D2\u7EDD\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "card_decline_rate_limit_exceeded": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002",
          "invalid_request": "\u94F6\u884C\u5361\u5B58\u5728\u672A\u77E5\u95EE\u9898\uFF0C\u65E0\u6CD5\u5904\u7406\u6B64\u7B14\u4ED8\u6B3E\u3002 \u8BF7\u5C1D\u8BD5\u4F7F\u7528\u5176\u4ED6\u94F6\u884C\u5361\u6216\u5176\u4ED6\u4ED8\u6B3E\u65B9\u5F0F\u3002 \u5982\u679C\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u8054\u7CFB\u5F00\u6237\u884C\u3002"
        }
      }
    },
    "country_option": {
      "us": "The United States",
      "other_regions": "Other Countries/Regions"
    },
    "essential_app": {
      "title": "\u57FA\u672C\u5E94\u7528",
      "see_more_details": "\u67E5\u770B\u66F4\u591A\u8BE6\u7EC6\u4FE1\u606F",
      "legal_copy": "\u6B64\u4F18\u60E0\u4EC5\u9002\u7528\u4E8E\u81EA 2023 \u5E74 1 \u6708 4 \u65E5\u8D77\u53CA\u4EE5\u540E\u901A\u8FC7 Zoom \u5728\u7EBF\u9891\u9053 zoom.us/buy \u8D2D\u4E70 Zoom One \u4E13\u4E1A\u7248\u3001\u5546\u4E1A\u7248\u6216\u5546\u4E1A\u52A0\u5F3A\u7248\u8BA2\u9605\u800C\u62E5\u6709\u5F53\u524D\u8BB8\u53EF\u8BC1\u7684\u7528\u6237\u3002 \u5176\u8BA2\u9605\u4E0E\u533B\u7597\u4FDD\u5065\u3001\u6559\u80B2\u6216\u653F\u5E9C\u8D26\u6237\u5173\u8054\u7684\u7528\u6237\u4E0D\u80FD\u4EAB\u53D7\u6B64\u4F18\u60E0\u3002  \u9664 Coda \u5916\uFF0C\u6BCF\u4E2A\u5E94\u7528\u7684\u8BBF\u95EE\u6709\u6548\u671F\u4E3A\u81EA\u4E2A\u4EBA\u7528\u6237\u6FC0\u6D3B\u8BE5\u5E94\u7528\u8D77\u7684 1 \u5E74\u65F6\u95F4\u3002 \u540C\u4E00 Zoom \u8D26\u6237\u4E2D\u6240\u6709\u7528\u6237\u7684 Coda \u8BBF\u95EE\u6709\u6548\u671F\u4E3A\u81EA\u540C\u4E00 Zoom \u8D26\u6237\u4E2D\u4EFB\u4F55\u7528\u6237\u9996\u6B21\u6FC0\u6D3B Coda \u8D77\u7684 1 \u5E74\u65F6\u95F4\uFF0C\u800C\u4E0E\u540C\u4E00 Zoom \u8D26\u6237\u4E2D\u540E\u7EED\u7528\u6237\u7684\u521D\u59CB\u6FC0\u6D3B\u65E5\u671F\u65E0\u5173\u3002\u5BF9\u4E8E\u6240\u6709\u5E94\u7528\uFF0C\u5982\u679C\u91CD\u65B0\u5206\u914D\u6216\u53D6\u6D88\u7528\u6237\u7684\u5408\u683C\u8BB8\u53EF\u8BC1\u6216\u8BA2\u9605\uFF0C\u5219\u5C06\u7EC8\u6B62\u8BE5\u7528\u6237\u7684\u8BBF\u95EE\u6743\u9650\uFF0C\u65E0\u8BBA 1 \u5E74\u8BBF\u95EE\u671F\u9650\u662F\u5426\u8FD8\u6709\u5269\u4F59\u65F6\u95F4\u3002\u6BCF\u4E2A\u5E94\u7528\u90FD\u9700\u8981\u9075\u5B88\u6FC0\u6D3B\u540E\u6240\u9002\u7528\u7684\u4F7F\u7528\u6761\u6B3E\u548C\u9690\u79C1\u653F\u7B56\u3002\u968F\u9644\u7684\u5E94\u7528\u4EC5\u652F\u6301\u82F1\u6587\u3002\u5E76\u975E\u6240\u6709\u5E94\u7528\u90FD\u80FD\u5728\u79FB\u52A8\u8BBE\u5907\u4E0A\u8FD0\u884C\u3002\u4F18\u60E0\u4E0D\u53EF\u5151\u6362\u4E5F\u4E0D\u53EF\u9000\u8FD8\u73B0\u91D1\u3002\u4F18\u60E0\u4EC5\u9002\u7528\u4E8E <a href=\"https://marketplace.zoom.us/apps?curatedCategory=essential-apps\" target=\"_blank\">Zoom App Marketplace</a> \u4E2D\u88AB\u5217\u4E3A\u57FA\u672C\u5E94\u7528\u7684\u8FD9\u4E9B\u5E94\u7528\u3002 \u5DF2\u8BA2\u9605\u4EFB\u4F55\u5E94\u7528\u7684\u7528\u6237\u4E0D\u80FD\u4EAB\u53D7\u4E0E\u90A3\u4E9B\u7279\u5B9A\u5E94\u7528\u6709\u5173\u7684\u8FD9\u9879\u4F18\u60E0\u3002Zoom \u4FDD\u7559\u968F\u65F6\u4FEE\u6539\u6216\u53D6\u6D88\u6B64\u4F18\u60E0\u7684\u6743\u5229\uFF0C\u65E0\u9700\u4E8B\u5148\u901A\u77E5\u548C\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002"
    }
  }
}
export default i18n
